! function(t) {
    var e = {};

    function n(i) {
        if (e[i]) return e[i].exports;
        var r = e[i] = {
            i: i,
            l: !1,
            exports: {}
        };
        return t[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports
    }
    n.m = t, n.c = e, n.d = function(t, e, i) {
        n.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: i
        })
    }, n.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        })
    }, n.t = function(t, e) {
        if (1 & e && (t = n(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var i = Object.create(null);
        if (n.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t)
            for (var r in t) n.d(i, r, function(e) {
                return t[e]
            }.bind(null, r));
        return i
    }, n.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default
        } : function() {
            return t
        };
        return n.d(e, "a", e), e
    }, n.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, n.p = "", n(n.s = 169)
}([function(t, e, n) {
    "use strict";
    e.a = {
        events: {
            LOAD_FORM_CONTROLLER: "loadFormController",
            REQUEST_CARD_NONCE_IF_VALID_FORM: "requestCardNonceIfValidForm",
            BUILD_STYLES_FOR_SCREEN_WIDTH: "buildStylesForScreenWidth",
            SET_POSTAL_CODE: "setPostalCode",
            BLUR_ALL_INPUTS: "blurAllInputs",
            LOAD_WALLET: "loadWallet",
            SET_ANALYTICS_TOKEN: "setAnalyticsToken",
            CARD_NONCE_RESPONSE_RECEIVED: "cardNonceResponseReceived",
            INPUT_EVENT_RECEIVED: "inputEventReceived",
            SET_INPUT_HEIGHT: "setInputHeight",
            PAYMENT_FORM_LOADED: "paymentFormLoaded",
            REQUEST_APPLE_PAY_CARD_NONCE: "requestApplePayCardNonce",
            RECEIVE_APPLE_PAY_CARD_NONCE: "receiveApplePayCardNonce",
            REQUEST_APPLE_PAY_MERCHANT_VALIDITY: "requestApplePayMerchantValidity",
            RECEIVE_APPLE_PAY_VALID_MERCHANT: "receiveApplePayValidMerchant",
            REQUEST_GOOGLE_PAY_CARD_NONCE: "requestGooglePayCardNonce",
            RECEIVE_GOOGLE_PAY_CARD_NONCE: "receiveGooglePayCardNonce",
            REQUEST_GOOGLE_PAY_TOKEN: "requestGooglePayToken",
            RECEIVE_GOOGLE_PAY_TOKEN: "receiveGooglePayToken",
            RECEIVE_MASTERPASS_TRANSACTION: "receiveMasterpassTransaction",
            SET_MASTERPASS_CHECKOUT_ID: "setMasterpassCheckoutId",
            REQUEST_MASTERPASS_CARD_NONCE: "requestMasterpassCardNonce"
        },
        inputEvents: {
            SUBMIT: "submit",
            EMPTY_STATE_CHANGED: "emptyStateChanged",
            FOCUS_CLASS_ADDED: "focusClassAdded",
            FOCUS_CLASS_REMOVED: "focusClassRemoved",
            ERROR_CLASS_ADDED: "errorClassAdded",
            ERROR_CLASS_REMOVED: "errorClassRemoved",
            CARD_BRAND_CHANGED: "cardBrandChanged",
            POSTAL_CODE_CHANGED: "postalCodeChanged"
        },
        inputTypes: {
            GIFT_CARD: "giftCard",
            CARD_NUMBER: "cardNumber",
            CVV: "cvv",
            EXPIRATION_DATE: "expirationDate",
            POSTAL_CODE: "postalCode",
            SINGLE_CARD_ELEMENT: "card"
        },
        paymentMethods: {
            GIFT_CARD: "giftCard",
            KEYED_CARD: "keyedCard",
            APPLE_PAY: "applePay",
            GOOGLE_PAY: "googlePay",
            INSTALLMENTS: "installments",
            MASTERPASS: "masterpass",
            SINGLE_CARD_ELEMENT: "card"
        },
        GOOGLE_PAY_JS: "https://pay.google.com/gp/p/js/pay.js"
    }
}, function(t, e, n) {
    "use strict";

    function i(t) {
        return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function r(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function o(t, e) {
        return !e || "object" !== i(e) && "function" != typeof e ? function() {
            if (void 0 !== t) return t;
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
        }() : e
    }

    function a(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: t,
                writable: !0,
                configurable: !0
            }
        }), e && c(t, e)
    }

    function s(t) {
        var e = "function" == typeof Map ? new Map : void 0;
        return (s = function(t) {
            if (null === t || (n = t, -1 === Function.toString.call(n).indexOf("[native code]"))) return t;
            var n;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
                if (e.has(t)) return e.get(t);
                e.set(t, i)
            }

            function i() {
                return function(t, e, n) {
                    return (function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0
                        } catch (t) {
                            return !1
                        }
                    }() ? Reflect.construct : function(t, e, n) {
                        var i = [null];
                        i.push.apply(i, e);
                        var r = new(Function.bind.apply(t, i));
                        return n && c(r, n.prototype), r
                    }).apply(null, arguments)
                }(t, arguments, l(this).constructor)
            }
            return i.prototype = Object.create(t.prototype, {
                constructor: {
                    value: i,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), c(i, t)
        })(t)
    }

    function c(t, e) {
        return (c = Object.setPrototypeOf || function(t, e) {
            return t.__proto__ = e, t
        })(t, e)
    }

    function l(t) {
        return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        })(t)
    }

    function u(t) {
        return "https://docs.connect.squareup.com/payments/sqpaymentform/sqpaymentform-overview" + (t || "")
    }

    function p(t) {
        return "https://docs.connect.squareup.com/api/paymentform" + (t || "")
    }
    n.d(e, "m", function() {
        return d
    }), n.d(e, "a", function() {
        return h
    }), n.d(e, "b", function() {
        return f
    }), n.d(e, "e", function() {
        return y
    }), n.d(e, "c", function() {
        return _
    }), n.d(e, "o", function() {
        return b
    }), n.d(e, "l", function() {
        return I
    }), n.d(e, "h", function() {
        return A
    }), n.d(e, "j", function() {
        return O
    }), n.d(e, "f", function() {
        return F
    }), n.d(e, "g", function() {
        return q
    }), n.d(e, "d", function() {
        return V
    }), n.d(e, "k", function() {
        return j
    }), n.d(e, "i", function() {
        return U
    }), n.d(e, "n", function() {
        return B
    }), n.d(e, "r", function() {
        return H
    }), n.d(e, "q", function() {
        return W
    }), n(22), n(23), n(20), n(17), n(101), n(126), n(129), n(46), n(13), n(76), n(26), n(10);
    var d = function() {
            function t(e) {
                var n;
                return r(this, t), (n = o(this, l(t).call(this, e || "Unknown SqError"))).name = "SqError", n
            }
            return a(t, s(Error)), t
        }(),
        h = function() {
            function t(e) {
                var n;
                return r(this, t), (n = o(this, l(t).call(this, "SqPaymentForm element with id '".concat(e, "' not found. Has the DOM finished loading?\nSee: ").concat("https://docs.connect.squareup.com/payments/sqpaymentform/sqpaymentform-setup#step-3-add-the-html-form-to-your-payment-page")))).name = "ElementNotFoundError", n
            }
            return a(t, d), t
        }(),
        f = function() {
            function t(e) {
                var n;
                return r(this, t), (n = o(this, l(t).call(this, "SqPaymentForm element with id '".concat(e, "' is not visible. Does it or a parent element have 'display:none'?")))).name = "ElementNotVisibleError", n
            }
            return a(t, d), t
        }(),
        y = function() {
            function t(e) {
                var n;
                return r(this, t), (n = o(this, l(t).call(this, "SqPaymentForm field '".concat(e, "' is invalid.")))).name = "InvalidFieldError", n
            }
            return a(t, d), t
        }(),
        m = function() {
            function t() {
                var e;
                r(this, t);
                var n = u("#requirements-and-limitations");
                return (e = o(this, l(t).call(this, "SqPaymentForm can only be embedded on sites that use HTTPS.\nSee: ".concat(n)))).name = "HttpsRequiredError", e
            }
            return a(t, d), t
        }(),
        v = function() {
            function t(e) {
                var n;
                return r(this, t), (n = o(this, l(t).call(this, "Cannot call SqPaymentForm#".concat(e, " after SqPaymentForm#destroy. Create a new SqPaymentForm instance instead.")))).name = "FormAlreadyDestroyedError", n
            }
            return a(t, d), t
        }(),
        g = function() {
            function t(e) {
                var n;
                return r(this, t), (n = o(this, l(t).call(this, "Cannot call SqPaymentForm#".concat(e, " before the paymentFormLoaded() callback. See Step 4: ").concat("https://developer.squareup.com/docs/payment-form/how-it-works#the-sqpaymentform-process-flow")))).name = "FormNotReadyError", n
            }
            return a(t, d), t
        }(),
        E = function() {
            function t() {
                var e;
                r(this, t);
                var n = p("#build");
                return (e = o(this, l(t).call(this, "SqPaymentForm#build called more than once. Did you mean to call SqPaymentForm#destroy first?\nSee: ".concat(n)))).name = "FormAlreadyBuiltError", e
            }
            return a(t, d), t
        }(),
        _ = function() {
            function t(e) {
                var n;
                r(this, t);
                var i = p("#destroy");
                return (n = o(this, l(t).call(this, "Iframe '".concat(e, "' no longer exists. Was SqPaymentForm#destroy called?.\nSee: ").concat(i)))).name = "IframeDoesNotExistError", n
            }
            return a(t, d), t
        }(),
        b = function() {
            function t() {
                var e;
                r(this, t);
                var n = p("#shippingcontactchanged");
                return (e = o(this, l(t).call(this, "validateShippingContact() has been deprecated. Please use shippingContactChanged().\nSee: ".concat(n)))).name = "ValidateShippingContactDeprecatedError", e
            }
            return a(t, d), t
        }(),
        S = function() {
            function t() {
                var e;
                return r(this, t), (e = o(this, l(t).call(this, "Only one of 'locationId' or 'accountId' can be specified."))).name = "TooManyIdsError", e
            }
            return a(t, d), t
        }(),
        I = function() {
            function t() {
                var e;
                return r(this, t), (e = o(this, l(t).call(this, "A request is already in progress."))).name = "RequestInProgressError", e
            }
            return a(t, d), t
        }(),
        C = function() {
            function t(e, n) {
                var i;
                r(this, t);
                var a = p("#configurationfields");
                return (i = o(this, l(t).call(this, "The SqPaymentForm '".concat(e, "' argument must be of type '").concat(n, "'.\nSee: ").concat(a)))).name = "InvalidArgumentError", i
            }
            return a(t, d), t
        }(),
        w = function() {
            function t(e) {
                var n;
                r(this, t);
                var i = p("#configurationfields");
                return (n = o(this, l(t).call(this, "The SqPaymentForm '".concat(e, "' argument is required.\nSee: ").concat(i)))).name = "MissingArgumentError", n
            }
            return a(t, d), t
        }(),
        P = function() {
            function t(e) {
                var n;
                r(this, t);
                var i = p("#_paymentform_functions");
                return (n = o(this, l(t).call(this, "The SqPaymentForm '".concat(e, "' function was called with missing or invalid parameters.\nSee: ").concat(i)))).name = "InvalidFunctionArgumentError", n
            }
            return a(t, d), t
        }(),
        A = function() {
            function t(e) {
                var n;
                r(this, t);
                var i = p("#configurationfields");
                return (n = o(this, l(t).call(this, "The SqPaymentForm '".concat(e, "' option value is invalid.\nSee: ").concat(i)))).name = "InvalidOptionError", n
            }
            return a(t, d), t
        }(),
        T = function() {
            function t(e) {
                var n;
                r(this, t);
                var i = p("#configurationfields");
                return (n = o(this, l(t).call(this, "The SqPaymentForm '".concat(e, "' option type is invalid.\nSee: ").concat(i)))).name = "InvalidOptionType", n
            }
            return a(t, d), t
        }(),
        O = function() {
            function t(e) {
                var n;
                r(this, t);
                var i = p("#configurationfields");
                return (n = o(this, l(t).call(this, "The SqPaymentForm '".concat(e, "' option is required.\nSee: ").concat(i)))).name = "MissingOptionError", n
            }
            return a(t, d), t
        }(),
        N = function() {
            function t(e) {
                var n;
                r(this, t);
                var i = p("#configurationfields");
                return (n = o(this, l(t).call(this, "The SqPaymentForm 'elementId' option is required for '".concat(e, "'.\nSee: ").concat(i)))).name = "MissingElementIdError", n
            }
            return a(t, d), t
        }(),
        L = function() {
            function t(e) {
                var n;
                r(this, t);
                var i = p("#configurationfields");
                return (n = o(this, l(t).call(this, "The SqPaymentForm '".concat(e, "' option is required.\nSee: ").concat(i)))).name = "MissingInputTypeError", n
            }
            return a(t, d), t
        }(),
        R = function() {
            function t(e) {
                var n;
                r(this, t);
                var i = p("#configurationfields");
                return (n = o(this, l(t).call(this, "The SqPaymentForm '".concat(e, "' option is not expected in this configuration.\nSee: ").concat(i)))).name = "UnexpectedInputTypeError", n
            }
            return a(t, d), t
        }(),
        k = function() {
            function t(e) {
                var n;
                r(this, t);
                var i = p("#_callbackfunctions_detail");
                return (n = o(this, l(t).call(this, "The SqPaymentForm '".concat(e, "' callback is required.\nSee: ").concat(i)))).name = "MissingCallbackError", n
            }
            return a(t, d), t
        }(),
        M = function() {
            function t(e) {
                var n;
                r(this, t);
                var i = p("#_callbackfunctions_detail");
                return (n = o(this, l(t).call(this, "The SqPaymentForm '".concat(e, "' callback must be a function.\nSee: ").concat(i)))).name = "InvalidCallbackError", n
            }
            return a(t, d), t
        }(),
        D = function() {
            function t() {
                var e;
                r(this, t);
                var n = p("#configurationfields");
                return (e = o(this, l(t).call(this, "The SqPaymentForm requires at least one payment method.\nSee: ".concat(n)))).name = "MissingPaymentMethodError", e
            }
            return a(t, d), t
        }(),
        x = function() {
            function t() {
                var e;
                r(this, t);
                var n = p("#configurationfields");
                return (e = o(this, l(t).call(this, "The SqPaymentForm 'inputStyles' option must be an array.\nSee: ".concat(n)))).name = "InvalidInputStylesError", e
            }
            return a(t, d), t
        }(),
        F = function() {
            function t(e) {
                var n;
                r(this, t);
                var i = p("#datatype-inputstyleobjects");
                return (n = o(this, l(t).call(this, "Invalid InputStyle property: '".concat(e, "'.\nSee: ").concat(i)))).name = "InvalidInputStylePropertyError", n
            }
            return a(t, d), t
        }(),
        q = function() {
            function t(e, n) {
                var i;
                r(this, t);
                var a = p("#datatype-inputstyleobjects");
                return (i = o(this, l(t).call(this, "Invalid InputStyle value '".concat(e, "' for property '").concat(n, "'.\nSee: ").concat(a)))).name = "InvalidInputStyleValueError", i
            }
            return a(t, d), t
        }(),
        V = function() {
            function t() {
                var e;
                return r(this, t), (e = o(this, l(t).call(this, "Input height zero detected; using fallback value."))).name = "InputHeightZeroError", e
            }
            return a(t, d), t
        }(),
        G = function() {
            function t() {
                var e;
                r(this, t);
                var n = u("#prerequisites");
                return (e = o(this, l(t).call(this, "Browser not supported.\nSee: ".concat(n)))).name = "UnsupportedBrowserError", e
            }
            return a(t, d), t
        }(),
        j = function() {
            function t() {
                var e;
                return r(this, t), (e = o(this, l(t).call(this, "The label field in the 'PaymentRequest.total' object must be set " + "with the merchant name to use Apple Pay with an Account ID.\nSee: ".concat("https://docs.connect.squareup.com/payments/sqpaymentform/digitalwallet/applepay-setup#payment-request-object-example")))).name = "MissingTotalLabelError", e
            }
            return a(t, d), t
        }(),
        U = function() {
            function t(e) {
                var n;
                return r(this, t), (n = o(this, l(t).call(this, e))).name = "InvalidOriginError", n
            }
            return a(t, d), t
        }(),
        B = function() {
            function t(e) {
                var n;
                return r(this, t), (n = o(this, l(t).call(this, e))).name = "UnexpectedError", n
            }
            return a(t, d), t
        }();

    function H(t) {
        return {
            fileName: t.fileName,
            name: t.name,
            message: t.message,
            stack: t.stack
        }
    }

    function W(t) {
        var e = new(z[t.name] || d);
        return t.message && (e.message = t.message), e.fileName = t.fileName, e.stack = t.stack, e
    }
    var z = {
            SqError: d,
            ElementNotFoundError: h,
            ElementNotVisibleError: f,
            InvalidFieldError: y,
            HttpsRequiredError: m,
            FormAlreadyDestroyedError: v,
            FormNotReadyError: g,
            FormAlreadyBuiltError: E,
            IframeDoesNotExistError: _,
            RequestInProgressError: I,
            TooManyIdsError: S,
            ValidateShippingContactDeprecatedError: b,
            InvalidArgumentError: C,
            MissingArgumentError: w,
            InvalidFunctionArgumentError: P,
            InvalidOptionError: A,
            InvalidOptionType: T,
            MissingOptionError: O,
            MissingElementIdError: N,
            MissingInputTypeError: L,
            UnexpectedInputTypeError: R,
            MissingCallbackError: k,
            InvalidCallbackError: M,
            MissingPaymentMethodError: D,
            InvalidInputStylesError: x,
            InvalidInputStylePropertyError: F,
            InvalidInputStyleValueError: q,
            InputHeightZeroError: V,
            UnsupportedBrowserError: G,
            MissingTotalLabelError: j,
            InvalidOriginError: U,
            UnexpectedError: B
        },
        Y = {
            serializeError: H,
            deserializeError: W
        };
    e.p = Object.assign({}, z, Y)
}, function(t, e, n) {
    "use strict";

    function i(t) {
        return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }
    n(22), n(23), n(86), n(20), n(17), n(27), n(10), n(124), n(47), n(46), n(13);
    var r = {},
        o = Object.prototype.hasOwnProperty;
    r.hasOwn = function(t, e) {
        return o.call(t, e)
    }, r.guid = function() {
        function t() {
            return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1)
        }
        return t() + t() + "-" + t() + "-" + t() + "-" + t() + "-" + t() + t() + t()
    }, r.truncate = function(t, e) {
        return t.length <= e ? t : t.substring(0, e - 1) + "â€¦"
    }, r.isValidWindow = function(t) {
        return !!t && "object" === i(t) && "function" == typeof t.postMessage
    }, r.isValidDocument = function(t) {
        return !!t && "object" === i(t) && !!t.body && "object" === i(t.body) && "function" == typeof t.body.appendChild
    }, r.typeOf = function(t) {
        if (null === t) return "null";
        if (t !== Object(t)) return i(t);
        var e = Object.prototype.toString.call(t).replace(/^\[(?:function|object) |\]$/g, "").toLowerCase();
        return -1 < e.indexOf("function") ? "function" : e
    }, r.constructorOf = function(t) {
        try {
            var e = t.constructor.toString().match(/[function|object] (\w*)/);
            if (e) return e[1]
        } catch (t) {}
        return ""
    }, r.isValidDataType = function(t, e, n, r) {
        return n instanceof r || i(n) === r.name.toLowerCase() || (window.console.error("".concat(t, " in ").concat(e, " must be of type ").concat(r.name, ".")), !1)
    }, r.logInvalidFieldsError = function(t, e) {
        var n = e.join(", ");
        window.console.error("Invalid ".concat(t, " field(s): ").concat(n))
    }, r.url = function(t, e) {
        var n = "?version=86785379ba";
        return e = e || {}, Object.keys(e).forEach(function(t) {
            r.hasOwn(e, t) && (n += "&" + encodeURIComponent(t) + "=" + encodeURIComponent(e[t]))
        }), encodeURI(t) + n
    };
    var a, s = {
        href: "",
        protocol: "",
        host: "",
        hostname: "",
        port: "",
        pathname: "",
        search: "",
        hash: "",
        username: "",
        password: "",
        origin: "",
        toString: function() {
            return ""
        }
    };
    r.parseUrl = function(t) {
        return t ? ((a = a || document.createElement("a")).href = "".concat(t), {
            hash: a.hash,
            host: a.host,
            hostname: a.hostname,
            href: a.href,
            origin: a.origin,
            password: a.password,
            pathname: a.pathname,
            port: a.port,
            protocol: a.protocol,
            search: a.search,
            username: a.username,
            toString: function() {
                return a.href
            }
        }) : s
    }, r.getParentLocation = function() {
        return window.location === window.parent.location ? window.location : r.parseUrl(document.referrer)
    }, r.embeddingAllowed = function(t) {
        return /localhost$/.test(t.hostname) || "https:" === t.protocol
    }, r.debounce = function(t, e) {
        var n;
        return function() {
            clearTimeout(n), n = setTimeout(t, e)
        }
    }, e.a = r
}, , function(t, e, n) {
    var i = n(52)("wks"),
        r = n(39),
        o = n(9).Symbol,
        a = "function" == typeof o;
    (t.exports = function(t) {
        return i[t] || (i[t] = a && o[t] || (a ? o : r)("Symbol." + t))
    }).store = i
}, function(t, e, n) {
    "use strict";
    n.d(e, "b", function() {
        return u
    }), n.d(e, "a", function() {
        return p
    }), n(47), n(19), n(20), n(17), n(13), n(27);
    var i = n(2),
        r = n(1),
        o = n(33),
        a = ["backgroundColor", "boxSizing", "boxShadow", "color", "fontFamily", "fontSize", "fontWeight", "lineHeight", "padding", "_webkitFontSmoothing", "_mozOsxFontSmoothing"],
        s = ["display"],
        c = ["borderRadius"],
        l = ["mediaMaxWidth", "mediaMinWidth"],
        u = {
            DEFAULT: "default",
            FORM_DETAILS: "formDetails",
            FORM_WRAPPER: "formWrapper"
        },
        p = "ignore",
        d = {
            buildStylesForScreenWidth: function(t, e) {
                var n = this,
                    r = {};
                return t.forEach(function(t) {
                    if (n.stylesApplyToScreenWidth(t, e))
                        for (var o in t) i.a.hasOwn(t, o) && (r[o] = t[o])
                }), this.styleStringForStyleObject(r)
            },
            styleStringForStyleObject: function(t, e) {
                var n = this,
                    i = 1 < arguments.length && void 0 !== e ? e : u.DEFAULT,
                    r = [];
                return Object.keys(t).forEach(function(e) {
                    l.includes(e) || t[e] !== p && r.push(n.styleStringForKeyValuePair(e, t[e], i))
                }), r.join(" ")
            },
            stylesApplyToScreenWidth: function(t, e) {
                var n = t.mediaMinWidth,
                    i = t.mediaMaxWidth;
                if (!n && !i) return !0;
                if (n) {
                    if (void 0 === o.a.sanitizeMediaFeatureValue("min-width", n)) throw new r.g(n, "mediaMinWidth");
                    if (!this.isAboveMinWidth(n, e)) return !1
                }
                if (i) {
                    if (void 0 === o.a.sanitizeMediaFeatureValue("max-width", i)) throw new r.g(i, "mediaMaxWidth");
                    if (!this.isBelowMaxWidth(i, e)) return !1
                }
                return !0
            },
            isAboveMinWidth: function(t, e) {
                return e >= parseInt(t, 10)
            },
            isBelowMaxWidth: function(t, e) {
                return e <= parseInt(t, 10)
            },
            styleStringForKeyValuePair: function(t, e, n) {
                var i = 2 < arguments.length && void 0 !== n ? n : u.DEFAULT,
                    l = a.includes(t);
                switch (i) {
                    case u.FORM_DETAILS:
                        l = l || s.includes(t);
                        break;
                    case u.FORM_WRAPPER:
                        l = l || c.includes(t)
                }
                if (!l) throw new r.f(t);
                var p = this.cssProperty(t),
                    d = o.a.sanitizeDeclarationValue(p, e);
                if (void 0 === d) throw new r.g(e, t);
                return this.formatKeyValuePair(p, d)
            },
            cssProperty: function(t) {
                return t.replace(/^_/g, "-").replace(/(?!^)([A-Z])/g, " $1").replace(/[_\s]+(?=[a-zA-Z])/g, "-").toLowerCase()
            },
            formatKeyValuePair: function(t, e) {
                return t + ": " + e + ";"
            }
        };
    e.c = d
}, function(t, e, n) {
    var i = n(14);
    t.exports = function(t) {
        if (!i(t)) throw TypeError(t + " is not an object!");
        return t
    }
}, function(t, e, n) {
    t.exports = !n(12)(function() {
        return 7 != Object.defineProperty({}, "a", {
            get: function() {
                return 7
            }
        }).a
    })
}, function(t, e, n) {
    "use strict";
    n.d(e, "a", function() {
        return u
    }), n.d(e, "b", function() {
        return p
    }), n(22), n(23), n(10), n(27), n(20), n(17), n(13), n(62), n(19), n(24), n(26), n(133);
    var i = n(2),
        r = n(38);

    function o(t) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function a(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function s(t, e) {
        for (var n = 0; n < e.length; n++) {
            var i = e[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
        }
    }

    function c(t, e, n) {
        return e && s(t.prototype, e), n && s(t, n), t
    }
    var l = i.a.url("https://pci-connect.squareup.com/v2/v"),
        u = Object.freeze({
            LOAD_EVENT: 0,
            NONCE_EVENT: 1,
            CONFIG_EVENT: 2,
            INSTALLMENTS_CONFIG_EVENT: 3,
            INSTALLMENTS_APPLICATION_RESULT_EVENT: 4,
            METHODS_SUPPORTED_EVENT: 5,
            INSTALLMENTS_SHOW_MODAL_EVENT: 6,
            GENERAL_EVENT: 7
        }),
        p = function() {
            function t(e) {
                a(this, t), this._options = Object.assign({}, e)
            }
            return c(t, [{
                key: "create",
                value: function(t, e) {
                    if (e = e || {}, !Object.values(u).includes(t)) throw new TypeError("Invalid event type: '".concat(t, "'"));
                    if ("object" !== o(e)) throw new TypeError("Invalid fields: '".concat(e, "'"));
                    var n = window.location.href,
                        r = i.a.getParentLocation().href,
                        a = Object.assign({}, e, {
                            e: t,
                            a: this._options.applicationId,
                            o: this._options.locationId,
                            n: this._options.sessionId,
                            q: this._options.accountId,
                            s: "SqPaymentForm",
                            u: n,
                            v: r,
                            w: this._options.apiWrapper
                        });
                    return new d(a)
                }
            }, {
                key: "send",
                value: function(t, e) {
                    if (!(t instanceof d)) throw TypeError("Expected 'SqEvent'");
                    r.a.post(l, {
                        json: t.toObject()
                    }, e)
                }
            }, {
                key: "track",
                value: function(t, e, n) {
                    var i = 2 < arguments.length && void 0 !== n ? n : function() {},
                        r = this.create(t, e);
                    this.send(r, i)
                }
            }, {
                key: "sessionId",
                set: function(t) {
                    this._options.sessionId || (this._options.sessionId = t)
                },
                get: function() {
                    return this._options.sessionId
                }
            }]), t
        }(),
        d = function() {
            function t(e) {
                var n = this;
                a(this, t), this._fields = {}, Object.keys(e).forEach(function(t) {
                    return n.set(t, e[t])
                })
            }
            return c(t, [{
                key: "set",
                value: function(t, e) {
                    if (void 0 !== this._fields[t]) throw new Error("Field '".concat(t, "' already set."));
                    this._fields[t] = e
                }
            }, {
                key: "get",
                value: function(t) {
                    return this._fields[t]
                }
            }, {
                key: "toObject",
                value: function() {
                    return Object.assign({}, this._fields)
                }
            }, {
                key: "type",
                get: function() {
                    return this._fields.e
                }
            }]), t
        }();
    e.c = p
}, function(t, e) {
    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n)
}, function(t, e, n) {
    var i = n(16).f,
        r = Function.prototype,
        o = /^\s*function ([^ (]*)/;
    "name" in r || n(7) && i(r, "name", {
        configurable: !0,
        get: function() {
            try {
                return ("" + this).match(o)[1]
            } catch (t) {
                return ""
            }
        }
    })
}, function(t, e, n) {
    "use strict";
    e.a = {
        messages: {
            cardNumber: {
                details: "Enter your card number",
                error: "Please enter a valid card number"
            },
            expirationDate: {
                details: "Enter the expiry date",
                error: "Please enter a valid expiry date"
            },
            cvv: {
                details: "Enter the CVV number",
                error: "Please enter a valid CVV number"
            },
            postalCode: {
                details: "Enter the ZIP code linked to this card",
                error: "Please enter a valid ZIP code"
            }
        },
        classNames: {
            base: "sq-card",
            input: "sq-input",
            error: "sq-error",
            focus: "sq-focus",
            flip: "sq-flip",
            hide: "sq-hide",
            transform: "sq-transform"
        },
        inputTypes: {
            CARD_NUMBER: "cardNumber",
            EXPIRATION_DATE: "expirationDate",
            CVV: "cvv",
            POSTAL_CODE: "postalCode"
        },
        defaultStyles: {
            placeholder: {
                color: "#C7C7CC"
            },
            autoFill: {
                color: "#0076D6"
            },
            error: {
                color: "#FF3E39",
                backgroundColor: "#FFEDED"
            }
        }
    }
}, function(t, e) {
    t.exports = function(t) {
        try {
            return !!t()
        } catch (t) {
            return !0
        }
    }
}, function(t, e, n) {
    "use strict";
    var i = n(68),
        r = {};
    r[n(4)("toStringTag")] = "z", r + "" != "[object z]" && n(18)(Object.prototype, "toString", function() {
        return "[object " + i(this) + "]"
    }, !0)
}, function(t, e) {
    t.exports = function(t) {
        return "object" == typeof t ? null !== t : "function" == typeof t
    }
}, function(t, e, n) {
    var i = n(9),
        r = n(34),
        o = n(29),
        a = n(18),
        s = n(40),
        c = "prototype",
        l = function(t, e, n) {
            var u, p, d, h, f = t & l.F,
                y = t & l.G,
                m = t & l.S,
                v = t & l.P,
                g = t & l.B,
                E = y ? i : m ? i[e] || (i[e] = {}) : (i[e] || {})[c],
                _ = y ? r : r[e] || (r[e] = {}),
                b = _[c] || (_[c] = {});
            for (u in y && (n = e), n) d = ((p = !f && E && void 0 !== E[u]) ? E : n)[u], h = g && p ? s(d, i) : v && "function" == typeof d ? s(Function.call, d) : d, E && a(E, u, d, t & l.U), _[u] != d && o(_, u, h), v && b[u] != d && (b[u] = d)
        };
    i.core = r, l.F = 1, l.G = 2, l.S = 4, l.P = 8, l.B = 16, l.W = 32, l.U = 64, l.R = 128, t.exports = l
}, function(t, e, n) {
    var i = n(6),
        r = n(79),
        o = n(53),
        a = Object.defineProperty;
    e.f = n(7) ? Object.defineProperty : function(t, e, n) {
        if (i(t), e = o(e, !0), i(n), r) try {
            return a(t, e, n)
        } catch (t) {}
        if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
        return "value" in n && (t[e] = n.value), t
    }
}, function(t, e, n) {
    "use strict";
    var i = n(75),
        r = n(87),
        o = n(44),
        a = n(32);
    t.exports = n(71)(Array, "Array", function(t, e) {
        this._t = a(t), this._i = 0, this._k = e
    }, function() {
        var t = this._t,
            e = this._k,
            n = this._i++;
        return !t || n >= t.length ? (this._t = void 0, r(1)) : r(0, "keys" == e ? n : "values" == e ? t[n] : [n, t[n]])
    }, "values"), o.Arguments = o.Array, i("keys"), i("values"), i("entries")
}, function(t, e, n) {
    var i = n(9),
        r = n(29),
        o = n(28),
        a = n(39)("src"),
        s = n(110),
        c = "toString",
        l = ("" + s).split(c);
    n(34).inspectSource = function(t) {
        return s.call(t)
    }, (t.exports = function(t, e, n, s) {
        var c = "function" == typeof n;
        c && (o(n, "name") || r(n, "name", e)), t[e] !== n && (c && (o(n, a) || r(n, a, t[e] ? "" + t[e] : l.join(String(e)))), t === i ? t[e] = n : s ? t[e] ? t[e] = n : r(t, e, n) : (delete t[e], r(t, e, n)))
    })(Function.prototype, c, function() {
        return "function" == typeof this && this[a] || s.call(this)
    })
}, function(t, e, n) {
    "use strict";
    var i = n(15),
        r = n(82)(!0);
    i(i.P, "Array", {
        includes: function(t, e) {
            return r(this, t, 1 < arguments.length ? e : void 0)
        }
    }), n(75)("includes")
}, function(t, e, n) {
    for (var i = n(17), r = n(31), o = n(18), a = n(9), s = n(29), c = n(44), l = n(4), u = l("iterator"), p = l("toStringTag"), d = c.Array, h = {
            CSSRuleList: !0,
            CSSStyleDeclaration: !1,
            CSSValueList: !1,
            ClientRectList: !1,
            DOMRectList: !1,
            DOMStringList: !1,
            DOMTokenList: !0,
            DataTransferItemList: !1,
            FileList: !1,
            HTMLAllCollection: !1,
            HTMLCollection: !1,
            HTMLFormElement: !1,
            HTMLSelectElement: !1,
            MediaList: !0,
            MimeTypeArray: !1,
            NamedNodeMap: !1,
            NodeList: !0,
            PaintRequestList: !1,
            Plugin: !1,
            PluginArray: !1,
            SVGLengthList: !1,
            SVGNumberList: !1,
            SVGPathSegList: !1,
            SVGPointList: !1,
            SVGStringList: !1,
            SVGTransformList: !1,
            SourceBufferList: !1,
            StyleSheetList: !0,
            TextTrackCueList: !1,
            TextTrackList: !1,
            TouchList: !1
        }, f = r(h), y = 0; y < f.length; y++) {
        var m, v = f[y],
            g = h[v],
            E = a[v],
            _ = E && E.prototype;
        if (_ && (_[u] || s(_, u, d), _[p] || s(_, p, v), c[v] = d, g))
            for (m in i) _[m] || o(_, m, i[m], !0)
    }
}, , function(t, e, n) {
    n(77)("asyncIterator")
}, function(t, e, n) {
    "use strict";

    function i(t) {
        var e = Y[t] = N(V[U]);
        return e._k = t, e
    }

    function r(t, e) {
        C(t);
        for (var n, i = S(e = A(e)), r = 0, o = i.length; r < o;) et(t, n = i[r++], e[n]);
        return t
    }

    function o(t) {
        var e = W.call(this, t = T(t, !0));
        return !(this === J && u(Y, t) && !u(K, t)) && (!(e || !u(this, t) || !u(Y, t) || u(this, B) && this[B][t]) || e)
    }

    function a(t, e) {
        if (t = A(t), e = T(e, !0), t !== J || !u(Y, e) || u(K, e)) {
            var n = x(t, e);
            return !n || !u(Y, e) || u(t, B) && t[B][e] || (n.enumerable = !0), n
        }
    }

    function s(t) {
        for (var e, n = q(A(t)), i = [], r = 0; n.length > r;) u(Y, e = n[r++]) || e == B || e == f || i.push(e);
        return i
    }

    function c(t) {
        for (var e, n = t === J, i = q(n ? K : A(t)), r = [], o = 0; i.length > o;) !u(Y, e = i[o++]) || n && !u(J, e) || r.push(Y[e]);
        return r
    }
    var l = n(9),
        u = n(28),
        p = n(7),
        d = n(15),
        h = n(18),
        f = n(55).KEY,
        y = n(12),
        m = n(52),
        v = n(56),
        g = n(39),
        E = n(4),
        _ = n(78),
        b = n(77),
        S = n(111),
        I = n(100),
        C = n(6),
        w = n(14),
        P = n(37),
        A = n(32),
        T = n(53),
        O = n(45),
        N = n(43),
        L = n(115),
        R = n(66),
        k = n(65),
        M = n(16),
        D = n(31),
        x = R.f,
        F = M.f,
        q = L.f,
        V = l.Symbol,
        G = l.JSON,
        j = G && G.stringify,
        U = "prototype",
        B = E("_hidden"),
        H = E("toPrimitive"),
        W = {}.propertyIsEnumerable,
        z = m("symbol-registry"),
        Y = m("symbols"),
        K = m("op-symbols"),
        J = Object[U],
        X = "function" == typeof V && !!k.f,
        Z = l.QObject,
        Q = !Z || !Z[U] || !Z[U].findChild,
        $ = p && y(function() {
            return 7 != N(F({}, "a", {
                get: function() {
                    return F(this, "a", {
                        value: 7
                    }).a
                }
            })).a
        }) ? function(t, e, n) {
            var i = x(J, e);
            i && delete J[e], F(t, e, n), i && t !== J && F(J, e, i)
        } : F,
        tt = X && "symbol" == typeof V.iterator ? function(t) {
            return "symbol" == typeof t
        } : function(t) {
            return t instanceof V
        },
        et = function(t, e, n) {
            return t === J && et(K, e, n), C(t), e = T(e, !0), C(n), u(Y, e) ? (n.enumerable ? (u(t, B) && t[B][e] && (t[B][e] = !1), n = N(n, {
                enumerable: O(0, !1)
            })) : (u(t, B) || F(t, B, O(1, {})), t[B][e] = !0), $(t, e, n)) : F(t, e, n)
        };
    X || (h((V = function(t) {
        if (this instanceof V) throw TypeError("Symbol is not a constructor!");
        var e = g(0 < arguments.length ? t : void 0),
            n = function(t) {
                this === J && n.call(K, t), u(this, B) && u(this[B], e) && (this[B][e] = !1), $(this, e, O(1, t))
            };
        return p && Q && $(J, e, {
            configurable: !0,
            set: n
        }), i(e)
    })[U], "toString", function() {
        return this._k
    }), R.f = a, M.f = et, n(58).f = L.f = s, n(42).f = o, k.f = c, p && !n(51) && h(J, "propertyIsEnumerable", o, !0), _.f = function(t) {
        return i(E(t))
    }), d(d.G + d.W + d.F * !X, {
        Symbol: V
    });
    for (var nt = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), it = 0; nt.length > it;) E(nt[it++]);
    for (var rt = D(E.store), ot = 0; rt.length > ot;) b(rt[ot++]);
    d(d.S + d.F * !X, "Symbol", {
        for: function(t) {
            return u(z, t += "") ? z[t] : z[t] = V(t)
        },
        keyFor: function(t) {
            if (!tt(t)) throw TypeError(t + " is not a symbol!");
            for (var e in z)
                if (z[e] === t) return e
        },
        useSetter: function() {
            Q = !0
        },
        useSimple: function() {
            Q = !1
        }
    }), d(d.S + d.F * !X, "Object", {
        create: function(t, e) {
            return void 0 === e ? N(t) : r(N(t), e)
        },
        defineProperty: et,
        defineProperties: r,
        getOwnPropertyDescriptor: a,
        getOwnPropertyNames: s,
        getOwnPropertySymbols: c
    });
    var at = y(function() {
        k.f(1)
    });
    d(d.S + d.F * at, "Object", {
        getOwnPropertySymbols: function(t) {
            return k.f(P(t))
        }
    }), G && d(d.S + d.F * (!X || y(function() {
        var t = V();
        return "[null]" != j([t]) || "{}" != j({
            a: t
        }) || "{}" != j(Object(t))
    })), "JSON", {
        stringify: function(t) {
            for (var e, n, i = [t], r = 1; r < arguments.length;) i.push(arguments[r++]);
            if (n = e = i[1], (w(e) || void 0 !== t) && !tt(t)) return I(e) || (e = function(t, e) {
                if ("function" == typeof n && (e = n.call(this, t, e)), !tt(e)) return e
            }), i[1] = e, j.apply(G, i)
        }
    }), V[U][H] || n(29)(V[U], H, V[U].valueOf), v(V, "Symbol"), v(Math, "Math", !0), v(l.JSON, "JSON", !0)
}, function(t, e, n) {
    "use strict";
    var i = n(15),
        r = n(116),
        o = "includes";
    i(i.P + i.F * n(117)(o), "String", {
        includes: function(t, e) {
            return !!~r(this, t, o).indexOf(t, 1 < arguments.length ? e : void 0)
        }
    })
}, , function(t, e, n) {
    var i = n(15);
    i(i.S + i.F, "Object", {
        assign: n(119)
    })
}, function(t, e, n) {
    var i = n(37),
        r = n(31);
    n(88)("keys", function() {
        return function(t) {
            return r(i(t))
        }
    })
}, function(t, e) {
    var n = {}.hasOwnProperty;
    t.exports = function(t, e) {
        return n.call(t, e)
    }
}, function(t, e, n) {
    var i = n(16),
        r = n(45);
    t.exports = n(7) ? function(t, e, n) {
        return i.f(t, e, r(1, n))
    } : function(t, e, n) {
        return t[e] = n, t
    }
}, function(t, e, n) {
    "use strict";
    n(22), n(23), n(10), n(46), n(13);
    var i = {
        AF: "Afghanistan",
        AL: "Albania",
        DZ: "Algeria",
        AS: "American Samoa",
        AD: "Andorra",
        AO: "Angola",
        AI: "Anguilla",
        AQ: "Antarctica",
        AG: "Antigua And Barbuda",
        AR: "Argentina",
        AM: "Armenia",
        AW: "Aruba",
        AU: "Australia",
        AT: "Austria",
        AZ: "Azerbaijan",
        BS: "Bahamas",
        BH: "Bahrain",
        BD: "Bangladesh",
        BB: "Barbados",
        BY: "Belarus",
        BE: "Belgium",
        BZ: "Belize",
        BJ: "Benin",
        BM: "Bermuda",
        BT: "Bhutan",
        BO: "Bolivia",
        BQ: "Bonaire, Sint Eustatius, And Saba",
        BA: "Bosnia And Herzegovina",
        BW: "Botswana",
        BV: "Bouvet Island",
        BR: "Brazil",
        IO: "British Indian Ocean Territory",
        BN: "Brunei Darussalam",
        BG: "Bulgaria (rep.)",
        BF: "Burkina Faso",
        BI: "Burundi",
        KH: "Cambodia",
        CM: "Cameroon",
        CA: "Canada",
        CV: "Cape Verde",
        KY: "Cayman Islands",
        CF: "Central African Republic",
        TD: "Chad",
        JE: "Channel Islands",
        GG: "Channel Islands",
        CL: "Chile",
        CN: "China",
        CX: "Christmas Island",
        CC: "Cocos (keeling) Islands",
        CO: "Colombia",
        KM: "Comoros",
        CD: "Congo (dem. Rep.)",
        CG: "Congo (rep.)",
        CK: "Cook Islands",
        CR: "Costa Rica",
        CI: "Cote D'ivoire",
        HR: "Croatia",
        CW: "Curacao",
        CY: "Cyprus",
        CZ: "Czech Rep.",
        DK: "Denmark",
        DJ: "Djibouti",
        DM: "Dominica",
        DO: "Dominican Rep.",
        EC: "Ecuador",
        EG: "Egypt",
        SV: "El Salvador",
        GQ: "Equatorial Guinea",
        ER: "Eritrea",
        EE: "Estonia",
        ET: "Ethiopia",
        FK: "Falkland Islands (malvinas)",
        FO: "Faroe Islands",
        FJ: "Fiji",
        AX: "Finland",
        FI: "Finland",
        FR: "France",
        GF: "French Guiana",
        PF: "French Polynesia",
        TF: "French Southern Territories",
        GA: "Gabon",
        GM: "Gambia",
        GE: "Georgia",
        DE: "Germany",
        GH: "Ghana",
        GI: "Gibraltar",
        GR: "Greece",
        GL: "Greenland",
        GD: "Grenada (west Indies)",
        GP: "Guadeloupe",
        GU: "Guam",
        GT: "Guatemala",
        GN: "Guinea",
        GW: "Guinea-bissau",
        GY: "Guyana",
        HT: "Haiti",
        HM: "Heard And Mcdonald Islands",
        HN: "Honduras",
        HK: "Hong Kong",
        HU: "Hungary (rep.)",
        IS: "Iceland",
        IN: "India",
        ID: "Indonesia",
        IR: "Iran",
        IQ: "Iraq",
        IE: "Ireland",
        IM: "Isle Of Man",
        IL: "Israel",
        IT: "Italy",
        JM: "Jamaica",
        JP: "Japan",
        JO: "Jordan",
        KZ: "Kazakhstan",
        KE: "Kenya",
        KI: "Kiribati",
        KW: "Kuwait",
        KG: "Kyrgyzstan",
        LA: "Lao (people's Dem. Rep.)",
        LV: "Latvia",
        LB: "Lebanon",
        LS: "Lesotho",
        LR: "Liberia",
        LY: "Libya",
        LI: "Liechtenstein",
        LT: "Lithuania",
        LU: "Luxembourg",
        MO: "Macao",
        MK: "Macedonia",
        MG: "Madagascar",
        MW: "Malawi",
        MY: "Malaysia",
        MV: "Maldives",
        ML: "Mali",
        MT: "Malta",
        MH: "Marshall Islands",
        MQ: "Martinique",
        MR: "Mauritania",
        MU: "Mauritius",
        YT: "Mayotte",
        MX: "Mexico",
        FM: "Micronesia (federated State Of)",
        MC: "Monaco",
        MN: "Mongolia",
        ME: "Montenegro",
        MS: "Montserrat",
        MA: "Morocco",
        MZ: "Mozambique",
        MM: "Myanmar",
        NA: "Namibia",
        NR: "Nauru Central Pacific",
        NP: "Nepal",
        NL: "Netherlands",
        NC: "New Caledonia",
        NZ: "New Zealand",
        NI: "Nicaragua",
        NE: "Niger",
        NG: "Nigeria",
        NU: "Niue",
        NF: "Norfolk Island",
        MP: "Northern Mariana Islands",
        NO: "Norway",
        OM: "Oman",
        PK: "Pakistan",
        PW: "Palau",
        PS: "Palestinian Territory",
        PA: "Panama (rep.)",
        PG: "Papua New Guinea",
        PY: "Paraguay",
        PE: "Peru",
        PH: "Philippines",
        PN: "Pitcairn",
        PL: "Poland",
        PT: "Portugal",
        PR: "Puerto Rico",
        QA: "Qatar",
        MD: "Rep. Moldova",
        SG: "Rep. Of Singapore",
        RS: "Republic Of Serbia",
        RE: "Reunion",
        RO: "Romania",
        RU: "Russian Federation",
        RW: "Rwanda",
        BL: "Saint Barthelemy",
        SH: "Saint Helena",
        KN: "Saint Kitts And Nevis",
        LC: "Saint Lucia",
        MF: "Saint Martin",
        VC: "Saint Vincent And The Grenadines (antilles)",
        WS: "Samoa",
        SM: "San Marino",
        ST: "Sao Tome And Principe",
        SA: "Saudi Arabia",
        SN: "Senegal",
        SC: "Seychelles",
        SL: "Sierra Leone",
        SX: "Sint Maarten",
        SK: "Slovakia",
        SI: "Slovenia",
        SB: "Solomon Islands",
        SO: "Somalia",
        ZA: "South Africa",
        GS: "South Georgia",
        KR: "South Korea",
        SS: "South Sudan",
        ES: "Spain",
        LK: "Sri Lanka",
        PM: "St. Pierre And Miquelon",
        SR: "Suriname",
        SJ: "Svalbard And Jan Mayen Islands",
        SZ: "Swaziland",
        SE: "Sweden",
        CH: "Switzerland",
        TW: "Taiwan",
        TJ: "Tajikistan",
        TZ: "Tanzania (united Rep.)",
        TH: "Thailand",
        TL: "Timor-leste",
        TG: "Togo",
        TK: "Tokelau",
        TO: "Tonga",
        TT: "Trinidad And Tobago",
        TN: "Tunisia",
        TR: "Turkey",
        TM: "Turkmenistan",
        TC: "Turks And Caicos Islands",
        TV: "Tuvalu",
        UG: "Uganda",
        UA: "Ukraine",
        AE: "United Arab Emirates",
        GB: "United Kingdom",
        US: "United States",
        UM: "United States Minor Outlying Islands",
        UY: "Uruguay",
        UZ: "Uzbekistan",
        VU: "Vanuatu",
        VA: "Vatican",
        VE: "Venezuela",
        VN: "Viet Nam",
        VG: "Virgin Islands (british)",
        VI: "Virgin Islands (u.s.)",
        WF: "Wallis And Futuna Islands",
        EH: "Western Sahara",
        YE: "Yemen",
        ZM: "Zambia",
        ZW: "Zimbabwe"
    };

    function r(t) {
        return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function o(t, e) {
        for (var n = 0; n < e.length; n++) {
            var i = e[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
        }
    }
    var a = function() {
        function t(e) {
            ! function(e) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
            }(this), e && "object" === r(e) || (e = {}), this.data = {}, this.familyName = e.familyName, this.givenName = e.givenName, this.email = e.email, this.country = e.country, this.region = e.region, this.city = e.city, this.addressLines = e.addressLines, this.postalCode = e.postalCode, this.phone = e.phone
        }
        return n = [{
            key: "fromApplePay",
            value: function(e) {
                if (!e) return e;
                var n = e.countryCode;
                return n = n && n.toUpperCase(), new t({
                    addressLines: e.addressLines,
                    city: e.locality,
                    region: e.administrativeArea,
                    postalCode: e.postalCode,
                    country: n,
                    givenName: e.givenName,
                    familyName: e.familyName,
                    email: e.emailAddress,
                    phone: e.phoneNumber
                })
            }
        }, {
            key: "legacyFromApplePay",
            value: function(e) {
                return e ? new t({
                    addressLines: e.addressLines,
                    city: e.locality,
                    region: e.administrativeArea,
                    postalCode: e.postalCode,
                    country: e.countryCode,
                    givenName: e.givenName,
                    familyName: e.familyName,
                    email: e.emailAddress,
                    phone: e.phoneNumber
                }) : e
            }
        }, {
            key: "fromGooglePay",
            value: function(e) {
                return e ? new t({
                    addressLines: [e.address1, e.address2, e.address3, e.address4, e.address5].filter(Boolean),
                    city: e.locality,
                    region: e.administrativeArea,
                    postalCode: e.postalCode,
                    country: e.countryCode,
                    givenName: e.name,
                    email: e.email,
                    phone: e.phoneNumber
                }) : e
            }
        }], o((e = t).prototype, [{
            key: "toApplePay",
            value: function() {
                return {
                    addressLines: this.data.addressLines,
                    locality: this.data.city,
                    administrativeArea: this.data.region,
                    postalCode: this.data.postalCode,
                    countryCode: this.data.country,
                    country: this.data.countryName,
                    givenName: this.data.givenName,
                    familyName: this.data.familyName,
                    emailAddress: this.data.email,
                    phoneNumber: this.data.phone
                }
            }
        }, {
            key: "familyName",
            get: function() {
                return this.data.familyName
            },
            set: function(t) {
                this.data.familyName = t
            }
        }, {
            key: "givenName",
            get: function() {
                return this.data.givenName
            },
            set: function(t) {
                this.data.givenName = t
            }
        }, {
            key: "email",
            get: function() {
                return this.data.email
            },
            set: function(t) {
                this.data.email = t
            }
        }, {
            key: "phone",
            get: function() {
                return this.data.phone
            },
            set: function(t) {
                this.data.phone = t
            }
        }, {
            key: "country",
            get: function() {
                return this.data.country
            },
            set: function(t) {
                this.data.country !== t && (this.data.country = t, this.data.countryName = i[t])
            }
        }, {
            key: "countryName",
            get: function() {
                return this.data.countryName
            }
        }, {
            key: "region",
            get: function() {
                return this.data.region
            },
            set: function(t) {
                this.data.region = t
            }
        }, {
            key: "city",
            get: function() {
                return this.data.city
            },
            set: function(t) {
                this.data.city = t
            }
        }, {
            key: "addressLines",
            get: function() {
                return this.data.addressLines
            },
            set: function(t) {
                !t || t instanceof Array || (t = [t.toString()]), this.data.addressLines = t
            }
        }, {
            key: "postalCode",
            get: function() {
                return this.data.postalCode
            },
            set: function(t) {
                this.data.postalCode = t
            }
        }]), o(e, n), t;
        var e, n
    }();
    e.a = a
}, function(t, e, n) {
    var i = n(81),
        r = n(64);
    t.exports = Object.keys || function(t) {
        return i(t, r)
    }
}, function(t, e, n) {
    var i = n(74),
        r = n(35);
    t.exports = function(t) {
        return i(r(t))
    }
}, function(t, e, n) {
    "use strict";
    n(46), n(13), n(47), n(94), n(73), n(19), n(24);
    var i = {
        ABSOLUTE_SIZES: ["xx-small", "x-small", "small", "medium", "large", "x-large", "xx-large"],
        BROWSER_COLORS: ["aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige", "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgrey", "darkgreen", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite", "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgrey", "lightgreen", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta", "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "teal", "thistle", "tomato", "transparent", "turquoise", "violet", "wheat", "white", "whitesmoke", "yellow", "yellowgreen"],
        FONT_WEIGHT_NUMBERS: [100, 200, 300, 400, 500, 600, 700, 800, 900],
        FONT_WEIGHT_STRINGS: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "normal", "bold", "bolder", "lighter"],
        LINE_HEIGHT_STRINGS: ["normal"],
        RELATIVE_SIZES: ["smaller", "larger"],
        WEB_SAFE_FONTS: ["andale mono", "arial", "arial black", "arial narrow", "arial rounded mt bold", "avant garde", "baskerville", "big caslon", "bodoni mt", "book antiqua", "brush script mt", "calibri", "calisto mt", "cambria", "candara", "century gothic", "charcoal", "comic sans ms", "consolas", "copperplate", "copperplate gothic light", "courier", "courier new", "cursive", "didot", "fantasy", "franklin gothic medium", "futura", "garamond", "geneva", "georgia", "gill sans", "goudy old style", "helvetica", "helvetica neue", "hoefler text", "impact", "lucida bright", "lucida console", "lucida grande", "lucida sans unicode", "lucida sans typewriter", "monaco", "monospace", "optima", "palatino", "palatino linotype", "papyrus", "perpetua", "rockwell", "rockwell extra bold", "sans-serif", "segoe ui", "serif", "square market", "tahoma", "times", "times new roman", "trebuchet ms", "verdana"],
        WEBKIT_FONT_SMOOTHNG: ["none", "antialiased", "subpixel-antialiased"],
        MOZ_OSX_FONT_SMOOTHNG: ["grayscale", "auto"],
        DISPLAY: ["none"],
        sanitizeDeclarationValue: function(t, e) {
            var n = this,
                i = function() {
                    switch (t) {
                        case "background-color":
                        case "color":
                            return n.isValidColor.bind(n);
                        case "box-shadow":
                            return n.isValidBoxShadowChain.bind(n);
                        case "box-sizing":
                            return n.isValidBoxSizing.bind(n);
                        case "font-family":
                            return n.isValidFontFamilyChain.bind(n);
                        case "font-size":
                            return n.isValidFontSize.bind(n);
                        case "font-weight":
                            return n.isValidFontWeight.bind(n);
                        case "line-height":
                            return n.isValidLineHeight.bind(n);
                        case "padding":
                            return n.isValidPaddingChain.bind(n);
                        case "-webkit-font-smoothing":
                            return n.isValidWebkitFontSmoothing.bind(n);
                        case "-moz-osx-font-smoothing":
                            return n.isValidMozOsxFontSmoothing.bind(n);
                        case "display":
                            return n.isValidDisplay.bind(n);
                        case "border-radius":
                            return n.isValidBorderRadiusChain.bind(n);
                        default:
                            return
                    }
                }();
            return i && i(e) || this.isUniversalProperty(e) ? e : void 0
        },
        sanitizeMediaFeatureValue: function(t, e) {
            switch (t) {
                case "min-width":
                case "max-width":
                    return this.isValidMediaWidth(e) ? e : void 0
            }
        },
        isUniversalProperty: function(t) {
            return ["unset", "inherit", "revert", "initial"].includes(t)
        },
        isValidBoxShadowChain: function(t) {
            var e = this;
            return null != t && t.split(/, ?(?![^(]*\))/).every(function(t) {
                return e.isValidBoxShadow(t)
            })
        },
        isValidBoxSizing: function(t) {
            return ["border-box", "content-box"].includes(t)
        },
        isValidBorderRadiusChain: function(t) {
            var e = this;
            return t.split(" ").every(function(t) {
                return e.isValidBorderRadius(t)
            })
        },
        isValidBoxShadow: function(t) {
            if (null == t) return !1;
            if ("none" === t) return !0;
            var e = t.split(/ (?![^(]*\))/),
                n = 0;
            if ("inset" === e[0] && (e.shift(), n++), "inset" === e[e.length - 1]) {
                if (0 < n) return !1;
                e.pop()
            }
            for (var i = 0; i < 2; i++) {
                var r = e.shift();
                if (!this.isValidBoxShadowOffset(r)) return !1
            }
            switch (e.length) {
                case 0:
                    return !0;
                case 1:
                    return this.isValidColor(e[0]) || this.isValidBoxShadowBlur(e[0]);
                case 2:
                    return this.isValidBoxShadowBlur(e[0]) && (this.isValidColor(e[1]) || this.isValidBoxShadowSpread(e[1]));
                case 3:
                    return this.isValidBoxShadowBlur(e[0]) && this.isValidBoxShadowSpread(e[1]) && this.isValidColor(e[2]);
                default:
                    return !1
            }
        },
        isValidBoxShadowOffset: function(t) {
            return 0 === Number(t) || this.isPositiveOrNegativePX(t) || this.isPositiveOrNegativeEM(t)
        },
        isValidBoxShadowSpread: function(t) {
            return 0 === Number(t) || this.isPositiveOrNegativePX(t) || this.isPositiveOrNegativeEM(t)
        },
        isValidBoxShadowBlur: function(t) {
            return 0 === Number(t) || this.isPositivePX(t) || this.isPositiveEM(t)
        },
        isValidBorderRadius: function(t) {
            return 0 === Number(t) || this.isPositivePX(t) || this.isPositiveEM(t)
        },
        isValidColor: function(t) {
            return null != t && (this.isBrowserColor(t) || this.isHex(t) || this.isRGB(t) || this.isRGBA(t))
        },
        isValidFontSize: function(t) {
            return null != t && (this.isAbsoluteSize(t) || this.isRelativeSize(t) || this.isPositivePX(t) || this.isPositivePT(t) || this.isPositiveEM(t) || this.isPositivePercent(t))
        },
        isValidFontFamilyChain: function(t) {
            var e = this;
            return null != t && t.split(", ").every(function(t) {
                return e.isValidFontFamily(t)
            })
        },
        isValidFontFamily: function(t) {
            var e = t.toLowerCase().trim().replace(/['"]+/g, "");
            return this.WEB_SAFE_FONTS.includes(e)
        },
        isValidFontWeight: function(t) {
            return "number" == typeof t ? this.FONT_WEIGHT_NUMBERS.includes(t) : "string" == typeof t && this.FONT_WEIGHT_STRINGS.includes(t.toLowerCase())
        },
        isValidLineHeight: function(t) {
            return "number" == typeof t && 0 <= t || this.LINE_HEIGHT_STRINGS.includes(t) || this.isPositiveEM(t) || this.isPositivePX(t) || this.isPositivePT(t) || this.isPositivePercent(t)
        },
        isValidWebkitFontSmoothing: function(t) {
            return this.WEBKIT_FONT_SMOOTHNG.includes(t)
        },
        isValidMozOsxFontSmoothing: function(t) {
            return this.MOZ_OSX_FONT_SMOOTHNG.includes(t)
        },
        isValidDisplay: function(t) {
            return this.DISPLAY.includes(t)
        },
        isValidPaddingChain: function(t) {
            var e = this;
            if (null == t) return !1;
            var n = t.toString().split(" ");
            return 4 < n.length ? void 0 : n.every(function(t) {
                return e.isValidPaddingValue(t)
            })
        },
        isValidPaddingValue: function(t) {
            return this.isPositivePX(t) || this.isPositiveEM(t) || this.isPositivePercent(t) || 0 === Number(t)
        },
        isValidMediaWidth: function(t) {
            return this.isPositivePX(t) || this.isPositiveEM(t)
        },
        isBrowserColor: function(t) {
            return this.BROWSER_COLORS.includes(t.toLowerCase())
        },
        isHex: function(t) {
            return /^#([a-fA-F0-9]{3}|[a-fA-F0-9]{6})$/.test(t)
        },
        isRGB: function(t) {
            return /^rgb\((\s*\d{1,3},){2}\s*\d{1,3}\)$/.test(t)
        },
        isRGBA: function(t) {
            return /^rgba\((\s*\d{1,3},){3}\s*(1|0*.\d*)\)$/.test(t)
        },
        isAbsoluteSize: function(t) {
            return this.ABSOLUTE_SIZES.includes(t.toLowerCase())
        },
        isRelativeSize: function(t) {
            return this.RELATIVE_SIZES.includes(t.toLowerCase())
        },
        isPositiveOrNegativePX: function(t) {
            return this.isPositivePX(t) || this.isNegativePX(t)
        },
        isPositivePX: function(t) {
            return /^\d*\.?\d+px$/.test(t)
        },
        isNegativePX: function(t) {
            return /^-\d*\.?\d+px$/.test(t)
        },
        isPositiveOrNegativeEM: function(t) {
            return this.isPositiveEM(t) || this.isNegativeEM(t)
        },
        isPositiveEM: function(t) {
            return /^\d*\.?\d+em$/.test(t)
        },
        isNegativeEM: function(t) {
            return /^-\d*\.?\d+em$/.test(t)
        },
        isPositiveOrNegativePT: function(t) {
            return this.isPositivePT(t) || this.isNegativePT(t)
        },
        isPositivePT: function(t) {
            return /^\d*\.?\d+pt$/.test(t)
        },
        isNegativePT: function(t) {
            return /^-\d*\.?\d+pt$/.test(t)
        },
        isPositiveOrNegativePercent: function(t) {
            return this.isPositivePercent(t) || this.isNegativePercent(t)
        },
        isPositivePercent: function(t) {
            return /^\d*\.?\d+%$/.test(t)
        },
        isNegativePercent: function(t) {
            return /^-\d*\.?\d+%$/.test(t)
        }
    };
    e.a = i
}, function(t, e) {
    var n = t.exports = {
        version: "2.6.9"
    };
    "number" == typeof __e && (__e = n)
}, function(t, e) {
    t.exports = function(t) {
        if (null == t) throw TypeError("Can't call method on  " + t);
        return t
    }
}, function(t, e, n) {
    var i = n(57),
        r = Math.min;
    t.exports = function(t) {
        return 0 < t ? r(i(t), 9007199254740991) : 0
    }
}, function(t, e, n) {
    var i = n(35);
    t.exports = function(t) {
        return Object(i(t))
    }
}, function(t, e, n) {
    "use strict";
    n(73), n(22), n(23), n(76), n(10);
    var i = n(2),
        r = n(1);

    function o(t) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function a(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function s(t, e) {
        return !e || "object" !== o(e) && "function" != typeof e ? function() {
            if (void 0 !== t) return t;
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
        }() : e
    }

    function c(t) {
        return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        })(t)
    }

    function l(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: t,
                writable: !0,
                configurable: !0
            }
        }), e && function(t, e) {
            (Object.setPrototypeOf || function(t, e) {
                return t.__proto__ = e, t
            })(t, e)
        }(t, e)
    }
    var u = {
            REQUEST_DURATION_MAX_MS: 6e4,
            REQUEST_TIMEOUT_MS: [1e4, 2e4, 3e4],
            RETRY_DELAY_MS: 200,
            BACKOFF_FACTOR: 1.66
        },
        p = function() {
            function t(e, n, i) {
                var r;
                return a(this, t), (r = s(this, c(t).call(this, "Request timeout exceeded (attempts=".concat(e, "; ").concat(n, "ms; ").concat(i, ")")))).name = "TimeoutError", r
            }
            return l(t, r.m), t
        }();
    u.TimeoutError = p;
    var d = function() {
        function t(e, n, i) {
            var r;
            return a(this, t), (r = s(this, c(t).call(this, "Network error during request (attempts=".concat(e, "; ").concat(n, "ms; ").concat(i, ")")))).name = "NetworkError", r
        }
        return l(t, r.m), t
    }();
    u.NetworkError = d;
    var h = function() {
        function t(e, n, i) {
            var r;
            return a(this, t), (r = s(this, c(t).call(this, "Invalid JSON received from ".concat(e, "; status=").concat(n, " response=").concat(i)))).name = "InvalidJsonError", r
        }
        return l(t, r.m), t
    }();
    u.InvalidJsonError = h, u.post = function(t, e, n) {
        n || "function" != typeof e || (n = e, e = {}), "function" != typeof n && (n = function() {}), (e = e || {})._attempts ? e._attempts += 1 : e._attempts = 1, e._startTime || (e._startTime = Date.now()), e.timeout || (e.timeout = u.REQUEST_TIMEOUT_MS[0]);
        var r = new XMLHttpRequest;
        if (r.open("POST", t, !0), r.timeout = e.timeout, r.withCredentials = !0, e.headers)
            for (var o in e.headers) i.a.hasOwn(e.headers, o) && r.setRequestHeader(o, e.headers[o]);
        e.json && (e.body && (e.body = null), r.setRequestHeader("Accept", "application/json"), r.setRequestHeader("Content-Type", "application/json; charset=utf-8"));
        var a = e.body || JSON.stringify(e.json);
        r.onreadystatechange = function() {
            if (4 === r.readyState && 0 !== r.status) {
                var o = r.responseText;
                if (o && e.json) try {
                    o = JSON.parse(o)
                } catch (s) {
                    var a = i.a.truncate(o, 64);
                    return n(new h(t, r.status, a))
                }
                var s = {
                    headers: u.parseHeaders(r.getAllResponseHeaders()),
                    status: r.status,
                    statusText: r.statusText
                };
                n(null, s, o)
            }
        }, r.onerror = function() {
            r.abort();
            var i = e._attempts - 1,
                o = u.backoff(u.RETRY_DELAY_MS, i),
                a = Date.now() - e._startTime,
                s = u.REQUEST_DURATION_MAX_MS - a;
            if (s <= o) {
                if (s > e.timeout) {
                    var c = s - e.timeout;
                    return void setTimeout(function() {
                        u.post(t, e, n)
                    }, c)
                }
                n(new d(e._attempts, a, t))
            } else setTimeout(function() {
                u.post(t, e, n)
            }, o)
        }, r.ontimeout = function() {
            r.abort();
            var i = Date.now() - e._startTime,
                o = u.REQUEST_DURATION_MAX_MS - i;
            if (o <= 0) n(new p(e._attempts, i, t));
            else {
                var a = u.REQUEST_TIMEOUT_MS[Math.min(e._attempts, 2)];
                o < a && (a = o), e.timeout = a, setTimeout(function() {
                    u.post(t, e, n)
                }, 0)
            }
        }, r.send(a)
    }, u.parseHeaders = function(t) {
        var e = {};
        return t && t.split("\r\n").forEach(function(t) {
            var n = t.indexOf(": ");
            if (0 < n) {
                var i = t.substring(0, n),
                    r = t.substring(n + 2);
                e[i] = r
            }
        }), e
    }, u.backoff = function(t, e) {
        var n = u.BACKOFF_FACTOR;
        return Math.floor(t * Math.pow(n, e))
    }, e.a = u
}, function(t, e) {
    var n = 0,
        i = Math.random();
    t.exports = function(t) {
        return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + i).toString(36))
    }
}, function(t, e, n) {
    var i = n(54);
    t.exports = function(t, e, n) {
        if (i(t), void 0 === e) return t;
        switch (n) {
            case 1:
                return function(n) {
                    return t.call(e, n)
                };
            case 2:
                return function(n, i) {
                    return t.call(e, n, i)
                };
            case 3:
                return function(n, i, r) {
                    return t.call(e, n, i, r)
                }
        }
        return function() {
            return t.apply(e, arguments)
        }
    }
}, function(t, e) {
    var n = {}.toString;
    t.exports = function(t) {
        return n.call(t).slice(8, -1)
    }
}, function(t, e) {
    e.f = {}.propertyIsEnumerable
}, function(t, e, n) {
    function i() {}
    var r = n(6),
        o = n(113),
        a = n(64),
        s = n(63)("IE_PROTO"),
        c = "prototype",
        l = function() {
            var t, e = n(80)("iframe"),
                i = a.length;
            for (e.style.display = "none", n(114).appendChild(e), e.src = "javascript:", (t = e.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), l = t.F; i--;) delete l[c][a[i]];
            return l()
        };
    t.exports = Object.create || function(t, e) {
        var n;
        return null !== t ? (i[c] = r(t), n = new i, i[c] = null, n[s] = t) : n = l(), void 0 === e ? n : o(n, e)
    }
}, function(t, e) {
    t.exports = {}
}, function(t, e) {
    t.exports = function(t, e) {
        return {
            enumerable: !(1 & t),
            configurable: !(2 & t),
            writable: !(4 & t),
            value: e
        }
    }
}, function(t, e, n) {
    "use strict";

    function i(t) {
        n(18)(RegExp.prototype, s, t, !0)
    }
    n(118);
    var r = n(6),
        o = n(59),
        a = n(7),
        s = "toString",
        c = /./ [s];
    n(12)(function() {
        return "/a/b" != c.call({
            source: "a",
            flags: "b"
        })
    }) ? i(function() {
        var t = r(this);
        return "/".concat(t.source, "/", "flags" in t ? t.flags : !a && t instanceof RegExp ? o.call(t) : void 0)
    }) : c.name != s && i(function() {
        return c.call(this)
    })
}, function(t, e, n) {
    "use strict";
    var i = n(6),
        r = n(37),
        o = n(36),
        a = n(57),
        s = n(72),
        c = n(60),
        l = Math.max,
        u = Math.min,
        p = Math.floor,
        d = /\$([$&`']|\d\d?|<[^>]*>)/g,
        h = /\$([$&`']|\d\d?)/g;
    n(61)("replace", 2, function(t, e, n, f) {
        return [function(i, r) {
            var o = t(this),
                a = null == i ? void 0 : i[e];
            return void 0 !== a ? a.call(i, o, r) : n.call(String(o), i, r)
        }, function(t, e) {
            var r = f(n, t, this, e);
            if (r.done) return r.value;
            var p = i(t),
                d = String(this),
                h = "function" == typeof e;
            h || (e = String(e));
            var m = p.global;
            if (m) {
                var v = p.unicode;
                p.lastIndex = 0
            }
            for (var g = [];;) {
                var E = c(p, d);
                if (null === E) break;
                if (g.push(E), !m) break;
                "" === String(E[0]) && (p.lastIndex = s(d, o(p.lastIndex), v))
            }
            for (var _, b = "", S = 0, I = 0; I < g.length; I++) {
                E = g[I];
                for (var C = String(E[0]), w = l(u(a(E.index), d.length), 0), P = [], A = 1; A < E.length; A++) P.push(void 0 === (_ = E[A]) ? _ : String(_));
                var T = E.groups;
                if (h) {
                    var O = [C].concat(P, w, d);
                    void 0 !== T && O.push(T);
                    var N = String(e.apply(void 0, O))
                } else N = y(C, d, w, P, T, e);
                S <= w && (b += d.slice(S, w) + N, S = w + C.length)
            }
            return b + d.slice(S)
        }];

        function y(t, e, i, o, a, s) {
            var c = i + t.length,
                l = o.length,
                u = h;
            return void 0 !== a && (a = r(a), u = d), n.call(s, u, function(n, r) {
                var s;
                switch (r.charAt(0)) {
                    case "$":
                        return "$";
                    case "&":
                        return t;
                    case "`":
                        return e.slice(0, i);
                    case "'":
                        return e.slice(c);
                    case "<":
                        s = a[r.slice(1, -1)];
                        break;
                    default:
                        var u = +r;
                        if (0 == u) return n;
                        if (l < u) {
                            var d = p(u / 10);
                            return 0 === d ? n : d <= l ? void 0 === o[d - 1] ? r.charAt(1) : o[d - 1] + r.charAt(1) : n
                        }
                        s = o[u - 1]
                }
                return void 0 === s ? "" : s
            })
        }
    })
}, function(t, e, n) {
    "use strict";
    e.a = {
        ie10: function() {
            return document.documentElement && "function" == typeof document.documentElement.doScroll
        },
        iosChrome: function() {
            var t = window.navigator.userAgent;
            return /iphone|ipod|ipad/i.test(t) && /CriOS/i.test(t)
        },
        supported: function() {
            return void 0 !== window.postMessage && void 0 !== window.XMLHttpRequest && void 0 !== document.createElement("a").classList
        },
        language: function() {
            return "undefined" == typeof navigator ? "en" : navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || "en"
        }
    }
}, , , function(t, e) {
    t.exports = !1
}, function(t, e, n) {
    var i = n(34),
        r = n(9),
        o = "__core-js_shared__",
        a = r[o] || (r[o] = {});
    (t.exports = function(t, e) {
        return a[t] || (a[t] = void 0 !== e ? e : {})
    })("versions", []).push({
        version: i.version,
        mode: n(51) ? "pure" : "global",
        copyright: "Â© 2019 Denis Pushkarev (zloirock.ru)"
    })
}, function(t, e, n) {
    var i = n(14);
    t.exports = function(t, e) {
        if (!i(t)) return t;
        var n, r;
        if (e && "function" == typeof(n = t.toString) && !i(r = n.call(t))) return r;
        if ("function" == typeof(n = t.valueOf) && !i(r = n.call(t))) return r;
        if (!e && "function" == typeof(n = t.toString) && !i(r = n.call(t))) return r;
        throw TypeError("Can't convert object to primitive value")
    }
}, function(t, e) {
    t.exports = function(t) {
        if ("function" != typeof t) throw TypeError(t + " is not a function!");
        return t
    }
}, function(t, e, n) {
    function i(t) {
        s(t, r, {
            value: {
                i: "O" + ++c,
                w: {}
            }
        })
    }
    var r = n(39)("meta"),
        o = n(14),
        a = n(28),
        s = n(16).f,
        c = 0,
        l = Object.isExtensible || function() {
            return !0
        },
        u = !n(12)(function() {
            return l(Object.preventExtensions({}))
        }),
        p = t.exports = {
            KEY: r,
            NEED: !1,
            fastKey: function(t, e) {
                if (!o(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
                if (!a(t, r)) {
                    if (!l(t)) return "F";
                    if (!e) return "E";
                    i(t)
                }
                return t[r].i
            },
            getWeak: function(t, e) {
                if (!a(t, r)) {
                    if (!l(t)) return !0;
                    if (!e) return !1;
                    i(t)
                }
                return t[r].w
            },
            onFreeze: function(t) {
                return u && p.NEED && l(t) && !a(t, r) && i(t), t
            }
        }
}, function(t, e, n) {
    var i = n(16).f,
        r = n(28),
        o = n(4)("toStringTag");
    t.exports = function(t, e, n) {
        t && !r(t = n ? t : t.prototype, o) && i(t, o, {
            configurable: !0,
            value: e
        })
    }
}, function(t, e) {
    var n = Math.ceil,
        i = Math.floor;
    t.exports = function(t) {
        return isNaN(t = +t) ? 0 : (0 < t ? i : n)(t)
    }
}, function(t, e, n) {
    var i = n(81),
        r = n(64).concat("length", "prototype");
    e.f = Object.getOwnPropertyNames || function(t) {
        return i(t, r)
    }
}, function(t, e, n) {
    "use strict";
    var i = n(6);
    t.exports = function() {
        var t = i(this),
            e = "";
        return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e
    }
}, function(t, e, n) {
    "use strict";
    var i = n(68),
        r = RegExp.prototype.exec;
    t.exports = function(t, e) {
        var n = t.exec;
        if ("function" == typeof n) {
            var o = n.call(t, e);
            if ("object" != typeof o) throw new TypeError("RegExp exec method returned something other than an Object or null");
            return o
        }
        if ("RegExp" !== i(t)) throw new TypeError("RegExp#exec called on incompatible receiver");
        return r.call(t, e)
    }
}, function(t, e, n) {
    "use strict";
    n(121);
    var i = n(18),
        r = n(29),
        o = n(12),
        a = n(35),
        s = n(4),
        c = n(70),
        l = s("species"),
        u = !o(function() {
            var t = /./;
            return t.exec = function() {
                var t = [];
                return t.groups = {
                    a: "7"
                }, t
            }, "7" !== "".replace(t, "$<a>")
        }),
        p = function() {
            var t = /(?:)/,
                e = t.exec;
            t.exec = function() {
                return e.apply(this, arguments)
            };
            var n = "ab".split(t);
            return 2 === n.length && "a" === n[0] && "b" === n[1]
        }();
    t.exports = function(t, e, n) {
        var d = s(t),
            h = !o(function() {
                var e = {};
                return e[d] = function() {
                    return 7
                }, 7 != "" [t](e)
            }),
            f = h ? !o(function() {
                var e = !1,
                    n = /a/;
                return n.exec = function() {
                    return e = !0, null
                }, "split" === t && (n.constructor = {}, n.constructor[l] = function() {
                    return n
                }), n[d](""), !e
            }) : void 0;
        if (!h || !f || "replace" === t && !u || "split" === t && !p) {
            var y = /./ [d],
                m = n(a, d, "" [t], function(t, e, n, i, r) {
                    return e.exec === c ? h && !r ? {
                        done: !0,
                        value: y.call(e, n, i)
                    } : {
                        done: !0,
                        value: t.call(n, e, i)
                    } : {
                        done: !1
                    }
                }),
                v = m[0],
                g = m[1];
            i(String.prototype, t, v), r(RegExp.prototype, d, 2 == e ? function(t, e) {
                return g.call(t, this, e)
            } : function(t) {
                return g.call(t, this)
            })
        }
    }
}, function(t, e, n) {
    var i = n(15),
        r = n(132)(!1);
    i(i.S, "Object", {
        values: function(t) {
            return r(t)
        }
    })
}, function(t, e, n) {
    var i = n(52)("keys"),
        r = n(39);
    t.exports = function(t) {
        return i[t] || (i[t] = r(t))
    }
}, function(t, e) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")
}, function(t, e) {
    e.f = Object.getOwnPropertySymbols
}, function(t, e, n) {
    var i = n(42),
        r = n(45),
        o = n(32),
        a = n(53),
        s = n(28),
        c = n(79),
        l = Object.getOwnPropertyDescriptor;
    e.f = n(7) ? l : function(t, e) {
        if (t = o(t), e = a(e, !0), c) try {
            return l(t, e)
        } catch (t) {}
        if (s(t, e)) return r(!i.f.call(t, e), t[e])
    }
}, function(t, e, n) {
    var i = n(14),
        r = n(41),
        o = n(4)("match");
    t.exports = function(t) {
        var e;
        return i(t) && (void 0 !== (e = t[o]) ? !!e : "RegExp" == r(t))
    }
}, function(t, e, n) {
    var i = n(41),
        r = n(4)("toStringTag"),
        o = "Arguments" == i(function() {
            return arguments
        }());
    t.exports = function(t) {
        var e, n, a;
        return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof(n = function(t, e) {
            try {
                return t[e]
            } catch (t) {}
        }(e = Object(t), r)) ? n : o ? i(e) : "Object" == (a = i(e)) && "function" == typeof e.callee ? "Arguments" : a
    }
}, function(t, e, n) {
    var i = n(14),
        r = n(84).set;
    t.exports = function(t, e, n) {
        var o, a = e.constructor;
        return a !== n && "function" == typeof a && (o = a.prototype) !== n.prototype && i(o) && r && r(t, o), t
    }
}, function(t, e, n) {
    "use strict";
    var i, r, o = n(59),
        a = RegExp.prototype.exec,
        s = String.prototype.replace,
        c = a,
        l = "lastIndex",
        u = (i = /a/, r = /b*/g, a.call(i, "a"), a.call(r, "a"), 0 !== i[l] || 0 !== r[l]),
        p = void 0 !== /()??/.exec("")[1];
    (u || p) && (c = function(t) {
        var e, n, i, r, c = this;
        return p && (n = new RegExp("^" + c.source + "$(?!\\s)", o.call(c))), u && (e = c[l]), i = a.call(c, t), u && i && (c[l] = c.global ? i.index + i[0].length : e), p && i && 1 < i.length && s.call(i[0], n, function() {
            for (r = 1; r < arguments.length - 2; r++) void 0 === arguments[r] && (i[r] = void 0)
        }), i
    }), t.exports = c
}, function(t, e, n) {
    "use strict";

    function i() {
        return this
    }
    var r = n(51),
        o = n(15),
        a = n(18),
        s = n(29),
        c = n(44),
        l = n(122),
        u = n(56),
        p = n(123),
        d = n(4)("iterator"),
        h = !([].keys && "next" in [].keys()),
        f = "values";
    t.exports = function(t, e, n, y, m, v, g) {
        function E(t) {
            if (!h && t in P) return P[t];
            switch (t) {
                case "keys":
                case f:
                    return function() {
                        return new n(this, t)
                    }
            }
            return function() {
                return new n(this, t)
            }
        }
        l(n, e, y);
        var _, b, S, I = e + " Iterator",
            C = m == f,
            w = !1,
            P = t.prototype,
            A = P[d] || P["@@iterator"] || m && P[m],
            T = A || E(m),
            O = m ? C ? E("entries") : T : void 0,
            N = "Array" == e && P.entries || A;
        if (N && (S = p(N.call(new t))) !== Object.prototype && S.next && (u(S, I, !0), r || "function" == typeof S[d] || s(S, d, i)), C && A && A.name !== f && (w = !0, T = function() {
                return A.call(this)
            }), r && !g || !h && !w && P[d] || s(P, d, T), c[e] = T, c[I] = i, m)
            if (_ = {
                    values: C ? T : E(f),
                    keys: v ? T : E("keys"),
                    entries: O
                }, g)
                for (b in _) b in P || a(P, b, _[b]);
            else o(o.P + o.F * (h || w), e, _);
        return _
    }
}, function(t, e, n) {
    "use strict";
    var i = n(89)(!0);
    t.exports = function(t, e, n) {
        return e + (n ? i(t, e).length : 1)
    }
}, function(t, e, n) {
    "use strict";
    var i = n(67),
        r = n(6),
        o = n(125),
        a = n(72),
        s = n(36),
        c = n(60),
        l = n(70),
        u = n(12),
        p = Math.min,
        d = [].push,
        h = "split",
        f = "length",
        y = "lastIndex",
        m = 4294967295,
        v = !u(function() {
            RegExp(m, "y")
        });
    n(61)("split", 2, function(t, e, n, u) {
        var g;
        return g = "c" == "abbc" [h](/(b)*/)[1] || 4 != "test" [h](/(?:)/, -1)[f] || 2 != "ab" [h](/(?:ab)*/)[f] || 4 != "." [h](/(.?)(.?)/)[f] || 1 < "." [h](/()()/)[f] || "" [h](/.?/)[f] ? function(t, e) {
            var r = String(this);
            if (void 0 === t && 0 === e) return [];
            if (!i(t)) return n.call(r, t, e);
            for (var o, a, s, c = [], u = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), p = 0, h = void 0 === e ? m : e >>> 0, v = new RegExp(t.source, u + "g");
                (o = l.call(v, r)) && !(p < (a = v[y]) && (c.push(r.slice(p, o.index)), 1 < o[f] && o.index < r[f] && d.apply(c, o.slice(1)), s = o[0][f], p = a, c[f] >= h));) v[y] === o.index && v[y]++;
            return p === r[f] ? !s && v.test("") || c.push("") : c.push(r.slice(p)), c[f] > h ? c.slice(0, h) : c
        } : "0" [h](void 0, 0)[f] ? function(t, e) {
            return void 0 === t && 0 === e ? [] : n.call(this, t, e)
        } : n, [function(n, i) {
            var r = t(this),
                o = null == n ? void 0 : n[e];
            return void 0 !== o ? o.call(n, r, i) : g.call(String(r), n, i)
        }, function(t, e) {
            var i = u(g, t, this, e, g !== n);
            if (i.done) return i.value;
            var l = r(t),
                d = String(this),
                h = o(l, RegExp),
                f = l.unicode,
                y = (l.ignoreCase ? "i" : "") + (l.multiline ? "m" : "") + (l.unicode ? "u" : "") + (v ? "y" : "g"),
                E = new h(v ? l : "^(?:" + l.source + ")", y),
                _ = void 0 === e ? m : e >>> 0;
            if (0 == _) return [];
            if (0 === d.length) return null === c(E, d) ? [d] : [];
            for (var b = 0, S = 0, I = []; S < d.length;) {
                E.lastIndex = v ? S : 0;
                var C, w = c(E, v ? d : d.slice(S));
                if (null === w || (C = p(s(E.lastIndex + (v ? 0 : S)), d.length)) === b) S = a(d, S, f);
                else {
                    if (I.push(d.slice(b, S)), I.length === _) return I;
                    for (var P = 1; P <= w.length - 1; P++)
                        if (I.push(w[P]), I.length === _) return I;
                    S = b = C
                }
            }
            return I.push(d.slice(b)), I
        }]
    })
}, function(t, e, n) {
    var i = n(41);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(t) {
        return "String" == i(t) ? t.split("") : Object(t)
    }
}, function(t, e, n) {
    var i = n(4)("unscopables"),
        r = Array.prototype;
    null == r[i] && n(29)(r, i, {}), t.exports = function(t) {
        r[i][t] = !0
    }
}, function(t, e, n) {
    var i = n(15);
    i(i.S, "Object", {
        setPrototypeOf: n(84).set
    })
}, function(t, e, n) {
    var i = n(9),
        r = n(34),
        o = n(51),
        a = n(78),
        s = n(16).f;
    t.exports = function(t) {
        var e = r.Symbol || (r.Symbol = o ? {} : i.Symbol || {});
        "_" == t.charAt(0) || t in e || s(e, t, {
            value: a.f(t)
        })
    }
}, function(t, e, n) {
    e.f = n(4)
}, function(t, e, n) {
    t.exports = !n(7) && !n(12)(function() {
        return 7 != Object.defineProperty(n(80)("div"), "a", {
            get: function() {
                return 7
            }
        }).a
    })
}, function(t, e, n) {
    var i = n(14),
        r = n(9).document,
        o = i(r) && i(r.createElement);
    t.exports = function(t) {
        return o ? r.createElement(t) : {}
    }
}, function(t, e, n) {
    var i = n(28),
        r = n(32),
        o = n(82)(!1),
        a = n(63)("IE_PROTO");
    t.exports = function(t, e) {
        var n, s = r(t),
            c = 0,
            l = [];
        for (n in s) n != a && i(s, n) && l.push(n);
        for (; e.length > c;) i(s, n = e[c++]) && (~o(l, n) || l.push(n));
        return l
    }
}, function(t, e, n) {
    var i = n(32),
        r = n(36),
        o = n(112);
    t.exports = function(t) {
        return function(e, n, a) {
            var s, c = i(e),
                l = r(c.length),
                u = o(a, l);
            if (t && n != n) {
                for (; u < l;)
                    if ((s = c[u++]) != s) return !0
            } else
                for (; u < l; u++)
                    if ((t || u in c) && c[u] === n) return t || u || 0;
            return !t && -1
        }
    }
}, function(t, e, n) {
    var i = n(9),
        r = n(69),
        o = n(16).f,
        a = n(58).f,
        s = n(67),
        c = n(59),
        l = i.RegExp,
        u = l,
        p = l.prototype,
        d = /a/g,
        h = /a/g,
        f = new l(d) !== d;
    if (n(7) && (!f || n(12)(function() {
            return h[n(4)("match")] = !1, l(d) != d || l(h) == h || "/a/i" != l(d, "i")
        }))) {
        function y(t) {
            t in l || o(l, t, {
                configurable: !0,
                get: function() {
                    return u[t]
                },
                set: function(e) {
                    u[t] = e
                }
            })
        }
        l = function(t, e) {
            var n = this instanceof l,
                i = s(t),
                o = void 0 === e;
            return !n && i && t.constructor === l && o ? t : r(f ? new u(i && !o ? t.source : t, e) : u((i = t instanceof l) ? t.source : t, i && o ? c.call(t) : e), n ? this : p, l)
        };
        for (var m = a(u), v = 0; m.length > v;) y(m[v++]);
        (p.constructor = l).prototype = p, n(18)(i, "RegExp", l)
    }
    n(85)("RegExp")
}, function(t, e, n) {
    function i(t, e) {
        if (o(t), !r(e) && null !== e) throw TypeError(e + ": can't set as prototype!")
    }
    var r = n(14),
        o = n(6);
    t.exports = {
        set: Object.setPrototypeOf || ("__proto__" in {} ? function(t, e, r) {
            try {
                (r = n(40)(Function.call, n(66).f(Object.prototype, "__proto__").set, 2))(t, []), e = !(t instanceof Array)
            } catch (t) {
                e = !0
            }
            return function(t, n) {
                return i(t, n), e ? t.__proto__ = n : r(t, n), t
            }
        }({}, !1) : void 0),
        check: i
    }
}, function(t, e, n) {
    "use strict";
    var i = n(9),
        r = n(16),
        o = n(7),
        a = n(4)("species");
    t.exports = function(t) {
        var e = i[t];
        o && e && !e[a] && r.f(e, a, {
            configurable: !0,
            get: function() {
                return this
            }
        })
    }
}, function(t, e, n) {
    "use strict";
    var i = n(6),
        r = n(120),
        o = n(60);
    n(61)("search", 1, function(t, e, n, a) {
        return [function(n) {
            var i = t(this),
                r = null == n ? void 0 : n[e];
            return void 0 !== r ? r.call(n, i) : new RegExp(n)[e](String(i))
        }, function(t) {
            var e = a(n, t, this);
            if (e.done) return e.value;
            var s = i(t),
                c = String(this),
                l = s.lastIndex;
            r(l, 0) || (s.lastIndex = 0);
            var u = o(s, c);
            return r(s.lastIndex, l) || (s.lastIndex = l), null === u ? -1 : u.index
        }]
    })
}, function(t, e) {
    t.exports = function(t, e) {
        return {
            value: e,
            done: !!t
        }
    }
}, function(t, e, n) {
    var i = n(15),
        r = n(34),
        o = n(12);
    t.exports = function(t, e) {
        var n = (r.Object || {})[t] || Object[t],
            a = {};
        a[t] = e(n), i(i.S + i.F * o(function() {
            n(1)
        }), "Object", a)
    }
}, function(t, e, n) {
    var i = n(57),
        r = n(35);
    t.exports = function(t) {
        return function(e, n) {
            var o, a, s = String(r(e)),
                c = i(n),
                l = s.length;
            return c < 0 || l <= c ? t ? "" : void 0 : (o = s.charCodeAt(c)) < 55296 || 56319 < o || c + 1 === l || (a = s.charCodeAt(c + 1)) < 56320 || 57343 < a ? t ? s.charAt(c) : o : t ? s.slice(c, c + 2) : a - 56320 + (o - 55296 << 10) + 65536
        }
    }
}, function(t, e, n) {
    var i = n(18);
    t.exports = function(t, e, n) {
        for (var r in e) i(t, r, e[r], n);
        return t
    }
}, function(t, e) {
    t.exports = function(t, e, n, i) {
        if (!(t instanceof e) || void 0 !== i && i in t) throw TypeError(n + ": incorrect invocation!");
        return t
    }
}, function(t, e, n) {
    var i = n(40),
        r = n(102),
        o = n(103),
        a = n(6),
        s = n(36),
        c = n(104),
        l = {},
        u = {};
    (e = t.exports = function(t, e, n, p, d) {
        var h, f, y, m, v = d ? function() {
                return t
            } : c(t),
            g = i(n, p, e ? 2 : 1),
            E = 0;
        if ("function" != typeof v) throw TypeError(t + " is not iterable!");
        if (o(v)) {
            for (h = s(t.length); E < h; E++)
                if ((m = e ? g(a(f = t[E])[0], f[1]) : g(t[E])) === l || m === u) return m
        } else
            for (y = v.call(t); !(f = y.next()).done;)
                if ((m = r(y, g, f.value, e)) === l || m === u) return m
    }).BREAK = l, e.RETURN = u
}, function(t, e, n) {
    var i = n(14);
    t.exports = function(t, e) {
        if (!i(t) || t._t !== e) throw TypeError("Incompatible receiver, " + e + " required!");
        return t
    }
}, function(t, e, n) {
    "use strict";

    function i(t) {
        var e = c(t, !1);
        if ("string" == typeof e && 2 < e.length) {
            var n, i, r, o = (e = E ? e.trim() : h(e, 3)).charCodeAt(0);
            if (43 === o || 45 === o) {
                if (88 === (n = e.charCodeAt(2)) || 120 === n) return NaN
            } else if (48 === o) {
                switch (e.charCodeAt(1)) {
                    case 66:
                    case 98:
                        i = 2, r = 49;
                        break;
                    case 79:
                    case 111:
                        i = 8, r = 55;
                        break;
                    default:
                        return +e
                }
                for (var a, s = e.slice(2), l = 0, u = s.length; l < u; l++)
                    if ((a = s.charCodeAt(l)) < 48 || r < a) return NaN;
                return parseInt(s, i)
            }
        }
        return +e
    }
    var r = n(9),
        o = n(28),
        a = n(41),
        s = n(69),
        c = n(53),
        l = n(12),
        u = n(58).f,
        p = n(66).f,
        d = n(16).f,
        h = n(106).trim,
        f = "Number",
        y = r[f],
        m = y,
        v = y.prototype,
        g = a(n(43)(v)) == f,
        E = "trim" in String.prototype;
    if (!y(" 0o1") || !y("0b1") || y("+0x1")) {
        y = function(t) {
            var e = arguments.length < 1 ? 0 : t,
                n = this;
            return n instanceof y && (g ? l(function() {
                v.valueOf.call(n)
            }) : a(n) != f) ? s(new m(i(e)), n, y) : i(e)
        };
        for (var _, b = n(7) ? u(m) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), S = 0; b.length > S; S++) o(m, _ = b[S]) && !o(y, _) && d(y, _, p(m, _));
        (y.prototype = v).constructor = y, n(18)(r, f, y)
    }
}, function(t, e, n) {
    "use strict";
    n(10), n(19);
    var i = ["constructor", "hasOwnProperty", "isPrototypeOf", "toLocaleString", "toString", "valueOf", "__defineGetter__", "__defineSetter__", "__lookupGetter__", "__lookupSetter__", "__proto__"];

    function r() {
        this.handlers = {}
    }
    r.prototype.add = function(t, e) {
        if ("string" != typeof t || i.includes(t)) throw Error("Invalid event: " + t);
        this.handlers[t] ? this.handlers[t].push(e) : this.handlers[t] = [e]
    }, r.prototype.handle = function(t, e) {
        var n = this.handlers[t],
            i = 0;
        if (n)
            for (var r = 0; r < n.length; r++) n[r](e), i += 1;
        return i
    }, e.a = r
}, function(t, e, n) {
    "use strict";

    function i(t, e) {
        return !!t.querySelector(e)
    }

    function r(t, e) {
        return void 0 !== t[e]
    }
    n(83), n(86), n(20), n(17), n(13), n(27), n(10);
    var o = n(2),
        a = n(8);

    function s(t) {
        if (!(t instanceof a.b)) throw new TypeError("Expected 'SqEventstream'");
        this.eventstream = t;
        var e = window.performance;
        e && "function" == typeof e.getEntriesByType ? this.performance = e : this.performance = void 0
    }

    function c(t) {
        switch (t.initiatorType) {
            case "script":
                return /v2\/paymentform/.test(t.name);
            case "iframe":
                return /v2\/iframe/.test(t.name);
            default:
                return !1
        }
    }
    s.prototype.collectLoadTiming = function(t) {
        var e = this._resources().filter(c),
            n = {
                t: t.tti
            };
        e.forEach(function(t) {
            var e = function(t) {
                    var e = o.a.parseUrl(t);
                    switch (e.pathname) {
                        case "/v2/paymentform":
                            return "m";
                        case "/v2/iframe":
                            switch (!0) {
                                case /type=main/.test(e.search):
                                    return "f";
                                case /type=cardNumber/.test(e.search):
                                    return "n";
                                case /type=giftCard/.test(e.search):
                                    return "g";
                                case /type=cvv/.test(e.search):
                                    return "v";
                                case /type=expirationDate/.test(e.search):
                                    return "x";
                                case /type=postalCode/.test(e.search):
                                    return "p";
                                default:
                                    return "?"
                            }
                    }
                }(t.name),
                i = Math.round(t.duration);
            n[e] = i
        }), this.eventstream.track(a.a.LOAD_EVENT, {
            l: n
        })
    }, s.prototype.collectNonceTiming = function(t, e) {
        var n = "https://pci-connect.squareup.com/v2/card-nonce\\?_=" + t,
            i = this._resources().filter(function(t, e) {
                switch (e.initiatorType) {
                    case "xmlhttprequest":
                        return new RegExp(t).test(e.name);
                    default:
                        return !1
                }
            }.bind(null, n)).pop();
        i = i || {
            duration: Date.now() - e.startTime
        };
        var r = {
            d: Math.round(i.duration),
            e: "".concat(e.error || !1)
        };
        "boolean" == typeof e.validLuhn && (r.l = "".concat(e.validLuhn)), this.eventstream.track(a.a.NONCE_EVENT, {
            l: r
        })
    }, s.prototype.collectConfiguration = function(t) {
        var e = Object.keys(t).filter(function(e) {
                return !1 !== t[e]
            }),
            n = Object.keys(t).filter(function(e) {
                return !1 === t[e]
            }),
            o = Object.keys(t.callbacks).filter(function(e) {
                return "function" == typeof t.callbacks[e]
            });
        t.inputStyles && t.inputStyles.some(function(t) {
            if (t.mediaMinWidth || t.mediaMaxWidth) return e.push("mediaBreakpoints")
        });
        var s = function(t) {
                for (var e = r(t, "angular"), n = r(t, "getAllAngularRootElements"), o = e || n, a = r(t, "bootstrap"), s = r(t, "Ember"), c = r(t, "jQuery"), l = i(t.document, 'form[action*="paypal.com"]'), u = i(t.document, "[data-reactroot]"), p = r(t, "__NUXT__") || r(t, "$nuxt"), d = {
                        angular: o,
                        bootstrap: a,
                        ember: s,
                        jquery: c,
                        paypalBuyNow: l,
                        react: u,
                        vue: r(t, "Vue") || p
                    }, h = 0, f = Object.keys(d); h < f.length; h++) {
                    var y = f[h];
                    !0 !== d[y] && delete d[y]
                }
                return d
            }(window),
            c = Object.keys(s),
            l = {
                c: {
                    e: e.join(" "),
                    d: n.join(" "),
                    c: o.join(" "),
                    l: c.join(" ")
                }
            };
        this.eventstream.track(a.a.CONFIG_EVENT, l)
    }, s.prototype._resources = function() {
        return this.performance ? this.performance.getEntriesByType("resource") : []
    }, e.a = s
}, , , , function(t, e, n) {
    var i = n(41);
    t.exports = Array.isArray || function(t) {
        return "Array" == i(t)
    }
}, function(t, e, n) {
    "use strict";
    var i = n(89)(!0);
    n(71)(String, "String", function(t) {
        this._t = String(t), this._i = 0
    }, function() {
        var t, e = this._t,
            n = this._i;
        return n >= e.length ? {
            value: void 0,
            done: !0
        } : (t = i(e, n), this._i += t.length, {
            value: t,
            done: !1
        })
    })
}, function(t, e, n) {
    var i = n(6);
    t.exports = function(t, e, n, r) {
        try {
            return r ? e(i(n)[0], n[1]) : e(n)
        } catch (e) {
            var o = t.return;
            throw void 0 !== o && i(o.call(t)), e
        }
    }
}, function(t, e, n) {
    var i = n(44),
        r = n(4)("iterator"),
        o = Array.prototype;
    t.exports = function(t) {
        return void 0 !== t && (i.Array === t || o[r] === t)
    }
}, function(t, e, n) {
    var i = n(68),
        r = n(4)("iterator"),
        o = n(44);
    t.exports = n(34).getIteratorMethod = function(t) {
        if (null != t) return t[r] || t["@@iterator"] || o[i(t)]
    }
}, function(t, e, n) {
    var i = n(4)("iterator"),
        r = !1;
    try {
        var o = [7][i]();
        o.return = function() {
            r = !0
        }, Array.from(o, function() {
            throw 2
        })
    } catch (t) {}
    t.exports = function(t, e) {
        if (!e && !r) return !1;
        var n = !1;
        try {
            var o = [7],
                a = o[i]();
            a.next = function() {
                return {
                    done: n = !0
                }
            }, o[i] = function() {
                return a
            }, t(o)
        } catch (t) {}
        return n
    }
}, function(t, e, n) {
    function i(t, e, n) {
        var i = {},
            o = a(function() {
                return !!s[t]() || "â€‹Â…" != "â€‹Â…" [t]()
            }),
            c = i[t] = o ? e(p) : s[t];
        n && (i[n] = c), r(r.P + r.F * o, "String", i)
    }
    var r = n(15),
        o = n(35),
        a = n(12),
        s = n(107),
        c = "[" + s + "]",
        l = RegExp("^" + c + c + "*"),
        u = RegExp(c + c + "*$"),
        p = i.trim = function(t, e) {
            return t = String(o(t)), 1 & e && (t = t.replace(l, "")), 2 & e && (t = t.replace(u, "")), t
        };
    t.exports = i
}, function(t, e) {
    t.exports = "\t\n\v\f\r Â áš€á Žâ€€â€â€‚â€ƒâ€„â€…â€†â€‡â€ˆâ€‰â€Šâ€¯âŸã€€\u2028\u2029\ufeff"
}, , , function(t, e, n) {
    t.exports = n(52)("native-function-to-string", Function.toString)
}, function(t, e, n) {
    var i = n(31),
        r = n(65),
        o = n(42);
    t.exports = function(t) {
        var e = i(t),
            n = r.f;
        if (n)
            for (var a, s = n(t), c = o.f, l = 0; s.length > l;) c.call(t, a = s[l++]) && e.push(a);
        return e
    }
}, function(t, e, n) {
    var i = n(57),
        r = Math.max,
        o = Math.min;
    t.exports = function(t, e) {
        return (t = i(t)) < 0 ? r(t + e, 0) : o(t, e)
    }
}, function(t, e, n) {
    var i = n(16),
        r = n(6),
        o = n(31);
    t.exports = n(7) ? Object.defineProperties : function(t, e) {
        r(t);
        for (var n, a = o(e), s = a.length, c = 0; c < s;) i.f(t, n = a[c++], e[n]);
        return t
    }
}, function(t, e, n) {
    var i = n(9).document;
    t.exports = i && i.documentElement
}, function(t, e, n) {
    var i = n(32),
        r = n(58).f,
        o = {}.toString,
        a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
    t.exports.f = function(t) {
        return a && "[object Window]" == o.call(t) ? function(t) {
            try {
                return r(t)
            } catch (t) {
                return a.slice()
            }
        }(t) : r(i(t))
    }
}, function(t, e, n) {
    var i = n(67),
        r = n(35);
    t.exports = function(t, e, n) {
        if (i(e)) throw TypeError("String#" + n + " doesn't accept regex!");
        return String(r(t))
    }
}, function(t, e, n) {
    var i = n(4)("match");
    t.exports = function(t) {
        var e = /./;
        try {
            "/./" [t](e)
        } catch (n) {
            try {
                return e[i] = !1, !"/./" [t](e)
            } catch (t) {}
        }
        return !0
    }
}, function(t, e, n) {
    n(7) && "g" != /./g.flags && n(16).f(RegExp.prototype, "flags", {
        configurable: !0,
        get: n(59)
    })
}, function(t, e, n) {
    "use strict";
    var i = n(7),
        r = n(31),
        o = n(65),
        a = n(42),
        s = n(37),
        c = n(74),
        l = Object.assign;
    t.exports = !l || n(12)(function() {
        var t = {},
            e = {},
            n = Symbol(),
            i = "abcdefghijklmnopqrst";
        return t[n] = 7, i.split("").forEach(function(t) {
            e[t] = t
        }), 7 != l({}, t)[n] || Object.keys(l({}, e)).join("") != i
    }) ? function(t, e) {
        for (var n = s(t), l = arguments.length, u = 1, p = o.f, d = a.f; u < l;)
            for (var h, f = c(arguments[u++]), y = p ? r(f).concat(p(f)) : r(f), m = y.length, v = 0; v < m;) h = y[v++], i && !d.call(f, h) || (n[h] = f[h]);
        return n
    } : l
}, function(t, e) {
    t.exports = Object.is || function(t, e) {
        return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e
    }
}, function(t, e, n) {
    "use strict";
    var i = n(70);
    n(15)({
        target: "RegExp",
        proto: !0,
        forced: i !== /./.exec
    }, {
        exec: i
    })
}, function(t, e, n) {
    "use strict";
    var i = n(43),
        r = n(45),
        o = n(56),
        a = {};
    n(29)(a, n(4)("iterator"), function() {
        return this
    }), t.exports = function(t, e, n) {
        t.prototype = i(a, {
            next: r(1, n)
        }), o(t, e + " Iterator")
    }
}, function(t, e, n) {
    var i = n(28),
        r = n(37),
        o = n(63)("IE_PROTO"),
        a = Object.prototype;
    t.exports = Object.getPrototypeOf || function(t) {
        return t = r(t), i(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? a : null
    }
}, function(t, e, n) {
    "use strict";
    var i = n(6),
        r = n(36),
        o = n(72),
        a = n(60);
    n(61)("match", 1, function(t, e, n, s) {
        return [function(n) {
            var i = t(this),
                r = null == n ? void 0 : n[e];
            return void 0 !== r ? r.call(n, i) : new RegExp(n)[e](String(i))
        }, function(t) {
            var e = s(n, t, this);
            if (e.done) return e.value;
            var c = i(t),
                l = String(this);
            if (!c.global) return a(c, l);
            for (var u, p = c.unicode, d = [], h = c.lastIndex = 0; null !== (u = a(c, l));) {
                var f = String(u[0]);
                "" === (d[h] = f) && (c.lastIndex = o(l, r(c.lastIndex), p)), h++
            }
            return 0 === h ? null : d
        }]
    })
}, function(t, e, n) {
    var i = n(6),
        r = n(54),
        o = n(4)("species");
    t.exports = function(t, e) {
        var n, a = i(t).constructor;
        return void 0 === a || null == (n = i(a)[o]) ? e : r(n)
    }
}, function(t, e, n) {
    "use strict";
    var i = n(127),
        r = n(93);
    t.exports = n(128)("Map", function(t) {
        return function(e) {
            return t(this, 0 < arguments.length ? e : void 0)
        }
    }, {
        get: function(t) {
            var e = i.getEntry(r(this, "Map"), t);
            return e && e.v
        },
        set: function(t, e) {
            return i.def(r(this, "Map"), 0 === t ? 0 : t, e)
        }
    }, i, !0)
}, function(t, e, n) {
    "use strict";

    function i(t, e) {
        var n, i = f(e);
        if ("F" !== i) return t._i[i];
        for (n = t._f; n; n = n.n)
            if (n.k == e) return n
    }
    var r = n(16).f,
        o = n(43),
        a = n(90),
        s = n(40),
        c = n(91),
        l = n(92),
        u = n(71),
        p = n(87),
        d = n(85),
        h = n(7),
        f = n(55).fastKey,
        y = n(93),
        m = h ? "_s" : "size";
    t.exports = {
        getConstructor: function(t, e, n, u) {
            var p = t(function(t, i) {
                c(t, p, e, "_i"), t._t = e, t._i = o(null), t._f = void 0, t._l = void 0, t[m] = 0, null != i && l(i, n, t[u], t)
            });
            return a(p.prototype, {
                clear: function() {
                    for (var t = y(this, e), n = t._i, i = t._f; i; i = i.n) i.r = !0, i.p && (i.p = i.p.n = void 0), delete n[i.i];
                    t._f = t._l = void 0, t[m] = 0
                },
                delete: function(t) {
                    var n = y(this, e),
                        r = i(n, t);
                    if (r) {
                        var o = r.n,
                            a = r.p;
                        delete n._i[r.i], r.r = !0, a && (a.n = o), o && (o.p = a), n._f == r && (n._f = o), n._l == r && (n._l = a), n[m]--
                    }
                    return !!r
                },
                forEach: function(t, n) {
                    y(this, e);
                    for (var i, r = s(t, 1 < arguments.length ? n : void 0, 3); i = i ? i.n : this._f;)
                        for (r(i.v, i.k, this); i && i.r;) i = i.p
                },
                has: function(t) {
                    return !!i(y(this, e), t)
                }
            }), h && r(p.prototype, "size", {
                get: function() {
                    return y(this, e)[m]
                }
            }), p
        },
        def: function(t, e, n) {
            var r, o, a = i(t, e);
            return a ? a.v = n : (t._l = a = {
                i: o = f(e, !0),
                k: e,
                v: n,
                p: r = t._l,
                n: void 0,
                r: !1
            }, t._f || (t._f = a), r && (r.n = a), t[m]++, "F" !== o && (t._i[o] = a)), t
        },
        getEntry: i,
        setStrong: function(t, e, n) {
            u(t, e, function(t, n) {
                this._t = y(t, e), this._k = n, this._l = void 0
            }, function() {
                for (var t = this, e = t._k, n = t._l; n && n.r;) n = n.p;
                return t._t && (t._l = n = n ? n.n : t._t._f) ? p(0, "keys" == e ? n.k : "values" == e ? n.v : [n.k, n.v]) : (t._t = void 0, p(1))
            }, n ? "entries" : "values", !n, !0), d(e)
        }
    }
}, function(t, e, n) {
    "use strict";
    var i = n(9),
        r = n(15),
        o = n(18),
        a = n(90),
        s = n(55),
        c = n(92),
        l = n(91),
        u = n(14),
        p = n(12),
        d = n(105),
        h = n(56),
        f = n(69);
    t.exports = function(t, e, n, y, m, v) {
        function g(t) {
            var e = S[t];
            o(S, t, "delete" == t ? function(t) {
                return !(v && !u(t)) && e.call(this, 0 === t ? 0 : t)
            } : "has" == t ? function(t) {
                return !(v && !u(t)) && e.call(this, 0 === t ? 0 : t)
            } : "get" == t ? function(t) {
                return v && !u(t) ? void 0 : e.call(this, 0 === t ? 0 : t)
            } : "add" == t ? function(t) {
                return e.call(this, 0 === t ? 0 : t), this
            } : function(t, n) {
                return e.call(this, 0 === t ? 0 : t, n), this
            })
        }
        var E = i[t],
            _ = E,
            b = m ? "set" : "add",
            S = _ && _.prototype,
            I = {};
        if ("function" == typeof _ && (v || S.forEach && !p(function() {
                (new _).entries().next()
            }))) {
            var C = new _,
                w = C[b](v ? {} : -0, 1) != C,
                P = p(function() {
                    C.has(1)
                }),
                A = d(function(t) {
                    new _(t)
                }),
                T = !v && p(function() {
                    for (var t = new _, e = 5; e--;) t[b](e, e);
                    return !t.has(-0)
                });
            A || (((_ = e(function(e, n) {
                l(e, _, t);
                var i = f(new E, e, _);
                return null != n && c(n, m, i[b], i), i
            })).prototype = S).constructor = _), (P || T) && (g("delete"), g("has"), m && g("get")), (T || w) && g(b), v && S.clear && delete S.clear
        } else _ = y.getConstructor(e, t, m, b), a(_.prototype, n), s.NEED = !0;
        return h(_, t), I[t] = _, r(r.G + r.W + r.F * (_ != E), I), v || y.setStrong(_, t, m), _
    }
}, function(t, e, n) {
    var i = n(15),
        r = n(43),
        o = n(54),
        a = n(6),
        s = n(14),
        c = n(12),
        l = n(130),
        u = (n(9).Reflect || {}).construct,
        p = c(function() {
            function t() {}
            return !(u(function() {}, [], t) instanceof t)
        }),
        d = !c(function() {
            u(function() {})
        });
    i(i.S + i.F * (p || d), "Reflect", {
        construct: function(t, e, n) {
            o(t), a(e);
            var i = arguments.length < 3 ? t : o(n);
            if (d && !p) return u(t, e, i);
            if (t == i) {
                switch (e.length) {
                    case 0:
                        return new t;
                    case 1:
                        return new t(e[0]);
                    case 2:
                        return new t(e[0], e[1]);
                    case 3:
                        return new t(e[0], e[1], e[2]);
                    case 4:
                        return new t(e[0], e[1], e[2], e[3])
                }
                var c = [null];
                return c.push.apply(c, e), new(l.apply(t, c))
            }
            var h = i.prototype,
                f = r(s(h) ? h : Object.prototype),
                y = Function.apply.call(t, f, e);
            return s(y) ? y : f
        }
    })
}, function(t, e, n) {
    "use strict";
    var i = n(54),
        r = n(14),
        o = n(131),
        a = [].slice,
        s = {};
    t.exports = Function.bind || function(t) {
        var e = i(this),
            n = a.call(arguments, 1),
            c = function() {
                var i = n.concat(a.call(arguments));
                return this instanceof c ? function(t, e, n) {
                    if (!(e in s)) {
                        for (var i = [], r = 0; r < e; r++) i[r] = "a[" + r + "]";
                        s[e] = Function("F,a", "return new F(" + i.join(",") + ")")
                    }
                    return s[e](t, n)
                }(e, i.length, i) : o(e, i, t)
            };
        return r(e.prototype) && (c.prototype = e.prototype), c
    }
}, function(t, e) {
    t.exports = function(t, e, n) {
        var i = void 0 === n;
        switch (e.length) {
            case 0:
                return i ? t() : t.call(n);
            case 1:
                return i ? t(e[0]) : t.call(n, e[0]);
            case 2:
                return i ? t(e[0], e[1]) : t.call(n, e[0], e[1]);
            case 3:
                return i ? t(e[0], e[1], e[2]) : t.call(n, e[0], e[1], e[2]);
            case 4:
                return i ? t(e[0], e[1], e[2], e[3]) : t.call(n, e[0], e[1], e[2], e[3])
        }
        return t.apply(n, e)
    }
}, function(t, e, n) {
    var i = n(7),
        r = n(31),
        o = n(32),
        a = n(42).f;
    t.exports = function(t) {
        return function(e) {
            for (var n, s = o(e), c = r(s), l = c.length, u = 0, p = []; u < l;) n = c[u++], i && !a.call(s, n) || p.push(t ? [n, s[n]] : s[n]);
            return p
        }
    }
}, function(t, e, n) {
    var i = n(14),
        r = n(55).onFreeze;
    n(88)("freeze", function(t) {
        return function(e) {
            return t && i(e) ? t(r(e)) : e
        }
    })
}, , function(t, e, n) {
    "use strict";
    var i = n(15),
        r = n(161)(5),
        o = "find",
        a = !0;
    o in [] && Array(1)[o](function() {
        a = !1
    }), i(i.P + i.F * a, "Array", {
        find: function(t, e) {
            return r(this, t, 1 < arguments.length ? e : void 0)
        }
    }), n(75)(o)
}, , , , , , , , , , , , , , , , , , , function(t, e, n) {
    var i = n(155);
    "string" == typeof i && (i = [
        [t.i, i, ""]
    ]), n(157)(i, {
        hmr: !0,
        transform: void 0,
        insertInto: void 0
    }), i.locals && (t.exports = i.locals)
}, function(t, e, n) {
    (t.exports = n(156)(!1)).push([t.i, ".sq-card-form-wrapper {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    height: 56px;\n    max-width: 700px;\n    padding: 0px 16px;\n    box-sizing: border-box;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04);\n    border-radius: 6px;\n}\n\n/*\n.sq-card-form-wrapper.sq-error {\n    box-shadow: 0 0 0 1px #FF3E39;\n    background-color: #FFEDED;\n}\n*/\n\n.sq-card-form-wrapper,\n.sq-card-details {\n    min-width: 200px;\n    width: 100%;\n    align-items: center;\n}\n\n.sq-card-base {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.sq-card-frame {\n    position: relative;\n    flex-wrap: nowrap;\n    height: 100%;\n    width: 100%;\n    outline: none;\n    -webkit-transition: transform .5s ease-in-out;\n    transition: transform .5s ease-in-out;\n}\n\n.sq-card-details {\n    margin-top: 16px;\n    font-family: Arial;\n    font-size: 12px;\n    text-align: center;\n    color: #C7C7CC;\n    opacity: 1;\n    -webkit-transition: color .1s ease-in, opacity .1s ease-in;\n    transition: color .1s ease-in, opacity .1s ease-in;\n}\n\n.sq-card-details.sq-error {\n    color: #FF3E39;\n}\n\n.sq-card-details.sq-hide {\n    opacity: .2;\n}\n", ""])
}, function(t, e, n) {
    "use strict";
    t.exports = function(t) {
        var e = [];
        return e.toString = function() {
            return this.map(function(e) {
                var n = function(t, e) {
                    var n, i, r, o = t[1] || "",
                        a = t[3];
                    if (!a) return o;
                    if (e && "function" == typeof btoa) {
                        var s = (n = a, i = btoa(unescape(encodeURIComponent(JSON.stringify(n)))), r = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(i), "/*# ".concat(r, " */")),
                            c = a.sources.map(function(t) {
                                return "/*# sourceURL=".concat(a.sourceRoot).concat(t, " */")
                            });
                        return [o].concat(c).concat([s]).join("\n")
                    }
                    return [o].join("\n")
                }(e, t);
                return e[2] ? "@media ".concat(e[2], "{").concat(n, "}") : n
            }).join("")
        }, e.i = function(t, n) {
            "string" == typeof t && (t = [
                [null, t, ""]
            ]);
            for (var i = {}, r = 0; r < this.length; r++) {
                var o = this[r][0];
                null != o && (i[o] = !0)
            }
            for (var a = 0; a < t.length; a++) {
                var s = t[a];
                null != s[0] && i[s[0]] || (n && !s[2] ? s[2] = n : n && (s[2] = "(".concat(s[2], ") and (").concat(n, ")")), e.push(s))
            }
        }, e
    }
}, function(t, e, n) {
    var i, r, o, a = {},
        s = (i = function() {
            return window && document && document.all && !window.atob
        }, function() {
            return void 0 === r && (r = i.apply(this, arguments)), r
        }),
        c = (o = {}, function(t, e) {
            if ("function" == typeof t) return t();
            if (void 0 === o[t]) {
                var n = function(t, e) {
                    return e ? e.querySelector(t) : document.querySelector(t)
                }.call(this, t, e);
                if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                    n = n.contentDocument.head
                } catch (t) {
                    n = null
                }
                o[t] = n
            }
            return o[t]
        }),
        l = null,
        u = 0,
        p = [],
        d = n(158);

    function h(t, e) {
        for (var n = 0; n < t.length; n++) {
            var i = t[n],
                r = a[i.id];
            if (r) {
                r.refs++;
                for (var o = 0; o < r.parts.length; o++) r.parts[o](i.parts[o]);
                for (; o < i.parts.length; o++) r.parts.push(E(i.parts[o], e))
            } else {
                var s = [];
                for (o = 0; o < i.parts.length; o++) s.push(E(i.parts[o], e));
                a[i.id] = {
                    id: i.id,
                    refs: 1,
                    parts: s
                }
            }
        }
    }

    function f(t, e) {
        for (var n = [], i = {}, r = 0; r < t.length; r++) {
            var o = t[r],
                a = e.base ? o[0] + e.base : o[0],
                s = {
                    css: o[1],
                    media: o[2],
                    sourceMap: o[3]
                };
            i[a] ? i[a].parts.push(s) : n.push(i[a] = {
                id: a,
                parts: [s]
            })
        }
        return n
    }

    function y(t, e) {
        var n = c(t.insertInto);
        if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
        var i = p[p.length - 1];
        if ("top" === t.insertAt) i ? i.nextSibling ? n.insertBefore(e, i.nextSibling) : n.appendChild(e) : n.insertBefore(e, n.firstChild), p.push(e);
        else if ("bottom" === t.insertAt) n.appendChild(e);
        else {
            if ("object" != typeof t.insertAt || !t.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
            var r = c(t.insertAt.before, n);
            n.insertBefore(e, r)
        }
    }

    function m(t) {
        if (null === t.parentNode) return !1;
        t.parentNode.removeChild(t);
        var e = p.indexOf(t);
        0 <= e && p.splice(e, 1)
    }

    function v(t) {
        var e = document.createElement("style");
        if (void 0 === t.attrs.type && (t.attrs.type = "text/css"), void 0 === t.attrs.nonce) {
            var i = n.nc;
            i && (t.attrs.nonce = i)
        }
        return g(e, t.attrs), y(t, e), e
    }

    function g(t, e) {
        Object.keys(e).forEach(function(n) {
            t.setAttribute(n, e[n])
        })
    }

    function E(t, e) {
        var n, i, r, o, a, s;
        if (e.transform && t.css) {
            if (!(o = "function" == typeof e.transform ? e.transform(t.css) : e.transform.default(t.css))) return function() {};
            t.css = o
        }
        if (e.singleton) {
            var c = u++;
            n = l = l || v(e), i = S.bind(null, n, c, !1), r = S.bind(null, n, c, !0)
        } else r = t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (a = e, s = document.createElement("link"), void 0 === a.attrs.type && (a.attrs.type = "text/css"), a.attrs.rel = "stylesheet", g(s, a.attrs), y(a, s), i = function(t, e, n) {
            var i = n.css,
                r = n.sourceMap,
                o = void 0 === e.convertToAbsoluteUrls && r;
            (e.convertToAbsoluteUrls || o) && (i = d(i)), r && (i += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");
            var a = new Blob([i], {
                    type: "text/css"
                }),
                s = t.href;
            t.href = URL.createObjectURL(a), s && URL.revokeObjectURL(s)
        }.bind(null, n = s, e), function() {
            m(n), n.href && URL.revokeObjectURL(n.href)
        }) : (n = v(e), i = function(t, e) {
            var n = e.css,
                i = e.media;
            if (i && t.setAttribute("media", i), t.styleSheet) t.styleSheet.cssText = n;
            else {
                for (; t.firstChild;) t.removeChild(t.firstChild);
                t.appendChild(document.createTextNode(n))
            }
        }.bind(null, n), function() {
            m(n)
        });
        return i(t),
            function(e) {
                if (e) {
                    if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
                    i(t = e)
                } else r()
            }
    }
    t.exports = function(t, e) {
        if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
        (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = s()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
        var n = f(t, e);
        return h(n, e),
            function(t) {
                for (var i = [], r = 0; r < n.length; r++) {
                    var o = n[r];
                    (s = a[o.id]).refs--, i.push(s)
                }
                for (t && h(f(t, e), e), r = 0; r < i.length; r++) {
                    var s;
                    if (0 === (s = i[r]).refs) {
                        for (var c = 0; c < s.parts.length; c++) s.parts[c]();
                        delete a[s.id]
                    }
                }
            }
    };
    var _, b = (_ = [], function(t, e) {
        return _[t] = e, _.filter(Boolean).join("\n")
    });

    function S(t, e, n, i) {
        var r = n ? "" : i.css;
        if (t.styleSheet) t.styleSheet.cssText = b(e, r);
        else {
            var o = document.createTextNode(r),
                a = t.childNodes;
            a[e] && t.removeChild(a[e]), a.length ? t.insertBefore(o, a[e]) : t.appendChild(o)
        }
    }
}, function(t, e) {
    t.exports = function(t) {
        var e = "undefined" != typeof window && window.location;
        if (!e) throw new Error("fixUrls requires window.location");
        if (!t || "string" != typeof t) return t;
        var n = e.protocol + "//" + e.host,
            i = n + e.pathname.replace(/\/[^\/]*$/, "/");
        return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(t, e) {
            var r, o = e.trim().replace(/^"(.*)"$/, function(t, e) {
                return e
            }).replace(/^'(.*)'$/, function(t, e) {
                return e
            });
            return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(o) ? t : (r = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? n + o : i + o.replace(/^\.\//, ""), "url(" + JSON.stringify(r) + ")")
        })
    }
}, function(t, e, n) {
    var i = n(15),
        r = n(160);
    i(i.S + i.F * (Number.parseFloat != r), "Number", {
        parseFloat: r
    })
}, function(t, e, n) {
    var i = n(9).parseFloat,
        r = n(106).trim;
    t.exports = 1 / i(n(107) + "-0") != -1 / 0 ? function(t) {
        var e = r(String(t), 3),
            n = i(e);
        return 0 === n && "-" == e.charAt(0) ? -0 : n
    } : i
}, function(t, e, n) {
    var i = n(40),
        r = n(74),
        o = n(37),
        a = n(36),
        s = n(162);
    t.exports = function(t, e) {
        var n = 1 == t,
            c = 2 == t,
            l = 3 == t,
            u = 4 == t,
            p = 6 == t,
            d = 5 == t || p,
            h = e || s;
        return function(e, s, f) {
            for (var y, m, v = o(e), g = r(v), E = i(s, f, 3), _ = a(g.length), b = 0, S = n ? h(e, _) : c ? h(e, 0) : void 0; b < _; b++)
                if ((d || b in g) && (m = E(y = g[b], b, v), t))
                    if (n) S[b] = m;
                    else if (m) switch (t) {
                case 3:
                    return !0;
                case 5:
                    return y;
                case 6:
                    return b;
                case 2:
                    S.push(y)
            } else if (u) return !1;
            return p ? -1 : l || u ? u : S
        }
    }
}, function(t, e, n) {
    var i = n(163);
    t.exports = function(t, e) {
        return new(i(t))(e)
    }
}, function(t, e, n) {
    var i = n(14),
        r = n(100),
        o = n(4)("species");
    t.exports = function(t) {
        var e;
        return r(t) && ("function" != typeof(e = t.constructor) || e !== Array && !r(e.prototype) || (e = void 0), i(e) && null === (e = e[o]) && (e = void 0)), void 0 === e ? Array : e
    }
}, , , , , , function(t, e, n) {
    "use strict";
    n.r(e), n(22), n(23), n(10), n(19), n(24), n(46), n(13), n(26), n(83);
    var i = n(2),
        r = n(38),
        o = n(1),
        a = i.a.url("https://pci-connect.squareup.com/v2/js-error");

    function s(t) {
        this.options = t || {}, this.source = this.options.source, this.applicationId = this.options.applicationId, this.apiWrapper = this.options.apiWrapper, this.ignoreError = 0, this.urlMatcher = /.+/, this.options.captureUncaughtExceptions && (this.options.captureUncaughtExceptions instanceof RegExp && (this.urlMatcher = this.options.captureUncaughtExceptions), this.install(window))
    }
    var c = s;
    s.prototype.destroy = function() {
        this.originalOnerror && (window.onerror = this.originalOnerror, this.originalOnerror = null)
    }, s.prototype.ignoreNextError = function() {
        var t = this;
        this.ignoreError += 1, window.setTimeout(function() {
            return t.ignoreError -= 1
        }, 0)
    }, s.prototype.wrap = function(t) {
        var e = this;
        if (t.__inner__) return t;

        function n() {
            var n = [].slice.call(arguments);
            try {
                return t.apply(this, n)
            } catch (n) {
                throw e.capture(n), n
            }
        }
        return n.__inner__ = t, n
    }, s.prototype.capture = function(t) {
        if (t.name || t.message) {
            t.message, this.ignoreNextError();
            var e = this._createPayload(t.name, t.message || "[unknown]", t.fileName || "[unknown]", t.stack);
            this._send(e)
        }
    }, s.prototype.install = function(t) {
        t.__error_logger__ || (t.__error_logger__ = !0, this.originalOnerror = t.onerror, t.onerror = function(e, n, i, r, a) {
            return this.ignoreError || /Script error/.test(e) || !this.urlMatcher.test(n) || (a = a || ("Syntax error" === e ? new SyntaxError("Unexpected syntax error") : new o.n(e)), this.capture(a)), "function" == typeof this.originalOnerror && this.originalOnerror.apply(t, [].slice.call(arguments))
        }.bind(this))
    }, s.prototype._createPayload = function(t, e, n, r) {
        return {
            app_id: this.applicationId,
            type: t,
            message: e,
            stack: r,
            ua: window.navigator.userAgent,
            url: window.location.href,
            app_url: i.a.getParentLocation().href,
            script_url: n,
            source: this.source,
            wrapper: this.apiWrapper
        }
    }, s.prototype._send = function(t) {
        r.a.post(a, {
            json: t
        }, this._handleResponse.bind(this))
    }, s.prototype._handleResponse = function() {};
    var l = n(48),
        u = n(0),
        p = n(95);

    function d(t, e, n) {
        this.type = t, this.options = e, this.callbacks = n, this.element = document.createElement("iframe"), this.element.onerror = this.onerror.bind(this), this.element.onload = this.onload.bind(this), this.setDefaultAttributes()
    }
    n(20), n(17), n(27), d.MIN_HEIGHT = 17, d.prototype.onerror = function(t) {
        "function" == typeof this.callbacks.onerror && this.callbacks.onerror(t)
    }, d.prototype.onload = function() {
        "function" == typeof this.callbacks.onload && this.callbacks.onload(this.type)
    }, d.prototype.destroy = function() {
        this.element.parentNode && (this.originalElement ? this.element.parentNode.replaceChild(this.originalElement, this.element) : this.element.parentNode.removeChild(this.element)), this.originalElement = null, this.element = null
    }, d.prototype.setDefaultAttributes = function() {
        var t = this.element;
        t.setAttribute("id", this.options.elementId), t.setAttribute("name", this.name()), t.setAttribute("class", this.combinedClassName()), t.setAttribute("frameBorder", "0"), t.setAttribute("width", "100%"), t.setAttribute("scrolling", "no"), t.setAttribute("height", 17), t.setAttribute("src", this.iframeSRC())
    }, d.prototype.combinedClassName = function() {
        var t = [];
        return this.options.inputClass && t.push(this.options.inputClass), this.options.inheritedClassName && t.push(this.options.inheritedClassName), t.join(" ")
    }, d.prototype.iframeSRC = function() {
        return i.a.url("https://pci-connect.squareup.com/v2/iframe", this.queryParameters())
    }, d.prototype.queryParameters = function() {
        var t = {
            type: this.type
        };
        return this.options.appendQueryParams && (t.app_id = this.options.applicationId, this.options.locationId && (t.location_id = this.options.locationId), this.options.accountId && (t.account_id = this.options.accountId)), t
    }, d.prototype.addClass = function(t) {
        this.element.classList.add(t)
    }, d.prototype.removeClass = function(t) {
        this.element.classList.remove(t)
    }, d.prototype.focus = function() {
        this.element.focus()
    }, d.prototype.name = function() {
        return this.options.elementId
    };
    var h = d;
    var f = {
            allowPaymentRequest: "true",
            height: "0",
            width: "0",
            style: "border: none !important; display: block !important; visibility: hidden !important"
        },
        y = function() {
            function t(e) {
                ! function(e) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }(this), this._options = e, this._errorLogger = this._options.errorLogger, this._id = this._options.formId, this._onload = this._options.onload, this._origin = this._options.targetOriginURL, this._ready = !1, this._window = null, this._iframe = this.createIframe()
            }
            return function(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var i = e[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
                }
            }(t.prototype, [{
                key: "destroy",
                value: function() {
                    this._ready = !1, this._window = null, this._iframe.destroy(), this._iframe = null
                }
            }, {
                key: "send",
                value: function(t) {
                    this._ready && this._window && this._window.postMessage(t, this._origin)
                }
            }, {
                key: "createIframe",
                value: function() {
                    var t = {
                            onerror: this.handleError.bind(this),
                            onload: this.handleLoad.bind(this)
                        },
                        e = Object.assign({}, this._options, {
                            appendQueryParams: !0,
                            elementId: this._options.formId
                        }),
                        n = new h("main", e, t);
                    return Object.keys(f).forEach(function(t) {
                        n.element.setAttribute(t, f[t])
                    }), document.body.appendChild(n.element), n
                }
            }, {
                key: "handleError",
                value: function(t) {
                    this._ready = !1, this._errorLogger.capture(t)
                }
            }, {
                key: "handleLoad",
                value: function() {
                    this._ready = !0, this._window = this._iframe.element.contentWindow, this._onload()
                }
            }, {
                key: "id",
                get: function() {
                    return this._id
                }
            }, {
                key: "ready",
                get: function() {
                    return this._ready
                }
            }, {
                key: "window",
                get: function() {
                    return this._window
                }
            }]), t
        }(),
        m = n(96);
    var v = function() {
            function t(e) {
                ! function(e) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }(this), this._options = e, this._applicationId = e.applicationId, this._locationId = e.locationId, this._accountId = e.accountId, this._errorLogger = e.errorLogger, this._inputs = e.inputs, this._inputClass = e.inputClass, this._onload = e.onload, this._iframeControllers = {}, this._iframeNames = {}, this._loadedIframes = [], this._expectedLoadedFrames = Object.keys(this._inputs).length, this._sendMessage = e.sendMessage, this._messageHandlers = e.messageHandlers, this._inputEventCallback = function() {}, e.callbacks && "function" == typeof e.callbacks.inputEventReceived && (this._inputEventCallback = e.callbacks.inputEventReceived), this._RESIZE_TIMEOUT_MS = 250
            }
            return function(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var i = e[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
                }
            }(t.prototype, [{
                key: "build",
                value: function() {
                    var t = this;
                    this._buildIframeControllers(), this._addResizeEventListener(), this._messageHandlers.add(u.a.events.SET_INPUT_HEIGHT, function(e) {
                        t._setInputHeight(e.inputType, e.inputHeight)
                    }), this._messageHandlers.add(u.a.events.INPUT_EVENT_RECEIVED, function(e) {
                        t._inputEventReceived(e.inputEvent)
                    })
                }
            }, {
                key: "destroy",
                value: function() {
                    for (var t in this._removeResizeEventListener(), this._removeTouchStartEventListener(), this._iframeControllers) i.a.hasOwn(this._iframeControllers, t) && (this._iframeControllers[t].destroy(), delete this._iframeControllers[t])
                }
            }, {
                key: "focus",
                value: function(t) {
                    var e = !1;
                    for (var n in this._inputs)
                        if (i.a.hasOwn(this._inputs, n) && t === n) {
                            e = !0;
                            break
                        } if (!e) {
                        var r = new o.e(t);
                        throw this._errorLogger.capture(r), r
                    }
                    this._iframeControllers[t].focus()
                }
            }, {
                key: "_inputEventReceived",
                value: function(t) {
                    var e = this._iframeControllers[t.field];
                    switch (t.eventType) {
                        case u.a.inputEvents.ERROR_CLASS_ADDED:
                            var n = this._classNameForClassType("error");
                            e.addClass(n);
                            break;
                        case u.a.inputEvents.ERROR_CLASS_REMOVED:
                            var i = this._classNameForClassType("error");
                            e.removeClass(i);
                            break;
                        case u.a.inputEvents.FOCUS_CLASS_ADDED:
                            var r = this._classNameForClassType("focus");
                            e.addClass(r);
                            break;
                        case u.a.inputEvents.FOCUS_CLASS_REMOVED:
                            var o = this._classNameForClassType("focus");
                            e.removeClass(o)
                    }
                    this._inputEventCallback(t)
                }
            }, {
                key: "_classNameForClassType",
                value: function(t) {
                    return this._inputClass + "--" + t
                }
            }, {
                key: "_setInputHeight",
                value: function(t, e) {
                    var n = this._iframeControllers[t].element,
                        i = Math.max(e, h.MIN_HEIGHT);
                    n.setAttribute("height", i), 0 !== e || this._inputHeightError || (this._inputHeightError = !0, this._errorLogger.capture(new o.d))
                }
            }, {
                key: "_buildIframeControllers",
                value: function() {
                    for (var t in this._inputs) i.a.hasOwn(this._inputs, t) && this._buildIframeController(t)
                }
            }, {
                key: "_buildIframeController",
                value: function(t) {
                    var e = this._inputs[t].elementId,
                        n = this._getContainerElement(e),
                        i = Object.assign({}, this._inputs[t], {
                            applicationId: this._applicationId,
                            locationId: this._locationId,
                            accountId: this._accountId,
                            inputClass: this._inputClass,
                            inheritedClassName: n.className
                        });
                    this._iframeControllers[t] = new h(t, i, this._iframeCallbacks()), this._iframeNames[t] = this._iframeControllers[t].name(), (this._iframeControllers[t].originalElement = n).parentElement.replaceChild(this._iframeControllers[t].element, n)
                }
            }, {
                key: "_getContainerElement",
                value: function(t) {
                    var e = document.getElementById(t);
                    if (!e) throw new o.a(t);
                    var n = e.innerHTML;
                    e.innerHTML = "!";
                    var i = e.offsetHeight;
                    return e.innerHTML = n, i <= 0 && window.console.warn(new o.b(t)), e
                }
            }, {
                key: "_iframeCallbacks",
                value: function() {
                    var t = this;
                    return {
                        onload: function(e) {
                            return t._addLoadedFrame(e)
                        }
                    }
                }
            }, {
                key: "_addLoadedFrame",
                value: function(t) {
                    this._loadedIframes.includes(t) || this._loadedIframes.push(t), this._loadedIframes.length === this._expectedLoadedFrames && (this._addTouchStartEventListener(), this._onload())
                }
            }, {
                key: "_addResizeEventListener",
                value: function() {
                    this._resizeCallback = this._updateStylesOnResize.bind(this), window.addEventListener("resize", this._resizeCallback)
                }
            }, {
                key: "_removeResizeEventListener",
                value: function() {
                    window.removeEventListener("resize", this._resizeCallback), clearTimeout(this.fireOnResizeEnd)
                }
            }, {
                key: "_updateStylesOnResize",
                value: function() {
                    var t = this;
                    clearTimeout(this.fireOnResizeEnd), this.fireOnResizeEnd = setTimeout(function() {
                        return t._buildStylesForScreenWidth()
                    }, this._RESIZE_TIMEOUT_MS)
                }
            }, {
                key: "_buildStylesForScreenWidth",
                value: function() {
                    this._sendMessage({
                        eventName: u.a.events.BUILD_STYLES_FOR_SCREEN_WIDTH,
                        screenWidth: window.innerWidth
                    })
                }
            }, {
                key: "_blurAllInputs",
                value: function() {
                    this._sendMessage({
                        eventName: u.a.events.BLUR_ALL_INPUTS
                    })
                }
            }, {
                key: "_addTouchStartEventListener",
                value: function() {
                    var t = this;
                    this._touchcancelCallback = function() {
                        return t._touchStarted = !1
                    }, this._touchmoveCallback = function() {
                        return t._touchStarted = !1
                    }, this._touchstartCallback = function() {
                        return t._touchStarted = !0
                    }, this._touchendCallback = function() {
                        t._touchStarted && t._blurAllInputs(), t._touchStarted = !1
                    }, window.addEventListener("touchstart", this._touchstartCallback), window.addEventListener("touchend", this._touchendCallback), window.addEventListener("touchmove", this._touchmoveCallback), window.addEventListener("touchcancel", this._touchcancelCallback)
                }
            }, {
                key: "_removeTouchStartEventListener",
                value: function() {
                    window.removeEventListener("touchstart", this._touchstartCallback), window.removeEventListener("touchend", this._touchendCallback), window.removeEventListener("touchmove", this._touchmoveCallback), window.removeEventListener("touchcancel", this._touchcancelCallback)
                }
            }, {
                key: "iframeNames",
                get: function() {
                    return this._iframeNames
                }
            }]), t
        }(),
        g = (n(62), n(11)),
        E = n(5);
    var _ = g.a.messages.cardNumber.details,
        b = g.a.classNames,
        S = function() {
            function t(e) {
                ! function(e) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }(this), this._unpackOptions(e), this._build()
            }
            return function(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var i = e[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
                }
            }(t.prototype, [{
                key: "_unpackOptions",
                value: function(t) {
                    if (void 0 === t.containerElement) throw new TypeError("[SqFormDetails]: The containerElement option is required.");
                    this._containerEl = t.containerElement;
                    var e = t.styles || {},
                        n = e.error || {},
                        i = e.hidden ? "none" : E.a;
                    this._styles = {
                        default: {
                            color: e.color || E.a,
                            fontFamily: e.fontFamily || E.a,
                            fontSize: e.fontSize || E.a,
                            fontWeight: e.fontWeight || E.a,
                            display: i
                        },
                        error: {
                            color: n.color || E.a,
                            fontFamily: n.fontFamily || e.fontFamily || E.a,
                            fontSize: n.fontSize || e.fontSize || E.a,
                            fontWeight: n.fontWeight || e.fontWeight || E.a,
                            display: i
                        }
                    }
                }
            }, {
                key: "_build",
                value: function() {
                    this.element = document.createElement("span"), this.element.setAttribute("class", "".concat(b.base, "-details")), this.element.innerHTML = _, this._containerEl.appendChild(this.element), this.applyDefaultStyles()
                }
            }, {
                key: "getText",
                value: function() {
                    return this.element.innerHTML
                }
            }, {
                key: "updateText",
                value: function(t) {
                    var e = this;
                    void 0 !== t && t !== this.element.innerHTML && (this.element.classList.add(b.hide), setTimeout(function() {
                        e.element.innerHTML = t, e.element.classList.remove(b.hide)
                    }, 100))
                }
            }, {
                key: "applyErrorStyles",
                value: function() {
                    this._applyStyles(this._styles.error), this.element.classList.add(b.error)
                }
            }, {
                key: "removeErrorStyles",
                value: function() {
                    this.applyDefaultStyles()
                }
            }, {
                key: "applyDefaultStyles",
                value: function() {
                    this._applyStyles(this._styles.default), this.element.classList.remove(b.error)
                }
            }, {
                key: "_applyStyles",
                value: function(t) {
                    var e = E.c.styleStringForStyleObject(t, E.b.FORM_DETAILS);
                    this.element.setAttribute("style", e)
                }
            }]), t
        }();
    var I = Object.assign({}, g.a.classNames),
        C = function() {
            function t(e) {
                ! function(e) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }(this), this._unpackOptions(e), this._build()
            }
            return function(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var i = e[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
                }
            }(t.prototype, [{
                key: "_unpackOptions",
                value: function(t) {
                    if (void 0 === t.containerElement) throw new TypeError("[SqFormWrapper]: The containerElement option is required.");
                    if (void 0 === t.iframeElement) throw new TypeError("[SqFormWrapper]: The iframeElement option is required.");
                    this._container = t.containerElement, this._iframe = t.iframeElement;
                    var e = t.styles || {
                        error: {}
                    };
                    this._styles = {
                        default: {
                            borderRadius: e.borderRadius || E.a,
                            boxShadow: e.boxShadow || e.outlineColor && "0 0 0 1px ".concat(e.outlineColor) || E.a,
                            backgroundColor: e.backgroundColor || E.a
                        },
                        error: {
                            borderRadius: e.borderRadius || E.a,
                            boxShadow: e.error.boxShadow || e.error.outlineColor && "0 0 0 1px ".concat(e.error.outlineColor) || E.a,
                            backgroundColor: e.error.backgroundColor || E.a
                        }
                    }
                }
            }, {
                key: "_build",
                value: function() {
                    this.element = document.createElement("div"), this.element.setAttribute("class", "".concat(I.base, "-form-wrapper")), this.element.appendChild(this._iframe), this._container.appendChild(this.element), this.applyDefaultStyles()
                }
            }, {
                key: "applyErrorStyles",
                value: function() {
                    this.element.classList.add(I.error), this._applyStyles(this._styles.error)
                }
            }, {
                key: "removeErrorStyles",
                value: function() {
                    this.applyDefaultStyles()
                }
            }, {
                key: "applyDefaultStyles",
                value: function() {
                    this.element.classList.remove(I.error), this._applyStyles(this._styles.default)
                }
            }, {
                key: "_applyStyles",
                value: function(t) {
                    var e = E.c.styleStringForStyleObject(t, E.b.FORM_WRAPPER);
                    this.element.setAttribute("style", e)
                }
            }]), t
        }();
    n(154);
    var w = Object.assign({}, g.a.defaultStyles),
        P = g.a.classNames,
        A = g.a.messages,
        T = Object.values(u.a.inputEvents),
        O = u.a.inputTypes.SINGLE_CARD_ELEMENT,
        N = function() {
            function t(e) {
                ! function(e) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }(this), this._options = e, this._errorLogger = e.errorLogger, this._inputClass = e.inputClass, this._onload = e.onload, this._wrapperStyles = {}, this._unpackInputStyle(e.card.inputStyle || {}), this._sendMessage = e.sendMessage, this._messageHandlers = e.messageHandlers, this._errors = [], this._details, this._wrapper, this._inputEventCallback = function() {}, e.callbacks && "function" == typeof e.callbacks.inputEventReceived && (this._inputEventCallback = e.callbacks.inputEventReceived)
            }
            return function(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var i = e[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
                }
            }(t.prototype, [{
                key: "_unpackInputStyle",
                value: function(t) {
                    this._detailsStyles = Object.assign({
                        color: t.placeholderColor || w.placeholder.color,
                        error: t.error
                    }, t.details), this._wrapperStyles = {
                        borderRadius: t.borderRadius,
                        boxShadow: t.boxShadow,
                        outlineColor: t.outlineColor,
                        backgroundColor: t.backgroundColor,
                        error: {
                            boxShadow: t.error && t.error.boxShadow,
                            backgroundColor: t.error && t.error.backgroundColor,
                            outlineColor: t.error && t.error.outlineColor
                        }
                    }
                }
            }, {
                key: "build",
                value: function() {
                    var t = this;
                    this._buildIframeController(), this._addResizeEventListener(), this._messageHandlers.add(u.a.events.SET_INPUT_HEIGHT, function(e) {
                        t._setInputHeight(e.inputHeight)
                    }), this._messageHandlers.add(u.a.events.INPUT_EVENT_RECEIVED, function(e) {
                        t._eventReceived(e.event)
                    })
                }
            }, {
                key: "destroy",
                value: function() {
                    this._removeResizeEventListener(), this._removeTouchStartEventListener(), this._iframeController && (this._iframeController.destroy(), delete this._iframeController)
                }
            }, {
                key: "_eventReceived",
                value: function(t) {
                    t.field === u.a.inputTypes.SINGLE_CARD_ELEMENT ? this._handleSceEvent(t) : this._handleInputEvent(t)
                }
            }, {
                key: "_handleSceEvent",
                value: function(t) {
                    switch (t.eventType) {
                        case u.a.inputEvents.FOCUS_CLASS_ADDED:
                            this._wrapper.element.classList.add(P.focus);
                            break;
                        case u.a.inputEvents.FOCUS_CLASS_REMOVED:
                            this._wrapper.element.classList.remove(P.focus)
                    }
                }
            }, {
                key: "_handleInputEvent",
                value: function(t) {
                    var e = t.field;
                    switch (t.eventType) {
                        case u.a.inputEvents.FOCUS_CLASS_ADDED:
                            var n;
                            0 === this._errors.length ? n = A[e].details : this._errors.includes(e) && (n = A[e].error), this._details.updateText(n);
                            break;
                        case u.a.inputEvents.ERROR_CLASS_ADDED:
                            this._details.applyErrorStyles(), this._details.updateText(A[e].error), this._errors.push(e), 1 === this._errors.length && this._wrapper.applyErrorStyles();
                            break;
                        case u.a.inputEvents.ERROR_CLASS_REMOVED:
                            var i = A[e];
                            if (this._errors.splice(this._errors.indexOf(e), 1), 0 === this._errors.length) this._details.removeErrorStyles(), this._wrapper.removeErrorStyles(), this._details.updateText(i.details);
                            else {
                                var r = this._errors[this._errors.length - 1];
                                this._details.updateText(A[r].error)
                            }
                    }
                    T.includes(t.eventType) && this._inputEventCallback(t)
                }
            }, {
                key: "_setInputHeight",
                value: function(t) {
                    var e = Math.max(t, h.MIN_HEIGHT);
                    this._wrapper.element.setAttribute("height", e), 0 !== t || this._inputHeightError || (this._inputHeightError = !0, this._errorLogger.capture(new o.d))
                }
            }, {
                key: "_buildIframeController",
                value: function() {
                    var t = this._getContainerElement(),
                        e = Object.assign({}, this._options[O]);
                    e.inputClass = this._options.inputClass, e.applicationId = this._options.applicationId, e.locationId = this._options.locationId, e.accountId = this._options.accountId, e.elementId = "".concat(this._options[O].elementId, "-frame"), this._iframeController = new h(O, e, this._iframeCallbacks()), this._iframeController.element.classList.add("".concat(g.a.classNames.base, "-frame")), this._iframeName = this._iframeController.name(), this._iframeController.originalElement = t;
                    var n = document.createElement("div");
                    n.setAttribute("id", this._options[O].elementId), n.setAttribute("class", t.className), n.classList.add("".concat(g.a.classNames.base, "-base")), t.parentElement.replaceChild(n, t), this._outerContainer = n, this._buildFormWrapper(n), this._buildFormDetails(n)
                }
            }, {
                key: "_buildFormWrapper",
                value: function(t) {
                    var e = {
                        containerElement: t,
                        iframeElement: this._iframeController.element,
                        styles: this._wrapperStyles
                    };
                    this._wrapper = new C(e)
                }
            }, {
                key: "_buildFormDetails",
                value: function(t) {
                    var e = {
                        containerElement: t,
                        styles: this._detailsStyles
                    };
                    this._details = new S(e)
                }
            }, {
                key: "_getContainerElement",
                value: function() {
                    var t = this._options[O].elementId,
                        e = document.getElementById(t);
                    if (!e) throw new o.a(t);
                    var n = e.innerHTML;
                    e.innerHTML = "!";
                    var i = e.offsetHeight;
                    return e.innerHTML = n, i <= 0 && window.console.warn(new o.b(t)), e
                }
            }, {
                key: "_iframeCallbacks",
                value: function() {
                    var t = this;
                    return {
                        onload: function() {
                            return t._addLoadedFrame()
                        }
                    }
                }
            }, {
                key: "_addLoadedFrame",
                value: function() {
                    this._addTouchStartEventListener(), this._onload()
                }
            }, {
                key: "_addResizeEventListener",
                value: function() {
                    this._resizeCallback = this._updateStylesOnResize.bind(this), window.addEventListener("resize", this._resizeCallback)
                }
            }, {
                key: "_removeResizeEventListener",
                value: function() {
                    window.removeEventListener("resize", this._resizeCallback), clearTimeout(this.fireOnResizeEnd)
                }
            }, {
                key: "_updateStylesOnResize",
                value: function() {
                    clearTimeout(this.fireOnResizeEnd), this.fireOnResizeEnd = setTimeout(this._buildStylesForScreenWidth.bind(this), 250)
                }
            }, {
                key: "_buildStylesForScreenWidth",
                value: function() {
                    this._sendMessage({
                        eventName: u.a.events.BUILD_STYLES_FOR_SCREEN_WIDTH,
                        screenWidth: window.innerWidth
                    })
                }
            }, {
                key: "_blurAllInputs",
                value: function() {
                    this._sendMessage({
                        eventName: u.a.events.BLUR_ALL_INPUTS
                    })
                }
            }, {
                key: "_addTouchStartEventListener",
                value: function() {
                    var t = this;
                    this._touchcancelCallback = function() {
                        t._touchStarted = !1
                    }, this._touchmoveCallback = function() {
                        t._touchStarted = !1
                    }, this._touchstartCallback = function() {
                        t._touchStarted = !0
                    }, this._touchendCallback = function() {
                        t._touchStarted && t._blurAllInputs(), t._touchStarted = !1
                    }, window.addEventListener("touchstart", this._touchstartCallback), window.addEventListener("touchend", this._touchendCallback), window.addEventListener("touchmove", this._touchmoveCallback), window.addEventListener("touchcancel", this._touchcancelCallback)
                }
            }, {
                key: "_removeTouchStartEventListener",
                value: function() {
                    window.removeEventListener("touchstart", this._touchstartCallback), window.removeEventListener("touchend", this._touchendCallback), window.removeEventListener("touchmove", this._touchmoveCallback), window.removeEventListener("touchcancel", this._touchcancelCallback)
                }
            }, {
                key: "iframeName",
                get: function() {
                    return this._iframeName
                }
            }]), t
        }();

    function L(t) {
        return (L = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }
    n(94), n(159);
    var R = "SqLineItem",
        k = function() {
            function t(e) {
                ! function(e) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }(this), e && "object" === L(e) || (e = {}), this.data = {}, this.label = e.label, this.pending = e.pending, this.amount = e.amount
            }
            return function(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var i = e[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
                }
            }(t.prototype, [{
                key: "toApplePayLineItem",
                value: function() {
                    return {
                        label: this.data.label,
                        type: this.data.pending ? "pending" : "final",
                        amount: this.data.amount
                    }
                }
            }, {
                key: "toGooglePayLineItem",
                value: function() {
                    return {
                        label: this.data.label,
                        type: "LINE_ITEM",
                        price: this.data.amount,
                        status: this.data.pending ? "PENDING" : "FINAL"
                    }
                }
            }, {
                key: "toInstallmentsLineItem",
                value: function() {
                    return {
                        label: this.data.label,
                        amount: this.data.amount,
                        pending: this.data.pending
                    }
                }
            }, {
                key: "isValid",
                value: function() {
                    if ("object" !== L(this.data) || "string" != typeof this.data.label || "string" != typeof this.data.amount) return !1;
                    var t = Number.parseFloat(this.data.amount);
                    return !isNaN(t) && (void 0 === this.data.pending || "boolean" == typeof this.data.pending)
                }
            }, {
                key: "toBeacon",
                value: function() {
                    return {
                        l: this.data.label,
                        a: this.data.amount,
                        p: this.data.pending
                    }
                }
            }, {
                key: "label",
                get: function() {
                    return this.data.label
                },
                set: function(t) {
                    i.a.isValidDataType("label", R, t, String), this.data.label = t
                }
            }, {
                key: "pending",
                get: function() {
                    return this.data.pending
                },
                set: function(t) {
                    null != t && i.a.isValidDataType("pending", R, t, Boolean) && (this.data.pending = t)
                }
            }, {
                key: "amount",
                get: function() {
                    return this.data.amount
                },
                set: function(t) {
                    i.a.isValidDataType("amount", R, t, String), this.data.amount = t
                }
            }]), t
        }();

    function M(t) {
        return (M = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function D(t, e) {
        for (var n = 0; n < e.length; n++) {
            var i = e[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
        }
    }
    var x = function() {
        function t(e) {
            ! function(e) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
            }(this), e && "object" === M(e) || (e = {}), this.data = {}, this.id = e.id, this.label = e.label, this.amount = e.amount
        }
        return n = [{
            key: "fromApplePay",
            value: function(e) {
                return e ? new t({
                    id: e.identifier,
                    label: e.label,
                    amount: e.amount
                }) : e
            }
        }], D((e = t).prototype, [{
            key: "toApplePay",
            value: function() {
                return {
                    label: this.data.label,
                    detail: "",
                    amount: this.data.amount,
                    identifier: this.data.id
                }
            }
        }, {
            key: "toGooglePay",
            value: function(t) {
                return {
                    id: this.data.id,
                    label: this.data.label,
                    description: Intl.NumberFormat(l.a.language(), {
                        style: "currency",
                        currency: t
                    }).format(this.amount)
                }
            }
        }, {
            key: "id",
            get: function() {
                return this.data.id
            },
            set: function(t) {
                this.data.id = t
            }
        }, {
            key: "label",
            get: function() {
                return this.data.label
            },
            set: function(t) {
                this.data.label = t
            }
        }, {
            key: "amount",
            get: function() {
                return this.data.amount
            },
            set: function(t) {
                this.data.amount = t
            }
        }]), D(e, n), t;
        var e, n
    }();

    function F(t) {
        return (F = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }
    var q = "PaymentDetailsUpdate",
        V = {
            addressLines: "addressLines",
            city: "locality",
            region: "administrativeArea",
            country: "countryCode",
            postalCode: "postalCode"
        },
        G = function() {
            function t(e) {
                ! function(e) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }(this), e && "object" === F(e) || (e = {}), this.data = {}, this.error = e.error, this.shippingContactErrors = e.shippingContactErrors, this.total = e.total, this.lineItems = e.lineItems, this.shippingOptions = e.shippingOptions
            }
            return function(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var i = e[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
                }
            }(t.prototype, [{
                key: "toApplePayShippingContactUpdate",
                value: function(t) {
                    return {
                        errors: this._toApplePayErrors(),
                        newShippingMethods: this._toApplePayShippingMethods(t.shippingMethods),
                        newTotal: this._toApplePayTotal(t.total),
                        newLineItems: this._toApplePayLineItems(t.lineItems)
                    }
                }
            }, {
                key: "toCompleteShippingContactSelectionInputs",
                value: function(t) {
                    return {
                        status: this._toApplePayStatusCode(),
                        newShippingMethods: this._toApplePayShippingMethods(t.shippingMethods),
                        newTotal: this._toApplePayTotal(t.total),
                        newLineItems: this._toApplePayLineItems(t.lineItems)
                    }
                }
            }, {
                key: "toApplePayShippingMethodUpdate",
                value: function(t) {
                    return {
                        newTotal: this._toApplePayTotal(t.total),
                        newLineItems: this._toApplePayLineItems(t.lineItems)
                    }
                }
            }, {
                key: "toCompleteShippingMethodSelectionInputs",
                value: function(t) {
                    return {
                        status: ApplePaySession.STATUS_SUCCESS,
                        newTotal: this._toApplePayTotal(t.total),
                        newLineItems: this._toApplePayLineItems(t.lineItems)
                    }
                }
            }, {
                key: "_toApplePayErrors",
                value: function() {
                    var t = [];
                    for (var e in this.data.error && t.push(new ApplePayError("addressUnserviceable", "postalAddress", this.data.error)), this.data.shippingContactErrors)
                        if (i.a.hasOwn(this.data.shippingContactErrors, e)) {
                            var n = V[e] || "postalAddress";
                            t.push(new ApplePayError("shippingContactInvalid", n, this.data.shippingContactErrors[e]))
                        } return t
                }
            }, {
                key: "_toApplePayStatusCode",
                value: function() {
                    return this.data.error || this.data.shippingContactErrors ? ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS : ApplePaySession.STATUS_SUCCESS
                }
            }, {
                key: "_toApplePayShippingMethods",
                value: function(t) {
                    return this.data.shippingOptions ? this.data.shippingOptions.map(function(t) {
                        return t.toApplePay()
                    }) : t
                }
            }, {
                key: "_toApplePayTotal",
                value: function(t) {
                    return this.data.total ? this.data.total.toApplePayLineItem() : t || (window.console.error("Field `total` in PaymentDetailsUpdate is required."), null)
                }
            }, {
                key: "_toApplePayLineItems",
                value: function(t) {
                    return this.data.lineItems ? this.data.lineItems.map(function(t) {
                        return t.toApplePayLineItem()
                    }) : t
                }
            }, {
                key: "toGooglePayErrors",
                value: function(t) {
                    var e = [];
                    for (var n in this.data.error && e.push({
                            reason: "SHIPPING_ADDRESS_UNSERVICEABLE",
                            message: this.data.error,
                            intent: t
                        }), this.data.shippingContactErrors) i.a.hasOwn(this.data.shippingContactErrors, n) && e.push({
                        reason: "SHIPPING_ADDRESS_INVALID",
                        message: n + ": " + this.data.shippingContactErrors[n],
                        intent: t
                    });
                    return e
                }
            }, {
                key: "toInstallments",
                value: function() {
                    var t = {};
                    return this.data.total && (t.total = this.data.total.toInstallmentsLineItem()), this.data.lineItems && (t.lineItems = this.data.lineItems.map(function(t) {
                        return t.toInstallmentsLineItem()
                    })), t
                }
            }, {
                key: "validate",
                value: function() {
                    var t = [];
                    return this.data.total && !this.data.total.isValid() && t.push("total"), this.data.lineItems && this.data.lineItems.some(function(e) {
                        if (!e.isValid()) return t.push("lineItems")
                    }), t
                }
            }, {
                key: "error",
                get: function() {
                    return this.data.error
                },
                set: function(t) {
                    t && i.a.isValidDataType("error", q, t, String) && (this.data.error = t)
                }
            }, {
                key: "shippingContactErrors",
                get: function() {
                    return this.data.shippingContactErrors
                },
                set: function(t) {
                    t && i.a.isValidDataType("shippingContactErrors", q, t, Object) && (this.data.shippingContactErrors = t)
                }
            }, {
                key: "total",
                get: function() {
                    return this.data.total
                },
                set: function(t) {
                    t && i.a.isValidDataType("total", q, t, Object) && (this.data.total = new k(t))
                }
            }, {
                key: "lineItems",
                get: function() {
                    return this.data.lineItems
                },
                set: function(t) {
                    t && i.a.isValidDataType("lineItems", q, t, Array) && (this.data.lineItems = t.map(function(t) {
                        return new k(t)
                    }))
                }
            }, {
                key: "shippingOptions",
                get: function() {
                    return this.data.shippingOptions
                },
                set: function(t) {
                    t && i.a.isValidDataType("shippingOptions", q, t, Array) && (this.data.shippingOptions = t.map(function(t) {
                        return new x(t)
                    }))
                }
            }]), t
        }(),
        j = n(30),
        U = (n(135), n(76), n(8));

    function B(t) {
        return (B = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function H(t) {
        return (H = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        })(t)
    }

    function W(t, e) {
        return (W = Object.setPrototypeOf || function(t, e) {
            return t.__proto__ = e, t
        })(t, e)
    }
    var z = function() {
        function t(e) {
            var n;
            return function(e) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
            }(this), (n = function(t, e) {
                return !e || "object" !== B(e) && "function" != typeof e ? function() {
                    if (void 0 !== t) return t;
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
                }() : e
            }(this, H(t).call(this, e))).name = "GooglePayError", n
        }
        return function(t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), e && W(t, e)
        }(t, o.m), t
    }();

    function Y(t) {
        this.controller = t, this.errorLogger = t.errorLogger, this.options = t.options, this.callbacks = t.callbacks, this.eventstream = t.eventstream, this.token = null, this.jsLoaded = null, this.enableMethodCalled = !1, this.paymentRequest = null, this.selectedShippingOptionId = null, this.controller.enabledDigitalWallets.includes(u.a.paymentMethods.GOOGLE_PAY) && this.isConfigValid() ? (this.fetchGooglePayJs(), this.controller.messageHandlers.add(u.a.events.RECEIVE_GOOGLE_PAY_CARD_NONCE, this.receiveGooglePayCardNonce.bind(this)), this.controller.messageHandlers.add(u.a.events.RECEIVE_GOOGLE_PAY_TOKEN, this.receiveGooglePayToken.bind(this)), this.controller.sendEvent(u.a.events.LOAD_WALLET, u.a.paymentMethods.GOOGLE_PAY)) : this.controller.enableMethod(u.a.paymentMethods.GOOGLE_PAY, !1)
    }
    Y.prototype.isConfigValid = function() {
        if (!this.options.googlePay || "function" != typeof this.callbacks.createPaymentRequest || "function" != typeof this.callbacks.cardNonceResponseReceived) return !1;
        if (!this.getElement()) throw new o.a(this.options.googlePay.elementId);
        if (!this.getGatewayMerchantId()) throw new o.j("locationId");
        return !0
    }, Y.prototype.getElement = function() {
        return document.getElementById(this.options.googlePay.elementId)
    }, Y.prototype.getGatewayMerchantId = function() {
        return this.options.locationId || this.options.accountId
    }, Y.prototype.fetchGooglePayJs = function() {
        var t = document.createElement("script");
        t.onload = this.googlePayJsFetched.bind(this), t.src = u.a.GOOGLE_PAY_JS, document.body.appendChild(t)
    }, Y.prototype.googlePayJsFetched = function() {
        var t = this;
        if ("undefined" != typeof google) {
            this.paymentsClient = new google.payments.api.PaymentsClient(this.buildClientConfig());
            var e = this.googlePayLoaded.bind(this);
            this.paymentsClient.isReadyToPay(this.buildBaseConfiguration()).then(function(t) {
                t.result ? e(!0) : e(!1)
            }).catch(function(n) {
                t.errorLogger.capture(n), e(!1)
            })
        } else this.googlePayLoaded(!1)
    }, Y.prototype.buildClientConfig = function() {
        var t = {
            environment: "TEST"
        };
        return "function" != typeof this.callbacks.shippingContactChanged && "function" != typeof this.callbacks.shippingOptionChanged || (t.paymentDataCallbacks = {
            onPaymentDataChanged: this.onPaymentDataChanged.bind(this),
            onPaymentAuthorized: function() {
                return {
                    transactionState: "SUCCESS"
                }
            }
        }), t
    }, Y.prototype.googlePayLoaded = function(t) {
        this.jsLoaded = t, this.tryEnablingGooglePay()
    }, Y.prototype.tryEnablingGooglePay = function() {
        !0 !== this.enableMethodCalled && (!1 === this.jsLoaded ? (this.controller.enableMethod(u.a.paymentMethods.GOOGLE_PAY, !1), this.enableMethodCalled = !0) : !0 === this.jsLoaded && null !== this.token && this.getElement() && (this.getElement().addEventListener("click", this.requestPayment.bind(this)), this.controller.enableMethod(u.a.paymentMethods.GOOGLE_PAY, !0), this.enableMethodCalled = !0))
    }, Y.prototype.requestPayment = function() {
        var t = this;
        this.paymentRequest = new Z(this.callbacks.createPaymentRequest());
        var e = this.paymentRequest.validate();
        this.trackSqPaymentRequestValidationErrors(e);
        var n = this.paymentRequest.toGooglePay(this.buildBaseConfiguration(), this.buildCallbackIntents()),
            i = this.requestGooglePayCardNonce.bind(this);
        this.paymentsClient.loadPaymentData(n).then(function(e) {
            e.apiVersion === n.apiVersion && e.apiVersionMinor === n.apiVersionMinor && (e.shippingOptionData && (t.selectedShippingOptionId = e.shippingOptionData.id), i(e))
        }).catch(function(e) {
            "CANCELED" !== e.statusCode && (window.console.error(e), t.errorLogger.capture(e))
        })
    }, Y.prototype.receiveGooglePayToken = function(t) {
        var e = t.payload;
        e.errors || (this.token = e.token, this.tryEnablingGooglePay())
    }, Y.prototype.requestGooglePayCardNonce = function(t) {
        this.controller.sendEvent(u.a.events.REQUEST_GOOGLE_PAY_CARD_NONCE, {
            googlepay_data: t
        })
    }, Y.prototype.receiveGooglePayCardNonce = function(t) {
        var e = t.payload;
        if (e.errors) this.callbacks.cardNonceResponseReceived(e.errors);
        else {
            var n, i = j.a.fromGooglePay(e.billing_contact),
                r = j.a.fromGooglePay(e.shipping_contact);
            this.selectedShippingOptionId && (n = this.getShippingOption(this.selectedShippingOptionId)), this.callbacks.cardNonceResponseReceived(null, e.card_nonce, e.card, i, r, n)
        }
    }, Y.prototype.onPaymentDataChanged = function(t) {
        switch (t.callbackTrigger) {
            case "INITIALIZE":
                return this._onPaymentDataChanged_Initialize(t);
            case "SHIPPING_ADDRESS":
                return this._onPaymentDataChanged_ShippingAddress(t);
            case "SHIPPING_OPTION":
                return this._onPaymentDataChanged_ShippingOption(t)
        }
        return this._onPaymentDataChanged__invalid_trigger(t.callbackTrigger)
    }, Y.prototype._onPaymentDataChanged_Initialize = function(t) {
        var e = this;
        return this.paymentRequest.shippingOptions && (this.selectedShippingOptionId = this.paymentRequest.shippingOptions[0].id), this.callShippingContactChanged(t).then(function(n) {
            return e.callShippingOptionChanged(t).then(function(t) {
                var i = n.concat(t);
                return e._onPaymentDataChanged__complete(i)
            })
        })
    }, Y.prototype._onPaymentDataChanged_ShippingAddress = function(t) {
        var e = this,
            n = this.selectedShippingOptionId;
        return this.paymentRequest.shippingOptions && (this.selectedShippingOptionId = this.paymentRequest.shippingOptions[0].id), this.callShippingContactChanged(t).then(function(i) {
            return n === e.selectedShippingOptionId ? e._onPaymentDataChanged__complete(i) : e.callShippingOptionChanged(t).then(function(t) {
                var n = i.concat(t);
                return e._onPaymentDataChanged__complete(n)
            })
        })
    }, Y.prototype._onPaymentDataChanged_ShippingOption = function(t) {
        var e = this;
        return this.selectedShippingOptionId = t.shippingOptionData.id, this.callShippingOptionChanged(t).then(function(t) {
            return e._onPaymentDataChanged__complete(t)
        })
    }, Y.prototype._onPaymentDataChanged__complete = function(t) {
        var e = this.paymentRequest.toGooglePayUpdate(this.selectedShippingOptionId);
        return t && 0 < t.length && (e.error = t[0]), e
    }, Y.prototype._onPaymentDataChanged__invalid_trigger = function(t) {
        var e = new o.n("Unknown callbackTrigger: '".concat(t, "'"));
        return this.errorLogger.capture(e), Promise.resolve({})
    }, Y.prototype.callShippingContactChanged = function(t) {
        var e = this;
        return t.shippingAddress ? "function" != typeof this.callbacks.shippingContactChanged ? Promise.resolve([]) : new Promise(function(n) {
            try {
                e.callbacks.shippingContactChanged(j.a.fromGooglePay(t.shippingAddress), function(t) {
                    var i = new G(t),
                        r = i.validate();
                    e.trackPaymentDetailsUpdateValidationErrors(r), e.updatePaymentRequest(i), n(i.toGooglePayErrors("SHIPPING_ADDRESS"))
                })
            } catch (t) {
                throw window.console.error("callbacks.shippingContactChanged error", t), t
            }
        }) : Promise.resolve([])
    }, Y.prototype.callShippingOptionChanged = function() {
        var t = this;
        if ("function" != typeof this.callbacks.shippingOptionChanged) return Promise.resolve([]);
        if (!this.selectedShippingOptionId) return Promise.resolve([]);
        var e = this.getShippingOption(this.selectedShippingOptionId);
        return e ? new Promise(function(n) {
            try {
                t.callbacks.shippingOptionChanged(e, function(e) {
                    var i = new G(e),
                        r = i.validate();
                    t.trackPaymentDetailsUpdateValidationErrors(r), t.updatePaymentRequest(i), n(i.toGooglePayErrors("SHIPPING_OPTION"))
                })
            } catch (t) {
                throw window.console.error("callbacks.shippingOptionChanged error", t), t
            }
        }) : Promise.resolve([])
    }, Y.prototype.updatePaymentRequest = function(t) {
        t.lineItems && (this.paymentRequest.lineItems = t.lineItems.map(function(t) {
            return new k(t)
        })), t.total && (this.paymentRequest.total = new k(t.total)), t.shippingOptions && (this.paymentRequest.shippingOptions = t.shippingOptions.map(function(t) {
            return new x(t)
        }))
    }, Y.prototype.getShippingOption = function(t) {
        if (this.paymentRequest) return Array.isArray(this.paymentRequest.shippingOptions) && 0 !== this.paymentRequest.shippingOptions.length ? this.paymentRequest.shippingOptions.find(function(e) {
            return e.id === t
        }) : null;
        var e = new o.n("paymentRequest not persisted, possibly due to createPaymentRequest not being called");
        throw this.errorLogger.capture(e), e
    }, Y.prototype.trackSqPaymentRequestValidationErrors = function(t) {
        var e = this;
        0 !== t.length && (t.forEach(function(t) {
            var n = {
                g: {
                    a: "SQ_PAYMENT_REQUEST_VALIDATION:ERROR",
                    e: t
                }
            };
            e.eventstream.track(U.a.GENERAL_EVENT, n)
        }), i.a.logInvalidFieldsError("PaymentRequest", t))
    }, Y.prototype.trackPaymentDetailsUpdateValidationErrors = function(t) {
        var e = this;
        0 !== t.length && (t.forEach(function(t) {
            var n = {
                g: {
                    a: "PAYMENT_DETAILS_UPDATE_VALIDATION:ERROR",
                    e: t
                }
            };
            e.eventstream.track(U.a.GENERAL_EVENT, n)
        }), i.a.logInvalidFieldsError("PaymentDetailsUpdate", t))
    }, Y.prototype.buildBaseConfiguration = function() {
        return {
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods: [{
                type: "CARD",
                parameters: {
                    allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                    allowedCardNetworks: ["AMEX", "DISCOVER", "MASTERCARD", "VISA"],
                    billingAddressRequired: !0
                },
                tokenizationSpecification: {
                    type: "PAYMENT_GATEWAY",
                    parameters: {
                        gateway: "square",
                        gatewayMerchantId: this.getGatewayMerchantId()
                    }
                }
            }],
            merchantInfo: {
                merchantId: "05498866192997955200",
                authJwt: this.token
            }
        }
    }, Y.prototype.buildCallbackIntents = function() {
        var t = [];
        return "function" == typeof this.callbacks.shippingOptionChanged ? (t.push("SHIPPING_ADDRESS"), t.push("SHIPPING_OPTION")) : "function" == typeof this.callbacks.shippingContactChanged && t.push("SHIPPING_ADDRESS"), 0 < t.length && t.push("PAYMENT_AUTHORIZATION"), t
    };
    var K = Y;

    function J(t) {
        return (J = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }
    var X = "SqPaymentRequest",
        Z = function() {
            function t(e) {
                ! function(e) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }(this), e && "object" === J(e) || (e = {}), this.data = {}, "boolean" == typeof e.requestEmailAddress && (this.data.requestEmailAddress = e.requestEmailAddress), this.currencyCode = e.currencyCode, this.countryCode = e.countryCode, this.total = e.total, this.shippingContact = e.shippingContact, this.shippingOptions = e.shippingOptions, this.lineItems = e.lineItems, this.requestShippingAddress = e.requestShippingAddress, this.requestBillingInfo = e.requestBillingInfo
            }
            return function(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var i = e[n];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
                }
            }(t.prototype, [{
                key: "toApplePay",
                value: function() {
                    var t = {
                        currencyCode: this.data.currencyCode,
                        countryCode: this.data.countryCode,
                        supportedNetworks: ["visa", "masterCard", "discover", "amex"],
                        merchantCapabilities: ["supports3DS"],
                        requiredBillingContactFields: ["postalAddress"]
                    };
                    return this.data.total && (t.total = this.data.total.toApplePayLineItem()), this.data.shippingContact instanceof j.a && (t.shippingContact = this.data.shippingContact.toApplePay()), this.data.shippingOptions ? t.shippingMethods = this.data.shippingOptions.map(function(t) {
                        return t.toApplePay()
                    }) : t.shippingMethods = [], this.data.lineItems ? t.lineItems = this.data.lineItems.map(function(t) {
                        return t.toApplePayLineItem()
                    }) : t.lineItems = [], this.data.requestBillingInfo && (t.requiredShippingContactFields = ["email", "name", "phone"]), this.data.requestShippingAddress && (t.requiredShippingContactFields = ["postalAddress", "name", "email", "phone"]), t
                }
            }, {
                key: "toGooglePay",
                value: function(t, e) {
                    var n = this;
                    if (!Array.isArray(e)) {
                        var r = i.a.typeOf(e);
                        throw new TypeError("Expected 'callbackIntents' to be Array but got ".concat(r))
                    }
                    var o = Object.assign({}, t, {
                        transactionInfo: {
                            totalPriceLabel: this.data.total.label,
                            totalPriceStatus: this.data.total.pending ? "ESTIMATED" : "FINAL",
                            totalPrice: this.data.total.amount,
                            currencyCode: this.data.currencyCode || "USD"
                        }
                    });
                    if (Array.isArray(this.data.lineItems) && 0 < this.data.lineItems.length && (o.transactionInfo.displayItems = this.data.lineItems.map(function(t) {
                            return t.toGooglePayLineItem()
                        })), o.shippingOptionRequired = !!this.data.shippingOptions || e.includes("SHIPPING_OPTION"), o.shippingOptionRequired) {
                        if (!this.data.shippingOptions || 0 === this.data.shippingOptions.length) {
                            var a = ["paymentRequest.shippingOptions is required when the SqPaymentForm shippingOptionsChanged() callback is defined.", "Provide paymentRequest.shippingOptions or remove the SqPaymentForm shippingOptionsChanged() callback to continue."].join("\n");
                            throw new z(a)
                        }
                        o.shippingOptionParameters = {
                            shippingOptions: this.data.shippingOptions.map(function(t) {
                                return t.toGooglePay(n.data.currencyCode)
                            })
                        }
                    }
                    return o.emailRequired = !!this.data.requestShippingAddress || !!this.data.requestEmailAddress, o.shippingAddressRequired = !!this.data.requestShippingAddress || !!this.data.shippingOptions || !!o.shippingOptionRequired || e.includes("SHIPPING_ADDRESS"), o.shippingAddressParameters = {
                        phoneNumberRequired: !!this.data.requestShippingAddress
                    }, o.allowedPaymentMethods[0].parameters.billingAddressParameters = {
                        format: "MIN",
                        phoneNumberRequired: !!this.data.requestBillingInfo
                    }, 0 < e.length && (o.callbackIntents = e), o
                }
            }, {
                key: "toGooglePayUpdate",
                value: function(t) {
                    var e = this,
                        n = [];
                    Array.isArray(this.data.lineItems) && 0 < this.data.lineItems.length && (n = this.data.lineItems.map(function(t) {
                        return t.toGooglePayLineItem()
                    }));
                    var i, r, o, a, s = this.data.currencyCode;
                    if (this.data.total) {
                        var c = this.data.total.toGooglePayLineItem();
                        i = c.label, o = c.price, r = c.status
                    }
                    return this.data.shippingOptions && (a = {
                        shippingOptions: this.data.shippingOptions.map(function(t) {
                            return t.toGooglePay(e.data.currencyCode)
                        })
                    }, t && this.data.shippingOptions && this.data.shippingOptions.find(function(e) {
                        return e.id === t
                    }) && (a.defaultSelectedOptionId = t)), {
                        newTransactionInfo: {
                            displayItems: n,
                            currencyCode: s,
                            totalPriceLabel: i,
                            totalPrice: o,
                            totalPriceStatus: r
                        },
                        newShippingOptionParameters: a
                    }
                }
            }, {
                key: "toInstallments",
                value: function() {
                    var t = {
                        currencyCode: this.data.currencyCode,
                        countryCode: this.data.countryCode,
                        total: this.data.total.toInstallmentsLineItem()
                    };
                    return this.data.lineItems ? t.lineItems = this.data.lineItems.map(function(t) {
                        return t.toInstallmentsLineItem()
                    }) : t.lineItems = [], t
                }
            }, {
                key: "validate",
                value: function() {
                    var t = [];
                    return "object" === J(this.data.total) && this.data.total.isValid() || t.push("total"), this.data.lineItems && this.data.lineItems.some(function(e) {
                        if (!e.isValid()) return t.push("lineItems")
                    }), t
                }
            }, {
                key: "toBeacon",
                value: function() {
                    var t = {
                        o: this.data.countryCode,
                        u: this.data.currencyCode,
                        t: this.data.total.toBeacon()
                    };
                    return this.data.lineItems && (t.l = this.data.lineItems.map(function(t) {
                        return t.toBeacon()
                    })), t
                }
            }, {
                key: "currencyCode",
                get: function() {
                    return this.data.currencyCode
                },
                set: function(t) {
                    t && i.a.isValidDataType("currencyCode", X, t, String) && (this.data.currencyCode = t)
                }
            }, {
                key: "countryCode",
                get: function() {
                    return this.data.countryCode
                },
                set: function(t) {
                    t && i.a.isValidDataType("countryCode", X, t, String) && (this.data.countryCode = t)
                }
            }, {
                key: "total",
                get: function() {
                    return this.data.total
                },
                set: function(t) {
                    t && i.a.isValidDataType("total", X, t, Object) && (this.data.total = new k(t))
                }
            }, {
                key: "shippingContact",
                get: function() {
                    return this.data.shippingContact
                },
                set: function(t) {
                    t && i.a.isValidDataType("shippingContact", X, t, Object) && (this.data.shippingContact = new j.a(t))
                }
            }, {
                key: "shippingOptions",
                get: function() {
                    return this.data.shippingOptions
                },
                set: function(t) {
                    t && i.a.isValidDataType("shippingOptions", X, t, Array) && (this.data.shippingOptions = t.map(function(t) {
                        return new x(t)
                    }))
                }
            }, {
                key: "lineItems",
                get: function() {
                    return this.data.lineItems
                },
                set: function(t) {
                    t && i.a.isValidDataType("lineItems", X, t, Array) && (this.data.lineItems = t.map(function(t) {
                        return new k(t)
                    }))
                }
            }, {
                key: "requestShippingAddress",
                get: function() {
                    return this.data.requestShippingAddress
                },
                set: function(t) {
                    null != t && i.a.isValidDataType("requestShippingAddress", X, t, Boolean) && (this.data.requestShippingAddress = t)
                }
            }, {
                key: "requestBillingInfo",
                get: function() {
                    return this.data.requestBillingInfo
                },
                set: function(t) {
                    null != t && i.a.isValidDataType("requestBillingInfo", X, t, Boolean) && (this.data.requestBillingInfo = t)
                }
            }]), t
        }();

    function Q(t) {
        if (this.controller = t, this.options = t.options, this.callbacks = t.callbacks, this.controller.enabledDigitalWallets.includes(u.a.paymentMethods.APPLE_PAY))
            if ("undefined" != typeof ApplePaySession)
                if (this.isConfigValid()) {
                    var e = this;
                    this.applePayVersion = this.getSupportedApplePayVersion(), this.selectedShippingOption = null, this.validityPromise = ApplePaySession.canMakePaymentsWithActiveCard(this.getApplePayMerchantId()).then(function(t) {
                        if (t) {
                            var n = e.options.applePay.elementId;
                            document.getElementById(n).addEventListener("click", e.requestPayment.bind(e)), e.controller.messageHandlers.add(u.a.events.RECEIVE_APPLE_PAY_VALID_MERCHANT, e.receiveApplePayValidMerchant.bind(e)), e.controller.messageHandlers.add(u.a.events.RECEIVE_APPLE_PAY_CARD_NONCE, e.receiveApplePayCardNonce.bind(e)), e.controller.sendEvent(u.a.events.LOAD_WALLET, u.a.paymentMethods.APPLE_PAY), e.controller.enableMethod(u.a.paymentMethods.APPLE_PAY, !0)
                        } else e.controller.enableMethod(u.a.paymentMethods.APPLE_PAY, !1)
                    }).catch(function() {
                        e.controller.enableMethod(u.a.paymentMethods.APPLE_PAY, !1)
                    })
                } else this.controller.enableMethod(u.a.paymentMethods.APPLE_PAY, !1);
        else this.controller.enableMethod(u.a.paymentMethods.APPLE_PAY, !1);
        else this.controller.enableMethod(u.a.paymentMethods.APPLE_PAY, !1)
    }
    Q.prototype.isConfigValid = function() {
        if (!this.options.applePay || "function" != typeof this.callbacks.createPaymentRequest || "function" != typeof this.callbacks.cardNonceResponseReceived) return !1;
        var t = this.options.applePay.elementId;
        if (!document.getElementById(t)) throw new o.a(t);
        if (!this.options.locationId && !this.options.accountId) throw new o.j("locationId");
        var e = new o.o;
        if ("function" == typeof this.callbacks.validateShippingContact) {
            if ("function" == typeof this.callbacks.shippingContactChanged) throw e;
            window.console.error(e.message)
        }
        return !0
    }, Q.prototype.requestPayment = function() {
        if (!this.session) {
            var t = new Z(this.callbacks.createPaymentRequest());
            this.applePayPaymentRequest = t.toApplePay(), t.shippingOptions && (this.selectedShippingOption = t.shippingOptions[0]), this.session = new ApplePaySession(this.applePayVersion, this.applePayPaymentRequest);
            var e = this;
            this.session.onvalidatemerchant = function(t) {
                e.requestApplePayMerchantValidity(t.validationURL, e.applePayPaymentRequest)
            }, "function" == typeof this.callbacks.shippingContactChanged ? this.session.onshippingcontactselected = function(t) {
                e._shippingContactChanged(t.shippingContact, e.applePayPaymentRequest)
            } : "function" == typeof this.callbacks.validateShippingContact && (this.session.onshippingcontactselected = function(t) {
                e._validateShippingContact(t.shippingContact, e.applePayPaymentRequest)
            }), this.session.onshippingmethodselected = function(t) {
                e.selectedShippingOption = x.fromApplePay(t.shippingMethod), e._shippingOptionChanged(e.selectedShippingOption, e.applePayPaymentRequest)
            }, this.session.onpaymentauthorized = function(t) {
                e.requestApplePayCardNonce(t.payment)
            }, this.session.oncancel = function() {
                delete e.session
            }, this.session.begin()
        }
    }, Q.prototype._shippingContactChanged = function(t, e) {
        var n = this,
            i = n.applePayVersion < 3 ? function(t) {
                var i = new G(t);
                n.selectedShippingOption = n.getDefaultShippingOption(i);
                var r = i.toCompleteShippingContactSelectionInputs(e);
                n.updateApplePayPaymentRequest(r), n.session.completeShippingContactSelection(r.status, r.newShippingMethods, r.newTotal, r.newLineItems)
            } : function(t) {
                var i = new G(t);
                n.selectedShippingOption = n.getDefaultShippingOption(i);
                var r = i.toApplePayShippingContactUpdate(e);
                n.updateApplePayPaymentRequest(r), n.session.completeShippingContactSelection(r)
            };
        this.callbacks.shippingContactChanged(j.a.fromApplePay(t), i)
    }, Q.prototype._validateShippingContact = function(t, e) {
        var n = "function" == typeof this.callbacks.validateShippingContact && this.callbacks.validateShippingContact(j.a.legacyFromApplePay(t));
        if (this.applePayVersion < 3) {
            var i = n ? ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS : ApplePaySession.STATUS_SUCCESS;
            this.session.completeShippingContactSelection(i, [], e.total, [])
        } else {
            var r = n ? [new ApplePayError("shippingContactInvalid", "postalAddress", "Incorrect address")] : [];
            this.session.completeShippingContactSelection({
                errors: r,
                newTotal: e.total
            })
        }
    }, Q.prototype._shippingOptionChanged = function(t, e) {
        var n = this,
            i = n.applePayVersion < 3 ? function(t) {
                var i = new G(t).toCompleteShippingMethodSelectionInputs(e);
                n.updateApplePayPaymentRequest(i), n.session.completeShippingMethodSelection(i.status, i.newTotal, i.newLineItems)
            } : function(t) {
                var i = new G(t).toApplePayShippingMethodUpdate(e);
                n.updateApplePayPaymentRequest(i), n.session.completeShippingMethodSelection(i)
            };
        "function" == typeof this.callbacks.shippingOptionChanged ? this.callbacks.shippingOptionChanged(t, i) : i()
    }, Q.prototype.requestApplePayMerchantValidity = function(t, e) {
        var n = e && e.total ? e.total.label : null;
        if (this.options.accountId && !n) throw new o.k;
        this.controller.sendEvent(u.a.events.REQUEST_APPLE_PAY_MERCHANT_VALIDITY, {
            client_id: this.options.applicationId,
            location_id: this.options.locationId,
            account_id: this.options.accountId,
            merchant_name: n,
            validation_url: t,
            source_url: window.location.href
        })
    }, Q.prototype.receiveApplePayValidMerchant = function(t) {
        var e = {
            detail: "Unable to start Apple Pay session."
        };
        if (void 0 !== this.session) {
            if (t.payload.sessionError) return t.payload.error && this.options.errorLogger.capture(Object(o.q)(t.payload.error)), this.callbacks.cardNonceResponseReceived([t.payload.sessionError || e]), void this.session.abort();
            var n;
            if (t.payload.session) try {
                n = JSON.parse(t.payload.session)
            } catch (t) {
                this.options.errorLogger.capture(t)
            }
            n ? this.session.completeMerchantValidation(n) : (this.callbacks.cardNonceResponseReceived([e]), this.session.abort())
        }
    }, Q.prototype.requestApplePayCardNonce = function(t) {
        this.controller.sendEvent(u.a.events.REQUEST_APPLE_PAY_CARD_NONCE, {
            client_id: this.options.applicationId,
            applepay_data: t
        })
    }, Q.prototype.receiveApplePayCardNonce = function(t) {
        var e = t.payload.nonceResponse;
        if (e.errors) return this.session.completePayment(this.session.STATUS_FAILURE), this.controller.callbacks.cardNonceResponseReceived(e.errors), delete this.session, !1;
        this.session.completePayment(this.session.STATUS_SUCCESS);
        var n = j.a.legacyFromApplePay(e.card.contact),
            i = j.a.legacyFromApplePay(e.shipping_contact);
        delete e.card.contact, this.controller.callbacks.cardNonceResponseReceived(null, e.card_nonce, e.card, n, i, this.selectedShippingOption), delete this.session
    }, Q.prototype.getApplePayMerchantId = function() {
        var t = this.options.applicationId,
            e = i.a.getParentLocation().hostname;
        return /(squareupstaging|squareup)\.com$/.test(e) ? t = "merchant.com.squareup.sdktest" : /squareup\.com$/.test(e) && (t = "merchant.com.squareup.sdk"), t
    }, Q.prototype.getSupportedApplePayVersion = function() {
        for (var t = 3; 0 < t && !ApplePaySession.supportsVersion(t);) t--;
        return t
    }, Q.prototype.getDefaultShippingOption = function(t) {
        return t.error || t.shippingContactErrors || !t.shippingOptions ? null : t.shippingOptions[0]
    }, Q.prototype.updateApplePayPaymentRequest = function(t) {
        t.newTotal && (this.applePayPaymentRequest.total = t.newTotal), t.newLineItems && (this.applePayPaymentRequest.lineItems = t.newLineItems), t.newShippingMethods && (this.applePayPaymentRequest.shippingMethods = t.newShippingMethods)
    };
    var $ = Q;

    function tt(t) {
        if (this.controller = t, this.options = t.options, this.controller.enabledDigitalWallets.includes(u.a.paymentMethods.MASTERPASS))
            if (this.options.masterpass && "function" == typeof this.controller.callbacks.createPaymentRequest && "function" == typeof this.controller.callbacks.cardNonceResponseReceived) {
                var e = this.options.masterpass.elementId;
                if (this.element = document.getElementById(e), !this.element) throw new o.a(e);
                this.checkoutId = "", this.cartId = "", this.masterpassWindow = null, this.controller.messageHandlers.add(u.a.events.RECEIVE_MASTERPASS_TRANSACTION, this.receiveTransaction.bind(this)), this.controller.messageHandlers.add(u.a.events.SET_MASTERPASS_CHECKOUT_ID, this.setCheckoutId.bind(this)), this.controller.sendEvent(u.a.events.LOAD_WALLET, u.a.paymentMethods.MASTERPASS)
            } else this.controller.enableMethod(u.a.paymentMethods.MASTERPASS, !1);
        else this.controller.enableMethod(u.a.paymentMethods.MASTERPASS, !1)
    }
    tt.prototype.setCheckoutId = function(t) {
        this.checkoutId = t.checkoutId, this.element.addEventListener("click", this._requestPayment.bind(this)), this.controller.enableMethod(u.a.paymentMethods.MASTERPASS, !0)
    }, tt.prototype._requestPayment = function() {
        if (!this.masterpassWindow || this.masterpassWindow.closed) {
            var t = this.controller.callbacks.createPaymentRequest();
            this.cartId = i.a.guid();
            var e = window.screen.width / 2 - 510,
                n = window.screen.height / 2 - 450;
            this.masterpassWindow = window.open("", "Masterpass", "width=1000,height=800,left=" + e + ",top=" + n + ",screenX=" + e + ",screenY=" + n + ",toolbar=no,menubar=no,scrollbars=no,location=yes,directories=no");
            var r = this.masterpassWindow.document;
            this._buildWindowContent(t, r)
        } else this.masterpassWindow.focus()
    }, tt.prototype._buildWindowContent = function(t, e) {
        var n = t.total.amount,
            r = t.currencyCode,
            o = i.a.url("https://pci-connect.squareup.com/v2/masterpass/callback", {
                "formId": this.controller.formId
            }),
            a = {
                checkoutId: this.checkoutId,
                allowedCardTypes: ["visa", "masterCard", "discover", "amex"],
                amount: n,
                currency: r,
                suppress3Ds: !1,
                suppressShippingAddress: !t.requestShippingAddress,
                cartId: this.cartId,
                callbackUrl: o
            },
            s = e.createElement("script");
        s.setAttribute("type", "text/javascript"), s.innerText = "function start() { masterpass.checkout(".concat(JSON.stringify(a), "); }");
        var c = e.createElement("script");
        c.setAttribute("type", "text/javascript"), c.setAttribute("src", "https://sandbox.static.masterpass.com/integration/merchant.js"), c.setAttribute("onload", "start()");
        var l = e.createElement("body");
        l.appendChild(s), l.appendChild(c), e.body = l
    }, tt.prototype.receiveTransaction = function(t) {
        this.masterpassWindow && (this.masterpassWindow.close(), this.masterpassWindow = null);
        var e = t.payload;
        if ("success" !== e.status) return !1;
        this.controller.sendEvent(u.a.events.REQUEST_MASTERPASS_CARD_NONCE, {
            client_id: this.options.applicationId,
            masterpass_data: {
                transaction_id: e.transactionId,
                cart_id: this.cartId
            }
        })
    };
    var et = tt,
        nt = (n(73), "installments"),
        it = {
            CHECKOUT: "checkout",
            CART: "cart",
            PRODUCT_DETAIL: "productDetail"
        },
        rt = "VALIDATION_ERROR",
        ot = "Error loading Capital JS",
        at = {
            INSTALLMENTS_APPLICATION_INELIGIBLE: {
                type: "INSTALLMENTS_APPLICATION_INELIGIBLE",
                message: "The merchant or this transaction is not eligible for Installments"
            },
            INSTALLMENTS_APPLICATION_DECLINED: {
                type: "INSTALLMENTS_APPLICATION_DECLINED",
                message: "The buyer Installments application was declined"
            },
            INSTALLMENTS_APPLICATION_CANCELLED: {
                type: "INSTALLMENTS_APPLICATION_CANCELLED",
                message: "The buyer cancelled the Installments application"
            },
            PAYMENT_DETAILS_UPDATE_INVALID: {
                type: "PAYMENT_DETAILS_UPDATE_INVALID",
                message: "The payment details update object provided is invalid"
            },
            INSTALLMENTS_NOT_READY: {
                type: "INSTALLMENTS_NOT_READY",
                message: "Installments has not finished loading"
            },
            UNKNOWN: {
                type: "UNKNOWN",
                message: "An unknown error has occurred"
            }
        };

    function st(t) {
        this.eventstream = t
    }
    st.prototype.collectApplicationResult = function(t) {
        var e = {
            r: {
                s: t.status,
                o: void 0
            }
        };
        t.paymentOption && (e.r.o = {
            m: t.paymentOption.months,
            p: {
                a: t.paymentOption.payment.amount,
                c: t.paymentOption.payment.currency
            }
        }), this.eventstream.track(U.a.INSTALLMENTS_APPLICATION_RESULT_EVENT, e)
    }, st.prototype.collectConfiguration = function(t) {
        var e = {
            i: {
                m: t.modalType,
                c: t.isCustom,
                p: t.paymentRequest
            }
        };
        this.eventstream.track(U.a.INSTALLMENTS_CONFIG_EVENT, e)
    }, st.prototype.collectShowModalData = function(t) {
        var e = {
            m: {
                m: t.modalType,
                i: t.isShown,
                e: t.error
            }
        };
        this.eventstream.track(U.a.INSTALLMENTS_SHOW_MODAL_EVENT, e)
    };
    var ct = st;

    function lt(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = n, t
    }

    function ut(t) {
        this.controller = t, this.options = t.options, this.callbacks = t.callbacks, this.eventstream = t.eventstream, this.installmentsEventstream = new ct(this.eventstream), this._validateOptions() && this._fetchInstallmentsPayJs()
    }
    ut.prototype._validateOptions = function() {
        if (!this.options.installments || "function" != typeof this.callbacks.createPaymentRequest || "function" != typeof this.callbacks.cardNonceResponseReceived) return this._enableInstallmentsMethod(!1, "Installments initialized incorrectly"), !1;
        if (!this.options.locationId) throw new o.j("locationId");
        if (this.modalType = this.options.installments.modalType || it.CHECKOUT, !Object.values(it).includes(this.modalType)) throw new o.h("installments.modalType");
        return !0
    }, ut.prototype._fetchInstallmentsPayJs = function() {
        var t = this,
            e = document.createElement("script");
        e.onload = this._installmentsPayJsFetched.bind(this), e.onerror = function() {
            t._enableInstallmentsMethod(!1, ot)
        }, e.src = "https://installments-ad-production-f.squarecdn.com/production/capital-installments-production-0.2.1.js", e.integrity = "sha256-8FKXoWT6A5o1q1wEhfFuqyH4BW9BH4g/tdzTN754Bfs= sha384-6OPJ1kGuRn1sxd4oCpbjTGD32Z1DgfmzrHzUxjAzJcX2NhjpI6nvL2KOWtiFGDFi sha512-GzISd3eYgRUkFPTMCiheFQxNbckf2gcI3+xn7TZEU7KjvngCFsAqitMPHZporqi7P9nyyWMl5wVNp2MBuCoCGw==", e.crossOrigin = "anonymous", document.body.appendChild(e)
    }, ut.prototype._installmentsPayJsFetched = function() {
        "undefined" != typeof CapitalInstallments ? this._enableInstallments() : this._enableInstallmentsMethod(!1, ot)
    }, ut.prototype._enableInstallments = function() {
        var t, e, n = this,
            r = new Z(this.callbacks.createPaymentRequest()),
            o = (e = (t = r).validate(), "US" === t.countryCode || e.includes("countryCode") || e.push("countryCode"), "USD" === t.currencyCode || e.includes("currencyCode") || e.push("currencyCode"), e);
        if (0 < o.length) return i.a.logInvalidFieldsError("PaymentRequest", o), void this._enableInstallmentsMethod(!1, "The payment request object provided is invalid");
        var a = r.toInstallments();
        this.installmentsEventstream.collectConfiguration({
            modalType: this.modalType,
            isCustom: !0,
            paymentRequest: r.toBeacon()
        });
        try {
            this.capitalClient = new CapitalInstallments({
                applicationId: this.options.applicationId,
                locationId: this.options.locationId,
                sessionId: this.eventstream.sessionId,
                config: {
                    modalType: this.modalType
                },
                paymentRequest: a,
                onNonceResponse: this._nonceResponseReceived.bind(this)
            })
        } catch (t) {
            if (this._enableInstallmentsMethod(!1, "Error initializing Capital JS"), t.type === rt) {
                var s = [];
                t.validationErrors.forEach(function(t) {
                    var e = t.attribute.split(".");
                    "paymentRequest" === e[0] && 2 === e.length && s.push(e[1])
                }), 0 < s.length && i.a.logInvalidFieldsError("PaymentRequest", s)
            }
            return
        }
        this.capitalClient.load(), this.capitalClient.checkMerchantEligibility().then(function(t) {
            t.success ? n._enableInstallmentsMethod(!0, "Merchant eligible for Installments") : n._enableInstallmentsMethod(!1, "Merchant is not eligible for Installments")
        }).catch(function() {
            n._enableInstallmentsMethod(!1, "unknown")
        })
    }, ut.prototype.updatePaymentDetails = function(t, e) {
        if (this.capitalClient) {
            var n = new G(t),
                r = n.validate();
            if (0 < r.length) return i.a.logInvalidFieldsError("PaymentDetailsUpdate", r), void e([at.PAYMENT_DETAILS_UPDATE_INVALID], !1);
            var o = n.toInstallments();
            this.capitalClient.updatePaymentRequest(o).then(function(t) {
                t.eligible ? e(null, !0) : e([at.INSTALLMENTS_APPLICATION_INELIGIBLE], !1)
            }).catch(function(t) {
                switch (t.type) {
                    case rt:
                        return void e([at.PAYMENT_DETAILS_UPDATE_INVALID], !1);
                    default:
                        return void e([at.UNKNOWN], !1)
                }
            })
        } else e([at.INSTALLMENTS_NOT_READY], !1)
    }, ut.prototype.getInstallmentsPricing = function(t) {
        this.capitalClient ? this.capitalClient.getPricing().then(function(e) {
            t(null, e)
        }).catch(function(e) {
            "FINANCING_NOT_AVAILABLE" !== e.type ? t([at.UNKNOWN]) : t([at.INSTALLMENTS_APPLICATION_INELIGIBLE])
        }) : t([at.INSTALLMENTS_NOT_READY])
    }, ut.prototype.showInstallmentsModal = function() {
        var t = this;
        if (!this.capitalClient) {
            var e = at.INSTALLMENTS_NOT_READY;
            return this._sendInstallmentsShowModalData(!1, e.type), void this.callbacks.cardNonceResponseReceived([e])
        }
        var n = this;
        this.capitalClient.showModal().then(function() {
            n._sendInstallmentsShowModalData(!0)
        }).catch(function(e) {
            if ("MERCHANT_NOT_ELIGIBLE" === e.type) {
                var i = at.INSTALLMENTS_APPLICATION_INELIGIBLE;
                return n._sendInstallmentsShowModalData(!1, i.type), void t.callbacks.cardNonceResponseReceived([i])
            }
            t.callbacks.cardNonceResponseReceived([at.UNKNOWN])
        })
    }, ut.prototype._sendInstallmentsShowModalData = function(t, e) {
        var n = {
            modalType: this.modalType,
            isShown: t,
            err: e
        };
        this.installmentsEventstream.collectShowModalData(n)
    }, ut.prototype._nonceResponseReceived = function(t, e) {
        var n;
        if (t) return this.callbacks.cardNonceResponseReceived([at.UNKNOWN]), this.installmentsEventstream.collectApplicationResult({
            status: at.UNKNOWN.type
        }), void this.options.errorLogger.capture({
            name: "UnknownInstallmentsResultError",
            message: t
        });
        if ("COMPLETED" === e.status) return this.callbacks.cardNonceResponseReceived(null, e.nonce, {
            paymentOption: e.paymentOption
        }), void this.installmentsEventstream.collectApplicationResult({
            status: e.status,
            paymentOption: e.paymentOption
        });
        var i = (lt(n = {}, "DENIED", at.INSTALLMENTS_APPLICATION_DECLINED), lt(n, "CANCELLED", at.INSTALLMENTS_APPLICATION_CANCELLED), n);
        this.callbacks.cardNonceResponseReceived([i[e.status] || at.UNKNOWN]), this.installmentsEventstream.collectApplicationResult({
            status: i[e.status] ? e.status : at.UNKNOWN.type
        })
    }, ut.prototype._enableInstallmentsMethod = function(t, e) {
        this.controller.enableMethod(nt, t, e)
    };
    var pt = ut,
        dt = {
            calculate: function(t) {
                if (this._ready()) {
                    var e = t.applicationId,
                        n = t.websiteUrl,
                        i = t.done;
                    new Square.Analytics(e).getToken(i, {
                        websiteUrl: n
                    })
                } else this._install(t)
            },
            _handleLoad: function(t) {
                if (!this._ready()) return t.done();
                this.calculate(t)
            },
            _install: function(t) {
                if (!this._ready()) {
                    var e = document.createElement("script"),
                        n = this._handleLoad.bind(this, t);
                    e.addEventListener("load", n, !1), e.addEventListener("error", n, !1), e.src = "https://js.squareup.com/payments/analytics.js", document.body.appendChild(e)
                }
            },
            _ready: function() {
                return "undefined" != typeof Square && void 0 !== Square.Analytics
            }
        };

    function ht(t) {
        return (ht = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function ft(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = n, t
    }
    var yt = "https://pci-connect.squareup.com",
        mt = u.a.paymentMethods.KEYED_CARD,
        vt = u.a.paymentMethods.GIFT_CARD,
        gt = u.a.paymentMethods.SINGLE_CARD_ELEMENT;

    function Et(t) {
        this.options = t, this.applicationId = t.applicationId, this.locationId = t.locationId, this.accountId = t.accountId, this.callbacks = t.callbacks, this.apiWrapper = t.apiWrapper, this.websiteUrl = t.websiteUrl, this.errorLogger = t.errorLogger, this.eventstream = this.options.eventstream, this.telemetry = new m.a(this.eventstream), this._initialize(t)
    }

    function _t() {
        var t = window.location;
        if (t.origin) return t.origin;
        if (t.protocol && t.host) return t.protocol + "//" + t.host;
        throw new o.i("Error accessing the current origin.")
    }
    Et.DIGITAL_WALLETS = {
        applePay: $,
        googlePay: K,
        masterpass: et,
        installments: pt
    }, Et.prototype._initialize = function(t) {
        this.formId = "sq-" + i.a.guid(), this.messageBuffer = [], this.messageHandlers = new p.a, this._paymentMethods = {}, this.expectedPaymentMethods = t.expectedPaymentMethods, this.inputs = t.inputs, this.inputStyles = t.inputStyles, this.autoFill = "boolean" != typeof t.autoFill || t.autoFill, this.loadedWallets = {}, this.digitalWallets = {}, this.expectedPaymentMethods.includes(vt) || (this.digitalWallets = Object.assign({}, Et.DIGITAL_WALLETS))
    }, Et.prototype.paymentMethod = function(t) {
        if (this._paymentMethods[t]) return this._paymentMethods[t]
    }, Et.prototype.build = function() {
        var t = this;
        void 0 === this._buildAt && (this._buildAt = Date.now(), this.mainIframe = this.createMainIframe(function() {
            return t.mainIframeLoaded()
        }), this._requestAnalyticsToken())
    }, Et.prototype.createMainIframe = function(t) {
        var e = {
            accountId: this.accountId,
            applicationId: this.applicationId,
            locationId: this.locationId,
            formId: this.formId,
            targetOriginURL: yt,
            onload: t
        };
        return new y(e)
    }, Et.prototype._requestAnalyticsToken = function() {
        dt.calculate({
            applicationId: this.applicationId,
            websiteUrl: this.websiteUrl,
            done: this._analyticsTokenReceived.bind(this)
        })
    }, Et.prototype._analyticsTokenReceived = function(t) {
        this.sendIframeMessage({
            eventName: u.a.events.SET_ANALYTICS_TOKEN,
            token: t,
            options: {
                hostOrigin: _t()
            }
        })
    }, Et.prototype.initializePaymentMethod = function(t) {
        var e, n = (ft(e = {}, gt, N), ft(e, vt, v), ft(e, mt, v), e),
            i = Object.assign({}, this.options);
        i.onload = this.loadFormController.bind(this), i.sendMessage = this.sendIframeMessage.bind(this), i.messageHandlers = this.messageHandlers;
        var r = new n[t](i);
        r.build(), this._paymentMethods[t] = r
    }, Et.prototype.mainIframeLoaded = function() {
        this.expectedPaymentMethods.includes(gt) ? this.initializePaymentMethod(gt) : this.expectedPaymentMethods.includes(mt) ? this.initializePaymentMethod(mt) : this.expectedPaymentMethods.includes(vt) ? this.initializePaymentMethod(vt) : this.loadFormController()
    }, Et.prototype.pluginShim = function() {
        var t = this;
        return {
            options: this.options,
            formId: this.formId,
            enabledDigitalWallets: this.enabledDigitalWallets || "",
            callbacks: this.callbacks,
            messageHandlers: this.messageHandlers,
            enableMethod: this.enableMethod.bind(this),
            sendEvent: function(e, n) {
                t.sendIframeMessage({
                    eventName: e,
                    payload: n
                })
            },
            errorLogger: this.errorLogger,
            eventstream: this.eventstream
        }
    }, Et.prototype.enableMethod = function(t, e) {
        var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : "",
            i = {};
        (i[t] = e) || delete this.loadedWallets[t], this.callbacks && "function" == typeof this.callbacks.methodsSupported && this.callbacks.methodsSupported(i), this._collectMethodsSupportedData({
            type: t,
            isSupported: e,
            reason: n
        })
    }, Et.prototype._collectMethodsSupportedData = function(t) {
        var e = {
            p: {
                t: t.type,
                s: t.isSupported,
                r: t.reason
            }
        };
        this.eventstream.track(U.a.METHODS_SUPPORTED_EVENT, e)
    }, Et.prototype.buildStylesForScreenWidth = function() {
        var t = this.paymentMethod(mt);
        t && t._buildStylesForScreenWidth()
    }, Et.prototype.destroy = function() {
        for (var t in this.removePostMessageEventListeners(), this.mainIframe && (this.mainIframe.destroy(), delete this.mainIframe), this._paymentMethods) i.a.hasOwn(this._paymentMethods, t) && (this._paymentMethods[t].destroy(), delete this._paymentMethods[t])
    }, Et.prototype.receiveMessageCallback = function(t) {
        if (t.origin === yt && t.data.formId === this.formId) {
            switch (t.data.eventName) {
                case u.a.events.CARD_NONCE_RESPONSE_RECEIVED:
                    if (!t.data.value.errors && !t.data.value.card_nonce) return this.errorLogger.capture(Error("errors and card_nonce are both null")), void this._cardNonceResponseReceived({
                        type: "UNKNOWN",
                        message: "An unknown error has occurred"
                    }, null, null);
                    this._cardNonceResponseReceived(t.data.value.errors, t.data.value.card_nonce, t.data.value.card, t.data.value.billing_contact, t.data.value.shipping_contact);
                    break;
                case u.a.events.PAYMENT_FORM_LOADED:
                    this._loadedAt = Date.now(), this.sessionId = t.data.sessionId, this.eventstream.sessionId = this.sessionId, this.enabledDigitalWallets = t.data.enabledDigitalWallets;
                    var e = this.pluginShim();
                    for (var n in this.digitalWallets) i.a.hasOwn(this.digitalWallets, n) && (this.loadedWallets[n] = new this.digitalWallets[n](e));
                    var r = this._loadedAt - this._buildAt;
                    this.telemetry.collectLoadTiming({
                        tti: r
                    });
                    var o = Object.assign({}, this.options);
                    for (delete o.errorLogger, delete o.eventstream, delete o.expectedPaymentMethods, delete o.inputs, this.telemetry.collectConfiguration(o), this.options.callbacks && "function" == typeof this.options.callbacks.paymentFormLoaded && this.options.callbacks.paymentFormLoaded(); 0 < this.messageBuffer.length;) this.sendIframeMessage(this.messageBuffer.pop())
            }
            this.messageHandlers.handle(t.data.eventName, t.data)
        }
    }, Et.prototype.addPostMessageEventListeners = function() {
        this._messageCallback = this.receiveMessageCallback.bind(this), window.addEventListener("message", this._messageCallback)
    }, Et.prototype.removePostMessageEventListeners = function() {
        window.removeEventListener("message", this._messageCallback)
    }, Et.prototype.sendIframeMessage = function(t) {
        if (t.formId = this.formId, this.mainIframe && this.mainIframe.ready) return this.mainIframe.window ? void this.mainIframe.send(t) : void window.console.warn(new o.c("main"));
        this.messageBuffer.push(t)
    }, Et.prototype.loadFormController = function() {
        var t = {
                version: "86785379ba",
                hostOrigin: _t(),
                applicationId: this.applicationId,
                locationId: this.locationId,
                accountId: this.accountId,
                apiWrapper: this.apiWrapper,
                websiteUrl: this.websiteUrl,
                expectedPaymentMethods: this.expectedPaymentMethods,
                googlePayTokenUrl: document.location.href
            },
            e = this.paymentMethod(vt),
            n = this.paymentMethod(mt),
            i = this.paymentMethod(gt);
        i ? t[gt] = {
            autoFill: this.options[gt].autoFill,
            iframeName: i.iframeName,
            inputStyle: this.options[gt].inputStyle,
            initialScreenWidth: window.innerWidth
        } : (e || n) && (t.keyedCard = {
            autoFill: this.autoFill,
            iframeNames: (e || n).iframeNames,
            inputStyles: this.inputStyles,
            initialScreenWidth: window.innerWidth,
            inputs: this.inputs
        });
        var r = {
            eventName: u.a.events.LOAD_FORM_CONTROLLER,
            options: t
        };
        this.addPostMessageEventListeners(), this.sendIframeMessage(r)
    }, Et.prototype.requestCardNonceIfValidForm = function() {
        if (this._pending) {
            var t = new o.l;
            return this.errorLogger.capture(t), void window.console.error(t)
        }
        this._pending = !0, this.sendIframeMessage({
            eventName: u.a.events.REQUEST_CARD_NONCE_IF_VALID_FORM
        })
    }, Et.prototype._cardNonceResponseReceived = function() {
        if (this._pending = !1, this.callbacks && "function" == typeof this.callbacks.cardNonceResponseReceived) {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            this.callbacks.cardNonceResponseReceived.apply(null, e)
        }
    }, Et.prototype.setPostalCode = function(t) {
        var e = ht(t);
        "string" !== e && "number" !== e || this.sendIframeMessage({
            eventName: u.a.events.SET_POSTAL_CODE,
            postalCode: "" + t
        })
    }, Et.prototype.hasLoaded = function() {
        return !!this._loadedAt
    }, Et.prototype.getInstallmentsPricing = function(t) {
        var e = this.loadedWallets.installments;
        e ? e.getInstallmentsPricing(t) : t([at.INSTALLMENTS_APPLICATION_INELIGIBLE])
    }, Et.prototype.showInstallmentsModal = function() {
        var t = this.loadedWallets.installments;
        t ? t.showInstallmentsModal() : this.callbacks.cardNonceResponseReceived([at.INSTALLMENTS_APPLICATION_INELIGIBLE])
    }, Et.prototype.updatePaymentDetails = function(t, e) {
        var n = this.loadedWallets.installments;
        n ? n.updatePaymentDetails(t, e) : e([at.INSTALLMENTS_APPLICATION_INELIGIBLE], !1)
    };
    var bt = Et;

    function St(t) {
        return (St = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function It(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function Ct(t, e) {
        for (var n = 0; n < e.length; n++) {
            var i = e[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
        }
    }

    function wt(t, e, n) {
        return e && Ct(t.prototype, e), n && Ct(t, n), t
    }
    n(47);
    var Pt = function() {
            function t(e) {
                It(this, t), e && "object" === St(e) || (e = {}), this._applicationId = e.applicationId, this._locationId = e.locationId, this._accountId = e.accountId
            }
            return wt(t, [{
                key: "verifyBuyer",
                value: function(t, e, n) {
                    var i = new Tt(this._applicationId, this._accountId, this._locationId, t, e),
                        r = this._generateToken(i);
                    r ? n(null, new At(r)) : n(new o.n("Unable to generate token."))
                }
            }, {
                key: "_generateToken",
                value: function(t) {
                    var e = "".concat(t._locationId, "-fake-verification-token-").concat(Date.now());
                    return this._base64encode(e.replace(/-/g, "")).replace(/=/g, "")
                }
            }, {
                key: "_base64encode",
                value: function(t) {
                    return window.btoa("" + t)
                }
            }]), t
        }(),
        At = function() {
            function t(e) {
                It(this, t), this._token = e
            }
            return wt(t, [{
                key: "toString",
                value: function() {
                    return this._token
                }
            }, {
                key: "token",
                get: function() {
                    return this._token
                }
            }, {
                key: "userChallenged",
                get: function() {
                    return !1
                }
            }]), t
        }(),
        Tt = function() {
            function t(e, n, i, r, o) {
                It(this, t), this.applicationId = e, this.accountId = n, this.locationId = i, this.source = r, this.details = o
            }
            return wt(t, [{
                key: "toJSON",
                value: function() {
                    return JSON.stringify({
                        applicationId: this.applicationId,
                        accountId: this.accountId,
                        locationId: this.locationId,
                        source: this.source,
                        details: this.details
                    })
                }
            }]), t
        }();

    function Ot(t) {
        return (Ot = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function Nt(t) {
        this.options = t;
        try {
            this._initialize()
        } catch (t) {
            throw this.eventstream.track(U.a.GENERAL_EVENT, Dt(t)), t
        }
    }

    function Lt(t, e) {
        var n = new o.p.FormNotReadyError(e);
        return t.errorLogger && "function" == typeof t.errorLogger.capture && t.errorLogger.capture(n), n
    }

    function Rt(t) {
        return t.clientController && t.clientController.hasLoaded()
    }
    Nt.prototype._initialize = function() {
        if (this.eventstream = new U.b({
                applicationId: this.options && this.options.applicationId,
                locationId: this.options && this.options.locationId,
                accountId: this.options && this.options.accountId,
                apiWrapper: this.options && this.options.apiWrapper
            }), this.eventstream.track(U.a.GENERAL_EVENT, Ft()), this.errorLogger = new c({
                applicationId: this.options && this.options.applicationId,
                apiWrapper: this.options && this.options.apiWrapper,
                captureUncaughtExceptions: !1,
                source: "SqPaymentForm"
            }), !i.a.embeddingAllowed(window.location)) {
            var t = new o.p.HttpsRequiredError;
            throw this.errorLogger.capture(t), t
        }
        var e = this.validateOptions(this.options);
        if (e) throw this.errorLogger.capture(e), e;
        var n = Object.assign({}, this.options, {
            errorLogger: this.errorLogger,
            eventstream: this.eventstream,
            expectedPaymentMethods: this._detectPaymentMethods(this.options)
        });
        this.clientController = new bt(n), !1 !== this.options.autoBuild && this._attachLoadListener(), this.eventstream.track(U.a.GENERAL_EVENT, xt())
    }, Nt.isSupportedBrowser = l.a.supported.bind(null), Nt.prototype._attachLoadListener = function() {
        this._handleDomContentLoaded = this.build.bind(this), l.a.ie10() ? window.addEventListener("load", this._handleDomContentLoaded) : "loading" === document.readyState && document.addEventListener("DOMContentLoaded", this._handleDomContentLoaded)
    }, Nt.prototype.build = function() {
        if (this.detachLoadEvent(), this.build = function() {
                var t = new o.p.FormAlreadyBuiltError;
                throw this.errorLogger.capture(t), t
            }, !Nt.isSupportedBrowser()) return this.errorLogger.capture(new o.p.UnsupportedBrowserError), void(this.options.callbacks && "function" == typeof this.options.callbacks.unsupportedBrowserDetected && this.options.callbacks.unsupportedBrowserDetected());
        try {
            this.clientController.build()
        } catch (t) {
            throw this.errorLogger.capture(t), t
        }
        this.eventstream.track(U.a.GENERAL_EVENT, qt(this.options.autoBuild))
    }, Nt.prototype.destroy = function() {
        var t = this;
        this.detachLoadEvent(), this.clientController && (this.clientController.destroy(), this.clientController = null), this.errorLogger.destroy(), this.errorLogger = null, ["build", "destroy", "focus", "getInstallmentsPricing", "recalculateSize", "requestCardNonce", "setPostalCode", "showInstallmentsModal", "updatePaymentRequest"].forEach(function(e) {
            t[e] = function() {
                throw new o.p.FormAlreadyDestroyedError(e)
            }
        })
    }, Nt.prototype.requestCardNonce = function() {
        if (Mt(this, "requestCardNonce"), 0 === this.clientController.expectedPaymentMethods.length) {
            var t = new o.p.MissingPaymentMethodError;
            throw this.errorLogger.capture(t), t
        }
        this.clientController.requestCardNonceIfValidForm()
    }, Nt.prototype.recalculateSize = function() {
        kt(this, "recalculateSize") && this.clientController.buildStylesForScreenWidth()
    }, Nt.prototype.setPostalCode = function(t) {
        kt(this, "setPostalCode") && this.clientController.setPostalCode(t)
    }, Nt.prototype.focus = function(t) {
        Mt(this, "focus");
        var e = this.clientController.paymentMethod(u.a.paymentMethods.KEYED_CARD);
        e && e.focus(t)
    }, Nt.prototype.getInstallmentsPricing = function(t) {
        if (Mt(this, "getInstallmentsPricing"), "function" != typeof t) {
            var e = new o.p.InvalidFunctionArgumentError("getInstallmentsPricing");
            throw this.errorLogger.capture(e), e
        }
        this.clientController.getInstallmentsPricing(t)
    }, Nt.prototype.updatePaymentRequest = function(t, e) {
        if (Mt(this, "updatePaymentRequest"), !t || "object" !== Ot(t) || "function" != typeof e) {
            var n = new o.p.InvalidFunctionArgumentError("updatePaymentRequest");
            throw this.errorLogger.capture(n), n
        }
        this.clientController.updatePaymentDetails(t, e)
    }, Nt.prototype.showInstallmentsModal = function() {
        Mt(this, "showInstallmentsModal"), this.clientController.showInstallmentsModal()
    }, Nt.prototype.verifyBuyer = function(t, e, n) {
        var i = this;
        if (this._trackVerificationRequested(), !this.options.locationId && !this.options.accountId) throw this._trackVerificationError("No location id given"), new TypeError("`locationId` is required");
        if (!t || "string" != typeof t) throw this._trackVerificationError("Invalid source"), new TypeError("`source` is required and must be a string");
        if (e && "object" === Ot(e) || (this._trackVerificationError("Invalid verification details"), new TypeError("`verificationDetails` is required and must be an object")), "function" != typeof n) throw this._trackVerificationError("Invalid callback"), new TypeError("`callback` is required and must be a function");
        e = this._validateVerificationDetails(e), new Pt({
            applicationId: this.applicationId,
            locationId: this.locationId,
            accountId: this.accountId
        }).verifyBuyer(t, e, function(t, e) {
            t && i._trackVerificationError(t.message), e ? i._trackVerificationSuccess() : i._trackVerificationError("No token generated"), n(t, e)
        })
    }, Nt.prototype._validateVerificationDetails = function(t) {
        var e = Ot(t.intent);
        if ("undefined" === e ? t.intent = "CHARGE" : "string" === e && (t.intent = t.intent.toUpperCase()), "CHARGE" !== t.intent && "STORE" !== t.intent) throw this._trackVerificationError("Invalid intent value"), new TypeError('`verificationDetails.intent` must be one of "CHARGE" or "STORE"');
        var n = Ot(t.amount),
            i = Ot(t.currencyCode);
        if ("STORE" === t.intent) {
            if ("undefined" !== n) throw this._trackVerificationError("Unnececessary amount given for STORE"), new TypeError('`verificationDetails.amount` is not necessary when `intent` is "STORE"');
            if ("undefined" !== i) throw this._trackVerificationError("Unnececessary currencyCode given for STORE"), new TypeError('`verificationDetails.currencyCode` is not necessary when `intent` is "STORE"')
        }
        if ("CHARGE" === t.intent) {
            if ("string" !== n) throw this._trackVerificationError("Invalid amount type"), new TypeError('`verificationDetails.amount` is required and must be a string representation of a number. Eg, "17.00"');
            if (isNaN(parseFloat(t.amount))) throw this._trackVerificationError("Invalid amount value"), new TypeError('`verificationDetails.amount` is required and must be a string representation of a number. Eg, "17.00"');
            if ("string" !== i) throw this._trackVerificationError("Invalid currencyCode type"), new TypeError('`verificationDetails.currencyCode` is required and must be an ISO 4217 currency code. Eg., "USD"');
            if (!/^[a-z]{3}$/i.test(t.currencyCode)) throw this._trackVerificationError("Invalid currencyCode value"), new TypeError('`verificationDetails.currencyCode` is required and must be an ISO 4217 currency code. Eg., "USD"')
        }
        if (!t.billingContact || "object" !== Ot(t.billingContact)) throw this._trackVerificationError("billingContact not given"), new TypeError("`verificationDetails.billingContact` is required and must be an object");
        return t.billingContact = new j.a(t.billingContact), t
    }, Nt.prototype._trackVerificationEvent = function(t, e) {
        var n = {
            g: {
                a: t,
                d: e
            }
        };
        this.eventstream.track(U.a.GENERAL_EVENT, n)
    }, Nt.prototype._trackVerificationError = function(t) {
        this._trackVerificationEvent("VERIFICATION:ERROR", t)
    }, Nt.prototype._trackVerificationSuccess = function() {
        this._trackVerificationEvent("VERIFICATION:SUCCESS")
    }, Nt.prototype._trackVerificationRequested = function() {
        this._trackVerificationEvent("VERIFICATION:REQUESTED")
    }, Nt.prototype.detachLoadEvent = function() {
        this._handleDomContentLoaded && (window.removeEventListener("load", this._handleDomContentLoaded), document.removeEventListener("DOMContentLoaded", this._handleDomContentLoaded), this._handleDomContentLoaded = null)
    }, Nt.prototype.validateOptions = function(t) {
        return this._validateCoreOptions(t) || this._validatePaymentMethodOptions(t)
    }, Nt.prototype._validateCoreOptions = function(t) {
        if (!t) return new o.p.MissingArgumentError("options");
        if ("[object Object]" !== Object.prototype.toString.call(t)) return new o.p.InvalidArgumentError("options", "object");
        if (!t.applicationId) return new o.p.MissingOptionError("applicationId");
        if (void 0 !== t.autoBuild && "boolean" != typeof t.autoBuild) return new o.p.InvalidOptionType("autoBuild");
        if (t.locationId && t.accountId) throw new o.p.TooManyIdsError;
        0 === t.applicationId.indexOf("sandbox-") && window.console.info("SqPaymentForm initialized in Sandbox Mode. See https://docs.connect.squareup.com/articles/using-sandbox/")
    }, Nt.prototype._validatePaymentMethodOptions = function(t) {
        var e = this,
            n = this._detectPaymentMethods(t),
            r = [u.a.paymentMethods.GIFT_CARD, u.a.paymentMethods.SINGLE_CARD_ELEMENT],
            a = n.includes(u.a.paymentMethods.KEYED_CARD),
            s = n.includes(u.a.paymentMethods.SINGLE_CARD_ELEMENT),
            c = n.includes(u.a.paymentMethods.GIFT_CARD),
            l = null;
        if (r.forEach(function(i) {
                if (n.includes(i) && 1 < n.length) {
                    var r = a ? e._detectKeyedCardInputs(t)[0] : n.splice(n.indexOf(r), 1)[0];
                    l = new o.p.UnexpectedInputTypeError(r)
                }
            }), l) return l;
        if (t.inputs = {}, s) t.inputs.singleCardElement = t.card;
        else if (c) t.inputs.giftCard = t.giftCard;
        else if (a) {
            var p = Object.assign({}, u.a.inputTypes);
            for (var d in delete p.GIFT_CARD, delete p.SINGLE_CARD_ELEMENT, p)
                if (i.a.hasOwn(p, d)) {
                    var h = p[d],
                        f = this.validateInputType(h, t);
                    if (f) return f;
                    t.inputs[h] = t[h]
                }! 1 === t[u.a.inputTypes.POSTAL_CODE] && delete t.inputs[u.a.inputTypes.POSTAL_CODE]
        }
        if (c || a) {
            if (!t.inputClass) return new o.p.MissingOptionError("inputClass");
            if (-1 !== t.inputClass.indexOf(" ")) return new o.p.InvalidOptionError("inputClass")
        }
        if (t.inputStyles && !Array.isArray(t.inputStyles)) return new o.p.InvalidInputStylesError;
        if (void 0 !== t.autoFill && "boolean" != typeof t.autoFill) return new o.p.InvalidOptionType("autoFill");
        if (0 < n.length) {
            if (!t.callbacks) return new o.p.MissingOptionError("callbacks");
            if (!t.callbacks.cardNonceResponseReceived) return new o.p.MissingCallbackError("cardNonceResponseReceived");
            if ("function" != typeof t.callbacks.cardNonceResponseReceived) return new o.p.InvalidCallbackError("cardNonceResponseReceived")
        }
        if (0 === n.length && window.console.info("SqPaymentForm initialized without a payment method. See: ".concat("https://docs.connect.squareup.com/api/paymentform#paymentform-configurationfields")), n.includes(u.a.paymentMethods.APPLE_PAY) || n.includes(u.a.paymentMethods.GOOGLE_PAY) || n.includes(u.a.paymentMethods.INSTALLMENTS) || n.includes(u.a.paymentMethods.MASTERPASS)) {
            if (!t.callbacks.createPaymentRequest) return new o.p.MissingCallbackError("createPaymentRequest");
            if ("function" != typeof t.callbacks.createPaymentRequest) return new o.p.InvalidCallbackError("createPaymentRequest");
            if (!t.callbacks.methodsSupported) return new o.p.MissingCallbackError("methodsSupported");
            if ("function" != typeof t.callbacks.methodsSupported) return new o.p.InvalidCallbackError("methodsSupported")
        }
    }, Nt.prototype.validateInputType = function(t, e) {
        if (t !== u.a.inputTypes.POSTAL_CODE || !1 !== e[t]) return e[t] ? e[t].elementId ? void 0 : new o.p.MissingElementIdError(t) : new o.p.MissingInputTypeError(t)
    }, Nt.prototype._detectKeyedCardInputs = function(t) {
        var e = u.a.inputTypes,
            n = [];
        return t[e.CARD_NUMBER] && n.push(e.CARD_NUMBER), t[e.CVV] && n.push(e.CVV), t[e.EXPIRATION_DATE] && n.push(e.EXPIRATION_DATE), t[e.POSTAL_CODE] && n.push(e.POSTAL_CODE), n
    }, Nt.prototype._detectPaymentMethods = function(t) {
        var e = u.a.paymentMethods,
            n = u.a.inputTypes,
            i = this._detectKeyedCardInputs(t),
            r = [];
        return t[n.SINGLE_CARD_ELEMENT] && r.push(e.SINGLE_CARD_ELEMENT), i.length && r.push(e.KEYED_CARD), t[n.GIFT_CARD] && r.push(e.GIFT_CARD), t[e.APPLE_PAY] && r.push(e.APPLE_PAY), t[e.GOOGLE_PAY] && r.push(e.GOOGLE_PAY), t[e.INSTALLMENTS] && r.push(e.INSTALLMENTS), t[e.MASTERPASS] && r.push(e.MASTERPASS), r
    };
    var kt = function(t, e) {
            if (Rt(t)) return !0;
            var n = Lt(t, e);
            return window.console.error(n), !1
        },
        Mt = function(t, e) {
            if (!Rt(t)) throw Lt(t, e)
        },
        Dt = function(t) {
            return {
                g: {
                    a: "PAYMENTFORM_INIT:ERROR",
                    d: "[".concat(t.name, "] ").concat(t.message)
                }
            }
        },
        xt = function() {
            return {
                g: {
                    a: "PAYMENTFORM_INIT:OK"
                }
            }
        },
        Ft = function() {
            return {
                g: {
                    a: "PAYMENTFORM_INIT:START"
                }
            }
        },
        qt = function(t) {
            return !1 !== t && (t = !0), {
                g: {
                    a: "PAYMENTFORM_BUILD:OK",
                    e: "autoBuild=".concat(t)
                }
            }
        },
        Vt = Nt;
    window.SqPaymentForm = Vt
}]);